
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea1a5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea1a5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gLqu3", function(module, exports) {

$parcel$export(module.exports, "createShape", () => $c3459442b74b7632$export$9e714c514dac39ee);
$parcel$export(module.exports, "updateTextBackground", () => $c3459442b74b7632$export$3337e5ae8cc3687e);
$parcel$export(module.exports, "getShapeBounds", () => $c3459442b74b7632$export$738eb5d336c2d26c);
/**
 * Shape creation and management utilities
 */ 
var $b8j1A = parcelRequire("b8j1A");

var $lwME4 = parcelRequire("lwME4");

var $89InF = parcelRequire("89InF");
function $c3459442b74b7632$export$9e714c514dac39ee(shapeType, x, y, isCisco = false) {
    // Check if it's a Cisco shape
    if (isCisco || (0, $b8j1A.CISCO_SHAPES)[shapeType]) return $c3459442b74b7632$var$createCiscoShape(shapeType, x, y);
    // Handle line and arrow shapes separately
    if (shapeType === 'line') return $c3459442b74b7632$var$createLineShape(x, y);
    if (shapeType === 'arrow') return $c3459442b74b7632$var$createArrowShape(x, y);
    if (shapeType === 'text') return $c3459442b74b7632$var$createTextShape(x, y);
    const template = (0, $b8j1A.SHAPE_TEMPLATES)[shapeType];
    if (!template) return null;
    const shape = document.createElementNS('http://www.w3.org/2000/svg', template.element);
    const shapeId = (0, $lwME4.appState).getNextShapeId();
    // Set basic attributes
    shape.setAttribute('id', shapeId);
    shape.setAttribute('class', 'canvas-shape');
    shape.setAttribute('data-shape-type', shapeType);
    // Set position based on shape type
    if (template.element === 'circle') {
        shape.setAttribute('cx', x);
        shape.setAttribute('cy', y);
    } else if (template.element === 'ellipse') {
        shape.setAttribute('cx', x);
        shape.setAttribute('cy', y);
    } else if (template.element === 'rect') {
        shape.setAttribute('x', x - template.attributes.width / 2);
        shape.setAttribute('y', y - template.attributes.height / 2);
    }
    // Set template attributes
    Object.entries(template.attributes).forEach(([attr, value])=>{
        shape.setAttribute(attr, value);
    });
    // Add event listeners for selection and dragging
    (0, $89InF.addShapeEventListeners)(shape);
    return shape;
}
/**
 * Create a Cisco network device shape
 * @param {string} shapeType - Type of Cisco shape
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @returns {SVGElement} The created shape group
 */ function $c3459442b74b7632$var$createCiscoShape(shapeType, x, y) {
    const ciscoTemplate = (0, $b8j1A.CISCO_SHAPES)[shapeType];
    if (!ciscoTemplate) return null;
    const shapeId = (0, $lwME4.appState).getNextShapeId();
    // Parse viewBox to get original dimensions
    const viewBoxParts = ciscoTemplate.viewBox.split(' ').map(Number);
    const [vbX, vbY, vbWidth, vbHeight] = viewBoxParts;
    // Scale to fit within 60x60 while maintaining aspect ratio
    const targetSize = 60;
    const scale = Math.min(targetSize / vbWidth, targetSize / vbHeight);
    const scaledWidth = vbWidth * scale;
    const scaledHeight = vbHeight * scale;
    // Create a group element to hold the shape
    const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    group.setAttribute('id', shapeId);
    group.setAttribute('class', 'canvas-shape cisco-shape');
    group.setAttribute('data-shape-type', shapeType);
    group.setAttribute('data-cisco', 'true');
    group.setAttribute('transform', `translate(${x - scaledWidth / 2}, ${y - scaledHeight / 2})`);
    // Create an SVG element to properly handle viewBox
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', scaledWidth);
    svg.setAttribute('height', scaledHeight);
    svg.setAttribute('viewBox', ciscoTemplate.viewBox);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    // Add a white background rectangle for visibility
    const bgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    bgRect.setAttribute('x', vbX);
    bgRect.setAttribute('y', vbY);
    bgRect.setAttribute('width', vbWidth);
    bgRect.setAttribute('height', vbHeight);
    bgRect.setAttribute('fill', '#ffffff');
    bgRect.setAttribute('rx', '3');
    svg.appendChild(bgRect);
    // Create the shape path with proper fill
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', ciscoTemplate.svgPath);
    path.setAttribute('fill', ciscoTemplate.attributes.fill);
    path.setAttribute('stroke', ciscoTemplate.attributes.stroke || 'none');
    svg.appendChild(path);
    group.appendChild(svg);
    // Add label text below the shape
    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.setAttribute('x', scaledWidth / 2);
    text.setAttribute('y', scaledHeight + 12);
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('fill', '#333');
    text.setAttribute('font-size', '10');
    text.setAttribute('font-weight', 'bold');
    text.textContent = ciscoTemplate.label;
    group.appendChild(text);
    // Add event listeners
    (0, $89InF.addShapeEventListeners)(group);
    return group;
}
/**
 * Create a line shape
 * @param {number} x - X coordinate (start point)
 * @param {number} y - Y coordinate (start point)
 * @returns {SVGElement} The created line element
 */ function $c3459442b74b7632$var$createLineShape(x, y) {
    const shapeId = (0, $lwME4.appState).getNextShapeId();
    const template = (0, $b8j1A.SHAPE_TEMPLATES).line;
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('id', shapeId);
    line.setAttribute('class', 'canvas-shape');
    line.setAttribute('data-shape-type', 'line');
    // Position the line centered at the drop point
    line.setAttribute('x1', x - 50);
    line.setAttribute('y1', y);
    line.setAttribute('x2', x + 50);
    line.setAttribute('y2', y);
    // Set template attributes
    Object.entries(template.attributes).forEach(([attr, value])=>{
        if (![
            'x1',
            'y1',
            'x2',
            'y2'
        ].includes(attr)) line.setAttribute(attr, value);
    });
    // Add event listeners
    (0, $89InF.addShapeEventListeners)(line);
    return line;
}
/**
 * Create an arrow shape (line with arrowhead)
 * @param {number} x - X coordinate (start point)
 * @param {number} y - Y coordinate (start point)
 * @returns {SVGElement} The created arrow group
 */ function $c3459442b74b7632$var$createArrowShape(x, y) {
    const shapeId = (0, $lwME4.appState).getNextShapeId();
    const template = (0, $b8j1A.SHAPE_TEMPLATES).arrow;
    // Create a group to hold the line and arrowhead
    const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    group.setAttribute('id', shapeId);
    group.setAttribute('class', 'canvas-shape');
    group.setAttribute('data-shape-type', 'arrow');
    // Create the line part
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', x - 50);
    line.setAttribute('y1', y);
    line.setAttribute('x2', x + 50);
    line.setAttribute('y2', y);
    line.setAttribute('stroke', template.attributes.stroke);
    line.setAttribute('stroke-width', template.attributes['stroke-width']);
    line.setAttribute('class', 'arrow-line');
    group.appendChild(line);
    // Create the arrowhead as a polygon
    const arrowhead = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    const headSize = 10;
    const arrowX = x + 50;
    const arrowY = y;
    arrowhead.setAttribute('points', `${arrowX},${arrowY} ${arrowX - headSize},${arrowY - headSize / 2} ${arrowX - headSize},${arrowY + headSize / 2}`);
    arrowhead.setAttribute('fill', template.attributes.fill);
    arrowhead.setAttribute('class', 'arrow-head');
    group.appendChild(arrowhead);
    // Add a circle at the start point
    const startCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    startCircle.setAttribute('cx', x - 50);
    startCircle.setAttribute('cy', y);
    startCircle.setAttribute('r', 4);
    startCircle.setAttribute('fill', template.attributes.fill);
    startCircle.setAttribute('class', 'arrow-start');
    group.appendChild(startCircle);
    // Add event listeners
    (0, $89InF.addShapeEventListeners)(group);
    return group;
}
/**
 * Create a text shape
 * @param {number} x - X coordinate (center)
 * @param {number} y - Y coordinate (center)
 * @returns {SVGElement} The created text group element
 */ function $c3459442b74b7632$var$createTextShape(x, y) {
    const shapeId = (0, $lwME4.appState).getNextShapeId();
    const template = (0, $b8j1A.SHAPE_TEMPLATES).text;
    // Create a group to hold the text and optional background
    const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    group.setAttribute('id', shapeId);
    group.setAttribute('class', 'canvas-shape text-shape');
    group.setAttribute('data-shape-type', 'text');
    group.setAttribute('transform', `translate(${x}, ${y})`);
    // Create background rectangle (optional, can be transparent)
    const bgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    bgRect.setAttribute('class', 'text-background');
    bgRect.setAttribute('x', 0);
    bgRect.setAttribute('y', 0);
    bgRect.setAttribute('width', 100);
    bgRect.setAttribute('height', 30);
    bgRect.setAttribute('fill', 'transparent');
    bgRect.setAttribute('stroke', 'none');
    bgRect.setAttribute('stroke-width', 0);
    bgRect.setAttribute('rx', 4);
    group.appendChild(bgRect);
    // Create the text element
    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.setAttribute('class', 'text-content');
    text.setAttribute('x', 50);
    text.setAttribute('y', 20);
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('dominant-baseline', 'middle');
    text.textContent = template.defaultText;
    // Set template attributes
    Object.entries(template.attributes).forEach(([attr, value])=>{
        text.setAttribute(attr, value);
    });
    group.appendChild(text);
    // Update background size to fit text
    $c3459442b74b7632$export$3337e5ae8cc3687e(group);
    // Add event listeners
    (0, $89InF.addShapeEventListeners)(group);
    return group;
}
function $c3459442b74b7632$export$3337e5ae8cc3687e(textGroup) {
    const textEl = textGroup.querySelector('.text-content');
    const bgRect = textGroup.querySelector('.text-background');
    if (!textEl || !bgRect) return;
    try {
        const bbox = textEl.getBBox();
        const padding = 8;
        bgRect.setAttribute('x', bbox.x - padding);
        bgRect.setAttribute('y', bbox.y - padding);
        bgRect.setAttribute('width', bbox.width + padding * 2);
        bgRect.setAttribute('height', bbox.height + padding * 2);
    } catch (e) {
        // Fallback if getBBox fails
        console.warn('Could not get text bounding box:', e);
    }
}
function $c3459442b74b7632$export$738eb5d336c2d26c(shape) {
    const shapeType = shape.tagName;
    // Handle group elements (Cisco shapes and arrows)
    if (shapeType === 'g') {
        const dataType = shape.getAttribute('data-shape-type');
        // Handle text shapes
        if (dataType === 'text') {
            const transform = shape.getAttribute('transform');
            let tx = 0, ty = 0;
            if (transform) {
                const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
                if (match) {
                    tx = parseFloat(match[1]);
                    ty = parseFloat(match[2]);
                }
            }
            const bgRect = shape.querySelector('.text-background');
            if (bgRect) {
                const x = parseFloat(bgRect.getAttribute('x'));
                const y = parseFloat(bgRect.getAttribute('y'));
                const width = parseFloat(bgRect.getAttribute('width'));
                const height = parseFloat(bgRect.getAttribute('height'));
                return {
                    x: tx + x,
                    y: ty + y,
                    width: width,
                    height: height,
                    left: tx + x,
                    right: tx + x + width,
                    top: ty + y,
                    bottom: ty + y + height,
                    centerX: tx + x + width / 2,
                    centerY: ty + y + height / 2
                };
            }
        }
        // Handle arrow shapes
        if (dataType === 'arrow') {
            const line = shape.querySelector('.arrow-line');
            if (line) {
                const x1 = parseFloat(line.getAttribute('x1'));
                const y1 = parseFloat(line.getAttribute('y1'));
                const x2 = parseFloat(line.getAttribute('x2'));
                const y2 = parseFloat(line.getAttribute('y2'));
                const minX = Math.min(x1, x2);
                const maxX = Math.max(x1, x2);
                const minY = Math.min(y1, y2);
                const maxY = Math.max(y1, y2);
                // Add padding for arrowhead
                const padding = 10;
                return {
                    x: minX - padding,
                    y: minY - padding,
                    width: maxX - minX + padding * 2,
                    height: maxY - minY + padding * 2,
                    left: minX - padding,
                    right: maxX + padding,
                    top: minY - padding,
                    bottom: maxY + padding,
                    centerX: (minX + maxX) / 2,
                    centerY: (minY + maxY) / 2
                };
            }
        }
        // Handle Cisco shapes
        const transform = shape.getAttribute('transform');
        let tx = 0, ty = 0;
        // Parse translate transform
        if (transform) {
            const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
            if (match) {
                tx = parseFloat(match[1]);
                ty = parseFloat(match[2]);
            }
        }
        // Get dimensions from the SVG element (which has width/height attributes)
        const svg = shape.querySelector('svg');
        let width = 60; // Default
        let height = 70; // Default including label
        if (svg) {
            // Use the SVG element's width and height attributes
            // These represent the actual rendered size after viewBox scaling
            width = parseFloat(svg.getAttribute('width')) || 60;
            height = parseFloat(svg.getAttribute('height')) || 60;
            // Add space for label
            height += 10;
        }
        // The transform translate already positions the top-left corner correctly
        // No need to adjust based on getBBox() offset
        return {
            x: tx,
            y: ty,
            width: width,
            height: height,
            left: tx,
            right: tx + width,
            top: ty,
            bottom: ty + height,
            centerX: tx + width / 2,
            centerY: ty + height / 2
        };
    }
    switch(shapeType){
        case 'line':
            const x1 = parseFloat(shape.getAttribute('x1'));
            const y1 = parseFloat(shape.getAttribute('y1'));
            const x2 = parseFloat(shape.getAttribute('x2'));
            const y2 = parseFloat(shape.getAttribute('y2'));
            const minX = Math.min(x1, x2);
            const maxX = Math.max(x1, x2);
            const minY = Math.min(y1, y2);
            const maxY = Math.max(y1, y2);
            // Add some padding for easier selection
            const padding = 5;
            return {
                x: minX - padding,
                y: minY - padding,
                width: maxX - minX + padding * 2,
                height: maxY - minY + padding * 2,
                left: minX - padding,
                right: maxX + padding,
                top: minY - padding,
                bottom: maxY + padding,
                centerX: (x1 + x2) / 2,
                centerY: (y1 + y2) / 2
            };
        case 'circle':
            const cx = parseFloat(shape.getAttribute('cx'));
            const cy = parseFloat(shape.getAttribute('cy'));
            const r = parseFloat(shape.getAttribute('r'));
            return {
                x: cx - r,
                y: cy - r,
                width: r * 2,
                height: r * 2,
                left: cx - r,
                right: cx + r,
                top: cy - r,
                bottom: cy + r,
                centerX: cx,
                centerY: cy
            };
        case 'ellipse':
            const ecx = parseFloat(shape.getAttribute('cx'));
            const ecy = parseFloat(shape.getAttribute('cy'));
            const rx = parseFloat(shape.getAttribute('rx'));
            const ry = parseFloat(shape.getAttribute('ry'));
            return {
                x: ecx - rx,
                y: ecy - ry,
                width: rx * 2,
                height: ry * 2,
                left: ecx - rx,
                right: ecx + rx,
                top: ecy - ry,
                bottom: ecy + ry,
                centerX: ecx,
                centerY: ecy
            };
        case 'rect':
            const x = parseFloat(shape.getAttribute('x'));
            const y = parseFloat(shape.getAttribute('y'));
            const width = parseFloat(shape.getAttribute('width'));
            const height = parseFloat(shape.getAttribute('height'));
            return {
                x: x,
                y: y,
                width: width,
                height: height,
                left: x,
                right: x + width,
                top: y,
                bottom: y + height,
                centerX: x + width / 2,
                centerY: y + height / 2
            };
    }
    return null;
}

});
parcelRegister("b8j1A", function(module, exports) {

$parcel$export(module.exports, "API_BASE_URL", () => $81af32f25f2290bc$export$c3ee1e672e1e24e7);
$parcel$export(module.exports, "SHAPE_TEMPLATES", () => $81af32f25f2290bc$export$7142099b3b7ad9b9);
$parcel$export(module.exports, "CISCO_SHAPES", () => $81af32f25f2290bc$export$31e93130d0c4f0dc);
$parcel$export(module.exports, "ZOOM_CONFIG", () => $81af32f25f2290bc$export$629d511489d383bc);
$parcel$export(module.exports, "CANVAS_CONFIG", () => $81af32f25f2290bc$export$3fea9e4a2e457811);
$parcel$export(module.exports, "MIN_SHAPE_SIZE", () => $81af32f25f2290bc$export$d9b34691fa373df4);
/**
 * Application configuration and constants
 */ const $81af32f25f2290bc$export$c3ee1e672e1e24e7 = 'http://localhost:8000';
const $81af32f25f2290bc$export$7142099b3b7ad9b9 = {
    circle: {
        element: 'circle',
        attributes: {
            r: 30,
            fill: '#e3f2fd',
            stroke: '#1976d2',
            'stroke-width': 2
        }
    },
    oval: {
        element: 'ellipse',
        attributes: {
            rx: 40,
            ry: 25,
            fill: '#f3e5f5',
            stroke: '#7b1fa2',
            'stroke-width': 2
        }
    },
    rectangle: {
        element: 'rect',
        attributes: {
            width: 80,
            height: 50,
            rx: 5,
            fill: '#e8f5e8',
            stroke: '#388e3c',
            'stroke-width': 2
        }
    },
    square: {
        element: 'rect',
        attributes: {
            width: 60,
            height: 60,
            rx: 5,
            fill: '#fff3e0',
            stroke: '#f57c00',
            'stroke-width': 2
        }
    },
    line: {
        element: 'line',
        attributes: {
            x1: 0,
            y1: 0,
            x2: 100,
            y2: 0,
            stroke: '#495057',
            'stroke-width': 2
        }
    },
    arrow: {
        element: 'g',
        attributes: {
            stroke: '#495057',
            'stroke-width': 2,
            fill: '#495057'
        }
    },
    text: {
        element: 'text',
        attributes: {
            'font-size': 24,
            'font-family': 'Arial, sans-serif',
            'font-weight': 'normal',
            'font-style': 'normal',
            'text-decoration': 'none',
            fill: '#333333',
            stroke: 'none',
            'stroke-width': 0
        },
        defaultText: 'Text'
    }
};
const $81af32f25f2290bc$export$31e93130d0c4f0dc = {
    l2switch: {
        element: 'g',
        label: 'L2 Switch',
        viewBox: '0 0 50 50',
        svgPath: 'M 23.38 40.52 L 23.38 36.53 L 12.78 36.53 L 12.78 33.39 L 3.75 38.71 L 12.78 43.96 L 12.78 40.52 Z M 28.32 21.46 L 28.32 17.48 L 17.73 17.48 L 17.73 14.33 L 8.7 19.66 L 17.73 24.9 L 17.73 21.46 Z M 22.38 31.06 L 22.38 27.08 L 32.98 27.08 L 32.98 23.93 L 42 29.26 L 32.98 34.51 L 32.98 31.06 Z M 26.96 12.32 L 26.96 8.34 L 37.55 8.34 L 37.55 5.2 L 46.58 10.52 L 37.55 15.77 L 37.55 12.32 Z M 3.07 0 C 1.38 0 0 1.37 0 3.05 L 0 46.95 C 0 48.63 1.38 50 3.07 50 L 46.93 50 C 48.62 50 50 48.63 50 46.95 L 50 3.05 C 50 1.37 48.62 0 46.93 0 Z M 3.07 1.38 L 46.93 1.38 C 47.88 1.38 48.62 2.11 48.62 3.05 L 48.62 46.95 C 48.62 47.89 47.88 48.62 46.93 48.62 L 3.07 48.62 C 2.12 48.62 1.38 47.89 1.38 46.95 L 1.38 3.05 C 1.38 2.11 2.12 1.38 3.07 1.38 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    l3switch: {
        element: 'g',
        label: 'L3 Switch',
        viewBox: '0 0 50 50',
        svgPath: 'M 25.03 4.6 L 20.84 10.59 L 23.62 10.59 L 23.62 16.96 C 22.4 17.17 21.24 17.65 20.23 18.38 L 15.69 13.89 L 17.65 11.92 L 10.46 10.61 L 11.79 17.8 L 13.75 15.83 L 18.29 20.33 C 17.6 21.31 17.13 22.44 16.93 23.62 L 10.53 23.62 L 10.53 20.86 L 4.5 24.97 L 10.53 29.14 L 10.53 26.37 L 16.92 26.37 C 17.13 27.57 17.6 28.7 18.31 29.69 L 13.78 34.2 L 11.81 32.25 L 10.51 39.44 L 17.7 38.1 L 15.73 36.15 L 20.25 31.64 C 21.26 32.35 22.41 32.83 23.62 33.03 L 23.62 39.41 L 20.84 39.41 L 25.03 45.4 L 29.16 39.41 L 26.38 39.41 L 26.38 33.04 C 27.59 32.83 28.73 32.36 29.73 31.65 L 34.27 36.15 L 32.31 38.11 L 39.54 39.39 L 38.18 32.24 L 36.22 34.2 L 31.68 29.71 C 32.39 28.72 32.87 27.57 33.07 26.37 L 39.47 26.37 L 39.47 29.14 L 45.5 24.97 L 39.47 20.86 L 39.47 23.62 L 33.08 23.62 C 32.87 22.41 32.38 21.27 31.66 20.27 L 36.19 15.76 L 38.15 17.72 L 39.49 10.56 L 32.27 11.86 L 34.23 13.82 L 29.71 18.33 C 28.72 17.63 27.58 17.17 26.38 16.97 L 26.38 10.59 L 29.16 10.59 Z M 3.07 0 C 1.38 0 0 1.37 0 3.05 L 0 46.95 C 0 48.63 1.38 50 3.07 50 L 46.93 50 C 48.62 50 50 48.63 50 46.95 L 50 3.05 C 50 1.37 48.62 0 46.93 0 Z M 3.07 1.38 L 46.93 1.38 C 47.88 1.38 48.62 2.11 48.62 3.05 L 48.62 46.95 C 48.62 47.89 47.88 48.62 46.93 48.62 L 3.07 48.62 C 2.12 48.62 1.39 47.89 1.39 46.95 L 1.39 3.05 C 1.39 2.11 2.12 1.38 3.07 1.38 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    accesspoint: {
        element: 'g',
        label: 'Access Point',
        viewBox: '0 0 51 51',
        svgPath: 'M 7.78 0 L 7.78 3.25 L 8.24 3.25 L 8.24 8.01 L 8.11 8.01 C 7.43 8.01 6.87 8.58 6.87 9.28 L 6.87 17.01 L 4.22 17.01 C 1.89 17.01 0 18.95 0 21.34 L 0 45.67 C 0 48.06 1.89 50 4.22 50 L 45.78 50 C 48.11 50 50 48.06 50 45.67 L 50 21.34 C 50 18.95 48.11 17.01 45.78 17.01 L 42.92 17.01 L 42.92 9.28 C 42.92 8.58 42.37 8.01 41.68 8.01 L 41.55 8.01 L 41.55 3.25 L 42.01 3.25 L 42.01 0 L 39.69 0 L 39.69 3.25 L 40.15 3.25 L 40.15 8.01 L 40.02 8.01 C 39.33 8.01 38.78 8.58 38.78 9.28 L 38.78 17.01 L 11.01 17.01 L 11.01 9.28 C 11.01 8.58 10.46 8.01 9.78 8.01 L 9.64 8.01 L 9.64 3.25 L 10.11 3.25 L 10.11 0 Z M 4.22 18.32 L 45.78 18.32 C 47.42 18.32 48.72 19.66 48.72 21.34 L 48.72 45.67 C 48.72 47.36 47.42 48.69 45.78 48.69 L 4.22 48.69 C 2.58 48.69 1.28 47.36 1.28 45.67 L 1.28 21.34 C 1.28 19.66 2.58 18.32 4.22 18.32 Z M 12 33.98 C 11.08 33.98 10.35 34.53 9.84 35.14 C 9.58 35.44 9.36 35.78 9.17 36.11 C 9.04 35.88 8.89 35.66 8.73 35.46 C 8.27 34.88 7.65 34.4 6.85 34.4 C 6.04 34.4 5.32 34.91 4.78 35.51 C 4.27 36.09 3.9 36.75 3.87 37.41 L 3.46 37.41 C 3.46 38.28 3.89 39.02 4.48 39.67 C 5.07 40.33 5.86 40.92 6.85 40.92 C 7.81 40.92 8.55 40.33 9.05 39.7 C 9.28 39.41 9.48 39.1 9.65 38.79 C 9.8 39.03 9.97 39.27 10.15 39.49 C 10.62 40.04 11.23 40.5 12 40.5 C 12.78 40.5 13.38 40.01 13.83 39.45 C 14.03 39.2 14.21 38.93 14.37 38.66 C 14.6 39 14.85 39.36 15.13 39.69 C 15.64 40.29 16.23 40.92 17.15 40.92 C 17.97 40.92 18.59 40.42 19.1 39.85 C 19.4 39.51 19.67 39.12 19.93 38.71 C 20.12 39.03 20.32 39.33 20.55 39.6 C 20.99 40.12 21.57 40.5 22.3 40.5 C 23.06 40.5 23.65 40.02 24.1 39.47 C 24.3 39.22 24.48 38.94 24.65 38.66 C 24.85 39 25.07 39.35 25.32 39.69 C 25.8 40.3 26.51 40.92 27.45 40.92 C 28.37 40.92 29.08 40.35 29.56 39.75 C 29.82 39.42 30.04 39.06 30.24 38.7 C 30.41 38.99 30.59 39.27 30.79 39.53 C 31.22 40.07 31.82 40.5 32.6 40.5 C 33.39 40.5 33.99 40.05 34.42 39.51 C 34.62 39.25 34.8 38.97 34.96 38.69 C 35.17 39.04 35.39 39.4 35.65 39.73 C 36.12 40.34 36.83 40.92 37.75 40.92 C 38.67 40.92 39.39 40.36 39.88 39.74 C 40.14 39.42 40.35 39.08 40.55 38.74 C 40.68 38.98 40.83 39.22 40.99 39.45 C 41.41 40.02 42.03 40.5 42.9 40.5 C 43.82 40.5 44.56 39.93 45.07 39.29 C 45.57 38.66 45.89 37.99 45.89 37.41 L 46.3 37.41 C 46.3 35.65 44.89 33.98 42.9 33.98 C 41.9 33.98 41.1 34.51 40.64 35.13 C 40.39 35.47 40.2 35.83 40.02 36.17 C 39.88 35.93 39.73 35.7 39.56 35.48 C 39.12 34.91 38.53 34.4 37.75 34.4 C 36.99 34.4 36.4 34.87 35.97 35.43 C 35.78 35.67 35.61 35.94 35.44 36.21 C 35.24 35.85 35.01 35.47 34.74 35.12 C 34.27 34.53 33.53 33.98 32.6 33.98 C 31.68 33.98 30.95 34.51 30.47 35.11 C 30.2 35.45 29.97 35.83 29.76 36.2 C 29.6 35.92 29.43 35.66 29.24 35.41 C 28.8 34.86 28.22 34.4 27.45 34.4 C 26.67 34.4 26.09 34.9 25.65 35.47 C 25.46 35.71 25.29 35.97 25.14 36.23 C 24.93 35.88 24.69 35.5 24.41 35.16 C 23.93 34.56 23.23 33.98 22.3 33.98 C 21.45 33.98 20.72 34.45 20.24 35.02 C 19.93 35.38 19.68 35.78 19.45 36.2 C 19.24 35.88 19.02 35.59 18.8 35.33 C 18.33 34.8 17.79 34.4 17.15 34.4 C 16.46 34.4 15.92 34.91 15.44 35.48 C 15.24 35.72 15.04 35.99 14.86 36.25 C 14.66 35.9 14.43 35.53 14.15 35.18 C 13.66 34.58 12.94 33.98 12 33.98 Z M 6.85 35.24 C 7.33 35.24 7.72 35.52 8.09 35.99 C 8.32 36.28 8.53 36.63 8.72 36.98 C 8.71 37 8.7 37.02 8.69 37.04 C 8.42 37.61 8.11 38.22 7.77 38.64 C 7.44 39.06 7.17 39.24 6.85 39.24 C 6.57 39.24 6.07 38.97 5.69 38.54 C 5.31 38.11 5.1 37.51 5.1 37.41 L 4.69 37.41 C 4.73 37.09 4.99 36.52 5.39 36.07 C 5.82 35.59 6.39 35.24 6.85 35.24 Z M 17.15 35.24 C 17.43 35.24 17.79 35.45 18.19 35.9 C 18.46 36.2 18.73 36.59 18.99 37.03 C 18.63 37.71 18.24 38.32 17.89 38.72 C 17.53 39.12 17.25 39.24 17.15 39.24 C 17.16 39.24 16.76 39.05 16.37 38.59 C 16 38.15 15.62 37.55 15.33 37.05 C 15.55 36.7 15.8 36.34 16.06 36.03 C 16.48 35.53 16.93 35.24 17.15 35.24 Z M 27.45 35.24 C 27.91 35.24 28.24 35.48 28.6 35.94 C 28.83 36.24 29.06 36.62 29.29 37.03 C 28.92 37.68 28.59 38.3 28.28 38.69 C 27.96 39.1 27.76 39.24 27.45 39.24 C 27.18 39.24 26.95 39.08 26.61 38.64 C 26.29 38.23 25.97 37.63 25.62 37.04 C 25.84 36.66 26.06 36.29 26.29 35.99 C 26.66 35.51 27.01 35.24 27.45 35.24 Z M 37.75 35.24 C 38.19 35.24 38.54 35.52 38.91 36 C 39.14 36.3 39.36 36.67 39.59 37.05 C 39.25 37.67 38.93 38.28 38.61 38.68 C 38.29 39.09 38.05 39.24 37.75 39.24 C 37.46 39.24 37.25 39.1 36.93 38.68 C 36.62 38.28 36.29 37.67 35.92 37.04 C 36.15 36.64 36.37 36.25 36.61 35.96 C 36.97 35.49 37.3 35.24 37.75 35.24 Z M 12 35.66 C 12.28 35.66 12.54 35.83 12.88 36.25 C 13.22 36.67 13.55 37.28 13.87 37.84 C 13.88 37.85 13.88 37.86 13.89 37.86 C 13.67 38.23 13.44 38.61 13.2 38.91 C 12.82 39.38 12.44 39.66 12 39.66 C 11.55 39.66 11.15 39.39 10.77 38.94 C 10.53 38.64 10.3 38.28 10.1 37.91 C 10.12 37.87 10.14 37.82 10.16 37.78 C 10.43 37.23 10.75 36.64 11.08 36.23 C 11.42 35.83 11.71 35.66 12 35.66 Z M 22.3 35.66 C 22.58 35.66 22.81 35.81 23.15 36.23 C 23.48 36.64 23.81 37.25 24.18 37.85 C 23.94 38.25 23.71 38.63 23.46 38.94 C 23.09 39.4 22.74 39.66 22.3 39.66 C 21.83 39.66 21.51 39.46 21.16 39.05 C 20.91 38.75 20.67 38.35 20.41 37.88 C 20.42 37.86 20.43 37.84 20.44 37.82 C 20.83 37.09 21.17 36.49 21.47 36.13 C 21.78 35.77 21.96 35.66 22.3 35.66 Z M 32.6 35.66 C 32.97 35.66 33.16 35.79 33.46 36.18 C 33.77 36.57 34.09 37.19 34.48 37.85 C 34.48 37.85 34.48 37.86 34.49 37.86 C 34.24 38.28 34.02 38.68 33.78 38.98 C 33.43 39.42 33.11 39.66 32.6 39.66 C 32.09 39.66 31.77 39.43 31.42 38.99 C 31.19 38.69 30.96 38.3 30.72 37.87 C 30.72 37.86 30.73 37.85 30.73 37.84 C 31.12 37.17 31.44 36.55 31.74 36.17 C 32.04 35.79 32.22 35.66 32.6 35.66 Z M 42.9 35.66 C 44 35.66 44.66 36.57 44.66 37.41 L 45.07 37.41 C 45.07 37.58 44.84 38.25 44.43 38.76 C 44.02 39.27 43.48 39.66 42.9 39.66 C 42.29 39.66 41.98 39.4 41.65 38.95 C 41.43 38.65 41.24 38.26 41.02 37.86 C 41.03 37.85 41.04 37.83 41.05 37.81 C 41.41 37.13 41.67 36.52 41.94 36.16 C 42.21 35.8 42.36 35.66 42.9 35.66 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    firewall: {
        element: 'g',
        label: 'Firewall',
        viewBox: '0 0 64 50',
        svgPath: 'M 2.9 3.16 L 2.9 5.45 L 19.82 5.45 L 19.82 11.4 L 2.9 11.4 L 2.9 13.7 L 8.49 13.7 L 8.49 19.65 L 2.9 19.65 L 2.9 21.95 L 19.82 21.95 L 19.82 27.9 L 2.9 27.9 L 2.9 30.2 L 8.49 30.2 L 8.49 36.15 L 2.9 36.15 L 2.9 38.45 L 19.82 38.45 L 19.82 44.4 L 2.9 44.4 L 2.9 46.7 L 61.29 46.7 L 61.29 44.4 L 44.75 44.4 L 44.75 38.45 L 61.29 38.45 L 61.29 36.15 L 56.08 36.15 L 56.08 30.2 L 61.29 30.2 L 61.29 27.9 L 44.75 27.9 L 44.75 21.95 L 61.29 21.95 L 61.29 19.65 L 56.08 19.65 L 56.08 13.7 L 61.29 13.7 L 61.29 11.4 L 44.75 11.4 L 44.75 5.45 L 61.29 5.45 L 61.29 3.16 Z M 22.09 5.45 L 42.48 5.45 L 42.48 11.4 L 22.09 11.4 Z M 10.76 13.7 L 31.15 13.7 L 31.15 19.65 L 10.76 19.65 Z M 33.42 13.7 L 53.81 13.7 L 53.81 19.65 L 33.42 19.65 Z M 22.09 21.95 L 42.48 21.95 L 42.48 27.9 L 22.09 27.9 Z M 10.76 30.2 L 31.15 30.2 L 31.15 36.15 L 10.76 36.15 Z M 33.42 30.2 L 53.81 30.2 L 53.81 36.15 L 33.42 36.15 Z M 22.09 38.45 L 42.48 38.45 L 42.48 44.4 L 22.09 44.4 Z M 3.02 0 C 1.36 0 0 1.37 0 3.05 L 0 46.95 C 0 48.63 1.36 50 3.02 50 L 60.98 50 C 62.64 50 64 48.63 64 46.95 L 64 3.05 C 64 1.37 62.64 0 60.98 0 Z M 3.02 1.38 L 60.98 1.38 C 61.91 1.38 62.64 2.11 62.64 3.05 L 62.64 46.95 C 62.64 47.89 61.91 48.62 60.98 48.62 L 3.02 48.62 C 2.09 48.62 1.36 47.89 1.36 46.95 L 1.36 3.05 C 1.36 2.11 2.09 1.38 3.02 1.38 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    router: {
        element: 'g',
        label: 'Router',
        viewBox: '0 0 50 50',
        svgPath: 'M 38.08 40.38 L 31.77 34.19 L 29.2 36.81 L 27.24 27.37 L 36.75 29.12 L 34.2 31.72 L 40.51 37.9 Z M 23.92 28.37 L 17.74 34.68 L 20.36 37.25 L 10.92 39.21 L 12.67 29.71 L 15.26 32.25 L 21.45 25.95 Z M 12.02 9.57 L 18.33 15.76 L 20.89 13.14 L 22.86 22.58 L 13.35 20.83 L 15.9 18.24 L 9.59 12.05 Z M 25.91 21.51 L 32.1 15.2 L 29.48 12.63 L 38.92 10.67 L 37.17 20.17 L 34.58 17.62 L 28.39 23.94 Z M 25 0 C 11.2 0 0 11.2 0 25 C 0 38.8 11.2 50 25 50 C 38.8 50 50 38.8 50 25 C 50 11.2 38.8 0 25 0 Z M 25 0.63 C 38.46 0.63 49.37 11.54 49.37 25 C 49.37 38.46 38.46 49.37 25 49.37 C 11.54 49.37 0.63 38.46 0.63 25 C 0.63 11.54 11.54 0.63 25 0.63 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    workstation: {
        element: 'g',
        label: 'Workstation',
        viewBox: '0 0 50 35',
        svgPath: 'M 7.49 25.73 L 7.96 25.73 L 42.06 25.73 L 42.57 25.73 C 42.78 25.73 43.3 26.01 43.71 26.33 L 49.32 31.75 L 49.32 33.04 C 49.32 33.66 48.68 34.3 47.88 34.3 L 2.16 34.3 C 1.8 34.3 1.41 34.17 1.14 33.93 C 0.86 33.7 0.68 33.38 0.68 32.93 L 0.68 31.81 L 6.65 26.08 C 6.85 25.91 7.19 25.73 7.49 25.73 Z M 7.96 0.7 L 42.06 0.7 C 42.87 0.7 43.5 1.34 43.5 2.17 L 43.5 23.55 C 43.5 24.38 42.87 25.03 42.06 25.03 L 7.96 25.03 C 7.15 25.03 6.52 24.38 6.52 23.55 L 6.52 2.17 C 6.52 1.34 7.15 0.7 7.96 0.7 Z M 7.96 0 C 6.79 0 5.84 0.97 5.84 2.17 L 5.84 23.55 C 5.84 24.24 6.15 24.85 6.64 25.25 C 6.47 25.34 6.33 25.45 6.2 25.56 L 6.2 25.57 L 0 31.5 L 0 32.93 C 0 33.58 0.29 34.11 0.7 34.47 C 1.11 34.82 1.64 35 2.16 35 L 47.88 35 C 49.03 35 50 34.11 50 33.04 L 50 31.46 L 44.15 25.8 L 44.14 25.79 C 43.9 25.6 43.65 25.41 43.38 25.26 C 43.87 24.86 44.18 24.24 44.18 23.56 L 44.18 2.17 C 44.18 0.97 43.23 0 42.06 0 Z M 8.42 2.67 L 41.51 2.67 L 41.51 23.07 L 8.42 23.07 Z M 16.55 31.7 L 18.28 28.67 L 31.78 28.67 L 33.52 31.7 L 29.02 31.7 L 29.02 32.24 C 29.02 32.79 28.51 33.4 27.95 33.4 L 21.97 33.4 C 21.39 33.4 20.95 32.8 20.95 32.26 L 20.95 31.7 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    printer: {
        element: 'g',
        label: 'Printer',
        viewBox: '0 0 50 45',
        svgPath: 'M 20.31 0 L 14.28 6.18 L 14.3 8.3 L 11 8.3 L 7.49 20.61 L 4.67 20.61 C 2.09 20.61 0 22.76 0 25.41 L 0 40.21 C 0 42.85 2.09 45 4.67 45 L 45.33 45 C 47.91 45 50 42.85 50 40.21 L 50 25.41 C 50 22.76 47.91 20.61 45.33 20.61 L 42.52 20.61 L 39.09 8.3 L 35.78 8.3 L 35.78 0 Z M 20.31 0.72 L 35.13 0.72 L 35.13 20.56 L 14.94 20.56 L 14.94 6.28 L 20.31 6.28 Z M 18.52 7.96 L 18.52 9.01 L 31.08 9.01 L 31.08 7.96 Z M 18.52 11.95 L 18.52 13 L 31.08 13 L 31.08 11.95 Z M 18.52 15.94 L 18.52 16.98 L 31.08 16.98 L 31.08 15.94 Z M 4.67 21.52 L 45.33 21.52 C 47.44 21.52 49.12 23.25 49.12 25.41 L 49.12 40.21 C 49.12 42.37 47.44 44.09 45.33 44.09 L 4.67 44.09 C 2.56 44.09 0.88 42.37 0.88 40.21 L 0.88 25.41 C 0.88 23.25 2.56 21.52 4.67 21.52 Z M 42.95 25.38 C 42.4 25.38 41.86 25.61 41.47 26.01 C 41.07 26.42 40.85 26.97 40.85 27.54 C 40.85 28.12 41.07 28.67 41.47 29.07 C 41.86 29.48 42.4 29.71 42.95 29.7 C 43.51 29.7 44.05 29.48 44.44 29.07 C 44.84 28.67 45.06 28.12 45.06 27.54 C 45.06 26.35 44.12 25.38 42.95 25.38 Z M 3.16 32.3 L 3.16 33.35 L 47.14 33.35 L 47.14 32.3 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    server: {
        element: 'g',
        label: 'Server',
        viewBox: '0 0 27.5 50',
        svgPath: 'M 13.77 17.07 C 12.15 17.07 10.82 18.43 10.82 20.09 C 10.82 21.75 12.15 23.11 13.77 23.11 C 15.39 23.11 16.71 21.75 16.71 20.09 C 16.71 18.43 15.39 17.07 13.77 17.07 Z M 13.38 18.02 L 13.38 20.15 C 13.38 20.37 13.56 20.55 13.77 20.55 C 13.98 20.55 14.15 20.37 14.15 20.15 L 14.15 18.02 C 15.1 18.21 15.82 19.06 15.82 20.09 C 15.82 21.26 14.9 22.19 13.77 22.19 C 12.63 22.19 11.71 21.26 11.71 20.09 C 11.71 19.06 12.43 18.21 13.38 18.02 Z M 0 34.68 L 0 35.33 L 0 41.46 L 27.5 41.46 L 27.5 34.68 Z M 1.27 35.98 L 26.23 35.98 L 26.23 40.16 L 1.27 40.16 Z M 0 13.53 L 0 14.18 L 0 33.29 L 27.5 33.29 L 27.5 13.53 Z M 1.27 14.83 L 26.23 14.83 L 26.23 31.98 L 1.27 31.98 Z M 27.5 12.55 L 27.5 3.05 C 27.5 1.37 26.13 0 24.49 0 L 2.98 0 C 1.34 0 0 1.37 0 3.05 L 0 12.55 Z M 0 42.71 L 0 46.95 C 0 48.63 1.34 50 2.98 50 L 24.49 50 C 26.13 50 27.5 48.63 27.5 46.95 L 27.5 42.71 Z M 26.23 44.07 L 26.23 46.95 C 26.23 47.93 25.44 48.7 24.49 48.7 L 2.98 48.7 C 2.02 48.7 1.27 47.93 1.27 46.95 L 1.27 44.07 Z M 1.27 11.21 L 1.27 3.05 C 1.27 2.07 2.02 1.3 2.98 1.3 L 24.49 1.3 C 25.44 1.3 26.23 2.07 26.23 3.05 L 26.23 11.21 Z',
        attributes: {
            fill: '#005073',
            stroke: 'none'
        }
    },
    cloud: {
        element: 'g',
        label: 'Cloud',
        viewBox: '0 0 50 30',
        svgPath: 'M 19.43 0.4 C 12.48 0.98 6.92 5.95 5.76 12.67 C 4.14 13.2 2.71 14 1.67 15.07 C 0.63 16.16 0 17.51 0 19.1 C 0 21.01 0.74 22.72 2.41 23.96 C 4.08 25.19 6.66 25.94 10.36 26 C 13.15 28.68 17.18 30 20.49 30 C 24.87 30 28.73 28.02 31.17 25.5 C 34.76 25.85 37.81 26.17 41.05 25.96 L 41.05 25.96 C 44.19 25.73 46.43 24.87 47.88 23.62 C 49.33 22.37 50 20.72 50 18.97 C 50 17.52 49.36 16.2 48.26 15.1 C 47.18 14.01 45.64 13.12 43.82 12.51 C 43.08 10.82 41.88 8.95 39.85 7.81 L 39.85 7.81 L 39.85 7.81 C 37.52 6.56 35.27 6.72 33.09 7.17 C 31.05 3.85 26.24 0 19.43 0.4 L 19.43 0.4 Z M 19.44 0.6 C 26.2 0.2 30.97 4.06 32.95 7.33 L 32.99 7.39 L 33.06 7.37 C 35.24 6.92 37.46 6.75 39.76 7.98 C 41.75 9.1 42.93 10.95 43.65 12.63 L 43.67 12.67 L 43.71 12.68 C 45.53 13.29 47.05 14.17 48.12 15.24 C 49.19 16.32 49.8 17.58 49.8 18.97 C 49.8 20.67 49.16 22.25 47.75 23.47 C 46.34 24.68 44.15 25.54 41.03 25.76 C 37.81 25.97 34.75 25.65 31.14 25.3 L 31.09 25.29 L 31.06 25.33 C 28.66 27.82 24.83 29.8 20.49 29.8 C 17.23 29.8 13.21 28.48 10.47 25.83 L 10.44 25.8 L 10.4 25.8 C 6.71 25.75 4.16 25 2.53 23.8 C 0.91 22.6 0.2 20.96 0.2 19.1 C 0.2 17.57 0.81 16.26 1.82 15.21 C 2.83 14.16 4.26 13.36 5.88 12.84 L 5.94 12.82 L 5.95 12.76 C 7.07 6.1 12.57 1.17 19.44 0.6 Z',
        attributes: {
            fill: '#186180',
            stroke: 'none'
        },
        resizable: true
    }
};
const $81af32f25f2290bc$export$629d511489d383bc = {
    MIN: 0.1,
    MAX: 5,
    STEP: 1.2,
    DEFAULT: 1
};
const $81af32f25f2290bc$export$3fea9e4a2e457811 = {
    WIDTH: 3000,
    HEIGHT: 3000,
    GRID_SIZE: 20
};
const $81af32f25f2290bc$export$d9b34691fa373df4 = {
    CIRCLE_RADIUS: 5,
    ELLIPSE_RADIUS: 5,
    RECT_WIDTH: 10,
    RECT_HEIGHT: 10
};

});

parcelRegister("lwME4", function(module, exports) {

$parcel$export(module.exports, "appState", () => $fac252159035d338$export$b72e390a9ebe1648);
/**
 * Application state management
 */ class $fac252159035d338$var$AppState {
    constructor(){
        this.currentZoom = 1;
        this.shapeIdCounter = 0;
        this.connectionIdCounter = 0;
        this.selectedShape = null;
        this.isDraggingShape = false;
        this.isResizing = false;
        this.isPanningCanvas = false;
        this.isSelectionMode = false;
        this.selectionManager = null; // Reference to SelectionMode instance
        this.resizeHandle = null;
        this.dragOffsetX = 0;
        this.dragOffsetY = 0;
        this.panStartX = 0;
        this.panStartY = 0;
        this.resizeHandles = [];
        this.endpointHandles = [];
        this.isDraggingEndpoint = false;
        this.draggingEndpointType = null;
        // Connection mode state
        this.isAddingConnection = false;
        this.connectionSourceShape = null;
        this.connectionTargetShape = null;
        // Drag threshold - prevent accidental drags on click
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.dragThreshold = 3; // pixels to move before considering it a drag
        this.isMouseDown = false;
    }
    reset() {
        this.isDraggingShape = false;
        this.isResizing = false;
        this.isPanningCanvas = false;
        this.resizeHandle = null;
        this.dragOffsetX = 0;
        this.dragOffsetY = 0;
        this.panStartX = 0;
        this.panStartY = 0;
        this.isMouseDown = false;
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.isDraggingEndpoint = false;
        this.draggingEndpointType = null;
    }
    getNextShapeId() {
        return `shape-${++this.shapeIdCounter}`;
    }
    getNextConnectionId() {
        return `connection-${++this.connectionIdCounter}`;
    }
    selectShape(shape) {
        this.selectedShape = shape;
    }
    deselectShape() {
        this.selectedShape = null;
    }
    clearResizeHandles() {
        this.resizeHandles.forEach((handle)=>handle.remove());
        this.resizeHandles = [];
    }
    addResizeHandle(handle) {
        this.resizeHandles.push(handle);
    }
    clearEndpointHandles() {
        this.endpointHandles.forEach((handle)=>handle.remove());
        this.endpointHandles = [];
    }
    addEndpointHandle(handle) {
        this.endpointHandles.push(handle);
    }
    startConnectionMode() {
        this.isAddingConnection = true;
        this.connectionSourceShape = null;
        this.connectionTargetShape = null;
    }
    cancelConnectionMode() {
        this.isAddingConnection = false;
        this.connectionSourceShape = null;
        this.connectionTargetShape = null;
    }
    setConnectionSource(shape) {
        this.connectionSourceShape = shape;
    }
    setConnectionTarget(shape) {
        this.connectionTargetShape = shape;
    }
}
const $fac252159035d338$export$b72e390a9ebe1648 = new $fac252159035d338$var$AppState();

});

parcelRegister("89InF", function(module, exports) {

$parcel$export(module.exports, "addShapeEventListeners", () => $5f019715f632f19f$export$8cfb5eb0e05d051f);
/**
 * Shape event handlers (selection and dragging)
 */ 
var $lwME4 = parcelRequire("lwME4");

var $f2jpm = parcelRequire("f2jpm");

var $162Oa = parcelRequire("162Oa");

var $hkA3I = parcelRequire("hkA3I");

var $1cdEC = parcelRequire("1cdEC");
function $5f019715f632f19f$export$927372f4ce2f054c(shape) {
    // If the shape has an AbortController, abort it to remove all listeners
    if (shape._listenerController) {
        shape._listenerController.abort();
        delete shape._listenerController;
    }
}
function $5f019715f632f19f$export$8cfb5eb0e05d051f(shape) {
    // Remove any existing listeners first
    $5f019715f632f19f$export$927372f4ce2f054c(shape);
    // Create a new AbortController for this shape's listeners
    const controller = new AbortController();
    shape._listenerController = controller;
    const signal = controller.signal;
    // Selection
    shape.addEventListener('click', (e)=>{
        e.stopPropagation();
        // Check if we're in overlay connection mode - PRIORITY CHECK
        if ((0, $1cdEC.isInConnectionMode)()) {
            // Handle target selection, don't select the shape normally
            (0, $1cdEC.handleTargetShapeClick)(shape);
            return; // Exit early, don't call selectShape
        }
        // Check if we're in connection mode (old style)
        if ((0, $hkA3I.handleConnectionShapeClick)(shape)) return; // Connection mode handled the click
        // Normal shape selection - only if not already selected
        // (mousedown already called selectShape via startDragging)
        if ((0, $lwME4.appState).selectedShape !== shape) (0, $f2jpm.selectShape)(shape);
    }, {
        signal: signal
    });
    // Dragging
    shape.addEventListener('mousedown', (e)=>{
        // Don't stop propagation in selection mode - let it bubble to canvas
        if ((0, $lwME4.appState).isSelectionMode) return;
        e.stopPropagation();
        // Don't allow dragging in connection mode
        if ((0, $lwME4.appState).isAddingConnection) return;
        // Don't start dragging if we're clicking on a resize handle
        if (!e.target.classList.contains('resize-handle')) $5f019715f632f19f$var$startDragging(shape, e);
    }, {
        signal: signal
    });
    // Hover effects for connection mode
    shape.addEventListener('mouseenter', ()=>{
        (0, $hkA3I.handleConnectionShapeHover)(shape);
    }, {
        signal: signal
    });
    shape.addEventListener('mouseleave', ()=>{
        (0, $hkA3I.handleConnectionShapeLeave)(shape);
    }, {
        signal: signal
    });
}
/**
 * Start dragging a shape
 * @param {SVGElement} shape - The shape to drag
 * @param {MouseEvent} e - The mouse event
 */ function $5f019715f632f19f$var$startDragging(shape, e) {
    // Mark that mouse is down, but don't start dragging yet
    (0, $lwME4.appState).isMouseDown = true;
    (0, $f2jpm.selectShape)(shape);
    const canvasRect = (0, $162Oa.elements).topologyCanvas.getBoundingClientRect();
    const mouseX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
    const mouseY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
    // Store the initial mouse position for drag threshold
    (0, $lwME4.appState).dragStartX = e.clientX;
    (0, $lwME4.appState).dragStartY = e.clientY;
    // Calculate offset based on shape type (for when dragging actually starts)
    const dataType = shape.getAttribute('data-shape-type');
    if (shape.tagName === 'g') {
        // Handle group elements (Cisco shapes and arrows)
        if (dataType === 'arrow') {
            // For arrows, store offset relative to line center
            const line = shape.querySelector('.arrow-line');
            if (line) {
                const x1 = parseFloat(line.getAttribute('x1'));
                const y1 = parseFloat(line.getAttribute('y1'));
                const x2 = parseFloat(line.getAttribute('x2'));
                const y2 = parseFloat(line.getAttribute('y2'));
                const centerX = (x1 + x2) / 2;
                const centerY = (y1 + y2) / 2;
                (0, $lwME4.appState).dragOffsetX = mouseX - centerX;
                (0, $lwME4.appState).dragOffsetY = mouseY - centerY;
            }
        } else {
            // Cisco shapes with transform
            const transform = shape.getAttribute('transform');
            let tx = 0, ty = 0;
            if (transform) {
                const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
                if (match) {
                    tx = parseFloat(match[1]);
                    ty = parseFloat(match[2]);
                }
            }
            (0, $lwME4.appState).dragOffsetX = mouseX - tx;
            (0, $lwME4.appState).dragOffsetY = mouseY - ty;
        }
    } else if (shape.tagName === 'line') {
        // For lines, store offset relative to line center
        const x1 = parseFloat(shape.getAttribute('x1'));
        const y1 = parseFloat(shape.getAttribute('y1'));
        const x2 = parseFloat(shape.getAttribute('x2'));
        const y2 = parseFloat(shape.getAttribute('y2'));
        const centerX = (x1 + x2) / 2;
        const centerY = (y1 + y2) / 2;
        (0, $lwME4.appState).dragOffsetX = mouseX - centerX;
        (0, $lwME4.appState).dragOffsetY = mouseY - centerY;
    } else if (shape.tagName === 'circle') {
        (0, $lwME4.appState).dragOffsetX = mouseX - parseFloat(shape.getAttribute('cx'));
        (0, $lwME4.appState).dragOffsetY = mouseY - parseFloat(shape.getAttribute('cy'));
    } else if (shape.tagName === 'ellipse') {
        (0, $lwME4.appState).dragOffsetX = mouseX - parseFloat(shape.getAttribute('cx'));
        (0, $lwME4.appState).dragOffsetY = mouseY - parseFloat(shape.getAttribute('cy'));
    } else if (shape.tagName === 'rect') {
        const x = parseFloat(shape.getAttribute('x'));
        const y = parseFloat(shape.getAttribute('y'));
        (0, $lwME4.appState).dragOffsetX = mouseX - x;
        (0, $lwME4.appState).dragOffsetY = mouseY - y;
    }
}

});
parcelRegister("f2jpm", function(module, exports) {

$parcel$export(module.exports, "selectShape", () => $af2618f065722c3c$export$36108fe737fd26d4);
$parcel$export(module.exports, "removeResizeHandles", () => $af2618f065722c3c$export$f4bcfcbb939c3ca5);
$parcel$export(module.exports, "deselectShape", () => $af2618f065722c3c$export$fe49b423dce781a3);
$parcel$export(module.exports, "updateResizeHandles", () => $af2618f065722c3c$export$c06b03b01251ed07);
/**
 * Shape selection and resize handle management
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $gLqu3 = parcelRequire("gLqu3");

var $cqSAC = parcelRequire("cqSAC");

var $1cdEC = parcelRequire("1cdEC");

var $hqYiK = parcelRequire("hqYiK");

var $k5XSw = parcelRequire("k5XSw");
function $af2618f065722c3c$export$36108fe737fd26d4(shape) {
    // Deselect previous shape
    if ((0, $lwME4.appState).selectedShape) {
        (0, $lwME4.appState).selectedShape.classList.remove('selected');
        $af2618f065722c3c$export$f4bcfcbb939c3ca5();
        (0, $k5XSw.removeEndpointHandles)();
        (0, $hqYiK.hideInteractionCircle)();
    }
    // Select new shape
    (0, $lwME4.appState).selectShape(shape);
    shape.classList.add('selected');
    // Create appropriate handles based on shape type
    const dataType = shape.getAttribute('data-shape-type');
    if (dataType === 'line' || dataType === 'arrow') (0, $k5XSw.createEndpointHandles)(shape);
    else $af2618f065722c3c$var$createResizeHandles(shape);
    // Show interaction circle instead of overlay panel immediately
    (0, $hqYiK.showInteractionCircle)(shape);
// Note: No need to call updateInteractionCirclePosition here,
// showInteractionCircle already positions it correctly
}
function $af2618f065722c3c$export$fe49b423dce781a3() {
    if ((0, $lwME4.appState).selectedShape) {
        (0, $lwME4.appState).selectedShape.classList.remove('selected');
        (0, $lwME4.appState).deselectShape();
        $af2618f065722c3c$export$f4bcfcbb939c3ca5();
        (0, $k5XSw.removeEndpointHandles)();
        (0, $1cdEC.hideOverlayPanel)();
        (0, $hqYiK.hideInteractionCircle)();
    }
}
/**
 * Create resize handles around a selected shape
 * @param {SVGElement} shape - The selected shape
 */ function $af2618f065722c3c$var$createResizeHandles(shape) {
    $af2618f065722c3c$export$f4bcfcbb939c3ca5();
    const bounds = (0, $gLqu3.getShapeBounds)(shape);
    if (!bounds) return;
    // Define handle positions
    const handlePositions = [
        {
            x: bounds.left,
            y: bounds.top,
            cursor: 'nw-resize',
            type: 'nw'
        },
        {
            x: bounds.right,
            y: bounds.top,
            cursor: 'ne-resize',
            type: 'ne'
        },
        {
            x: bounds.right,
            y: bounds.bottom,
            cursor: 'se-resize',
            type: 'se'
        },
        {
            x: bounds.left,
            y: bounds.bottom,
            cursor: 'sw-resize',
            type: 'sw'
        },
        {
            x: bounds.centerX,
            y: bounds.top,
            cursor: 'n-resize',
            type: 'n'
        },
        {
            x: bounds.right,
            y: bounds.centerY,
            cursor: 'e-resize',
            type: 'e'
        },
        {
            x: bounds.centerX,
            y: bounds.bottom,
            cursor: 's-resize',
            type: 's'
        },
        {
            x: bounds.left,
            y: bounds.centerY,
            cursor: 'w-resize',
            type: 'w'
        }
    ];
    handlePositions.forEach((pos)=>{
        const handle = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        handle.setAttribute('class', 'resize-handle');
        handle.setAttribute('x', pos.x - 4);
        handle.setAttribute('y', pos.y - 4);
        handle.setAttribute('width', 8);
        handle.setAttribute('height', 8);
        handle.setAttribute('fill', '#2196F3');
        handle.setAttribute('stroke', '#ffffff');
        handle.setAttribute('stroke-width', 1);
        handle.style.cursor = pos.cursor;
        handle.setAttribute('data-handle-type', pos.type);
        // Add resize event listeners
        handle.addEventListener('mousedown', (e)=>{
            e.stopPropagation();
            (0, $cqSAC.startResize)(shape, pos.type, e);
        });
        // Ensure cursor stays consistent
        handle.addEventListener('mouseenter', ()=>{
            handle.style.cursor = pos.cursor;
        });
        (0, $162Oa.elements).topologyCanvas.appendChild(handle);
        (0, $lwME4.appState).addResizeHandle(handle);
    });
}
function $af2618f065722c3c$export$f4bcfcbb939c3ca5() {
    (0, $lwME4.appState).clearResizeHandles();
}
function $af2618f065722c3c$export$c06b03b01251ed07(shape) {
    if ((0, $lwME4.appState).resizeHandles.length === 0) return;
    const bounds = (0, $gLqu3.getShapeBounds)(shape);
    if (!bounds) return;
    const positions = [
        {
            x: bounds.left,
            y: bounds.top
        },
        {
            x: bounds.right,
            y: bounds.top
        },
        {
            x: bounds.right,
            y: bounds.bottom
        },
        {
            x: bounds.left,
            y: bounds.bottom
        },
        {
            x: bounds.centerX,
            y: bounds.top
        },
        {
            x: bounds.right,
            y: bounds.centerY
        },
        {
            x: bounds.centerX,
            y: bounds.bottom
        },
        {
            x: bounds.left,
            y: bounds.centerY
        }
    ];
    positions.forEach((pos, index)=>{
        if ((0, $lwME4.appState).resizeHandles[index]) {
            (0, $lwME4.appState).resizeHandles[index].setAttribute('x', pos.x - 4);
            (0, $lwME4.appState).resizeHandles[index].setAttribute('y', pos.y - 4);
        }
    });
// Note: Interaction circle update moved to mouseup for better performance
}

});
parcelRegister("162Oa", function(module, exports) {

$parcel$export(module.exports, "elements", () => $0cc887a55fa42419$export$7a5d735b2ab6389d);
$parcel$export(module.exports, "initializeElements", () => $0cc887a55fa42419$export$a57455d21a15702b);
/**
 * DOM element references
 */ const $0cc887a55fa42419$export$7a5d735b2ab6389d = {
    // API elements
    testApiBtn: null,
    apiResponse: null,
    // Canvas elements
    topologyCanvas: null,
    canvasWrapper: null,
    zoomLevel: null,
    canvas: null,
    canvasInfo: null,
    pointerPosition: null,
    // Menu elements
    newTopologyBtn: null,
    exportBtn: null,
    exportPngBtn: null,
    importBtn: null,
    // Canvas controls (sidebar)
    zoomInBtn: null,
    zoomOutBtn: null,
    resetZoomBtn: null,
    clearCanvasBtn: null,
    // Canvas controls (floating)
    zoomInBtnFloating: null,
    zoomOutBtnFloating: null,
    resetZoomBtnFloating: null,
    // Connection elements
    addConnectionBtn: null,
    connectionLabelModal: null,
    sourceLabel: null,
    targetLabel: null,
    submitConnectionLabels: null,
    connectionLabelForm: null,
    // Shape overlay panel elements
    shapeOverlayPanel: null,
    closeOverlayPanel: null,
    shapeLabelText: null,
    shapeLabelPosition: null,
    shapeLabelColor: null,
    shapeLabelFontSize: null,
    shapeLabelBold: null,
    shapeLabelItalic: null,
    shapeLabelUnderline: null,
    startConnectionBtn: null,
    applyShapeChanges: null,
    // Connection overlay panel elements
    connectionOverlayPanel: null,
    closeConnectionPanel: null,
    connectionSourceLabel: null,
    connectionTargetLabel: null,
    connectionCenterLabel: null,
    connectionStrokeWidth: null,
    connectionStrokeColor: null,
    connectionStrokeStyle: null,
    connectionLabelColor: null,
    connectionLabelFontSize: null,
    applyConnectionChanges: null
};
function $0cc887a55fa42419$export$a57455d21a15702b() {
    // API elements
    $0cc887a55fa42419$export$7a5d735b2ab6389d.testApiBtn = document.getElementById('testApiBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.apiResponse = document.getElementById('apiResponse');
    // Canvas elements
    $0cc887a55fa42419$export$7a5d735b2ab6389d.topologyCanvas = document.getElementById('topologyCanvas');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.canvasWrapper = document.getElementById('canvasWrapper');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.zoomLevel = document.getElementById('zoomLevel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.canvas = $0cc887a55fa42419$export$7a5d735b2ab6389d.topologyCanvas;
    $0cc887a55fa42419$export$7a5d735b2ab6389d.canvasInfo = document.getElementById('canvasInfo');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.pointerPosition = document.getElementById('pointerPosition');
    // Menu elements
    $0cc887a55fa42419$export$7a5d735b2ab6389d.newTopologyBtn = document.getElementById('newTopologyBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.exportBtn = document.getElementById('exportBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.exportPngBtn = document.getElementById('exportPngBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.importBtn = document.getElementById('importBtn');
    // Canvas controls (sidebar)
    $0cc887a55fa42419$export$7a5d735b2ab6389d.zoomInBtn = document.getElementById('zoomInBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.zoomOutBtn = document.getElementById('zoomOutBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.resetZoomBtn = document.getElementById('resetZoomBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.clearCanvasBtn = document.getElementById('clearCanvasBtn');
    // Canvas controls (floating)
    $0cc887a55fa42419$export$7a5d735b2ab6389d.zoomInBtnFloating = document.getElementById('zoomInBtnFloating');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.zoomOutBtnFloating = document.getElementById('zoomOutBtnFloating');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.resetZoomBtnFloating = document.getElementById('resetZoomBtnFloating');
    // Connection elements
    $0cc887a55fa42419$export$7a5d735b2ab6389d.addConnectionBtn = document.getElementById('addConnectionBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionLabelModal = document.getElementById('connectionLabelModal');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.sourceLabel = document.getElementById('sourceLabel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.targetLabel = document.getElementById('targetLabel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.submitConnectionLabels = document.getElementById('submitConnectionLabels');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionLabelForm = document.getElementById('connectionLabelForm');
    // Shape overlay panel elements
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeOverlayPanel = document.getElementById('shapeOverlayPanel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.closeOverlayPanel = document.getElementById('closeOverlayPanel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelText = document.getElementById('shapeLabelText');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelPosition = document.getElementById('shapeLabelPosition');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelColor = document.getElementById('shapeLabelColor');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelFontSize = document.getElementById('shapeLabelFontSize');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelBold = document.getElementById('shapeLabelBold');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelItalic = document.getElementById('shapeLabelItalic');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.shapeLabelUnderline = document.getElementById('shapeLabelUnderline');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.startConnectionBtn = document.getElementById('startConnectionBtn');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.applyShapeChanges = document.getElementById('applyShapeChanges');
    // Connection overlay panel elements
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionOverlayPanel = document.getElementById('connectionOverlayPanel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.closeConnectionPanel = document.getElementById('closeConnectionPanel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionSourceLabel = document.getElementById('connectionSourceLabel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionTargetLabel = document.getElementById('connectionTargetLabel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionCenterLabel = document.getElementById('connectionCenterLabel');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionStrokeWidth = document.getElementById('connectionStrokeWidth');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionStrokeColor = document.getElementById('connectionStrokeColor');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionStrokeStyle = document.getElementById('connectionStrokeStyle');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionLabelColor = document.getElementById('connectionLabelColor');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.connectionLabelFontSize = document.getElementById('connectionLabelFontSize');
    $0cc887a55fa42419$export$7a5d735b2ab6389d.applyConnectionChanges = document.getElementById('applyConnectionChanges');
}

});

parcelRegister("cqSAC", function(module, exports) {

$parcel$export(module.exports, "startResize", () => $90d2422062f07627$export$54257255aa86071b);
$parcel$export(module.exports, "handleResize", () => $90d2422062f07627$export$d3bf307c2376562f);
/**
 * Shape resizing functionality
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $b8j1A = parcelRequire("b8j1A");

var $f2jpm = parcelRequire("f2jpm");

var $hkA3I = parcelRequire("hkA3I");
parcelRequire("hqYiK");
function $90d2422062f07627$export$54257255aa86071b(shape, handleType, e) {
    (0, $lwME4.appState).isResizing = true;
    (0, $lwME4.appState).resizeHandle = handleType;
    (0, $lwME4.appState).selectShape(shape);
    // Prevent text selection during resize
    document.body.classList.add('no-select');
    const canvasRect = (0, $162Oa.elements).topologyCanvas.getBoundingClientRect();
    const mouseX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
    const mouseY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
    // Store initial mouse position
    (0, $lwME4.appState).dragOffsetX = mouseX;
    (0, $lwME4.appState).dragOffsetY = mouseY;
    // Set global cursor during resize
    const cursorMap = {
        nw: 'nw-resize',
        ne: 'ne-resize',
        se: 'se-resize',
        sw: 'sw-resize',
        n: 'n-resize',
        e: 'e-resize',
        s: 's-resize',
        w: 'w-resize'
    };
    document.body.style.cursor = cursorMap[handleType] || 'default';
}
function $90d2422062f07627$export$d3bf307c2376562f(shape, handleType, mouseX, mouseY) {
    const shapeType = shape.tagName;
    const deltaX = mouseX - (0, $lwME4.appState).dragOffsetX;
    const deltaY = mouseY - (0, $lwME4.appState).dragOffsetY;
    if (shapeType === 'circle') $90d2422062f07627$var$handleCircleResize(shape, deltaX, deltaY);
    else if (shapeType === 'ellipse') $90d2422062f07627$var$handleEllipseResize(shape, handleType, deltaX, deltaY);
    else if (shapeType === 'rect') $90d2422062f07627$var$handleRectResize(shape, handleType, deltaX, deltaY);
    else if (shapeType === 'g') $90d2422062f07627$var$handleGroupResize(shape, handleType, deltaX, deltaY);
    // Update drag offset for continuous resizing
    (0, $lwME4.appState).dragOffsetX = mouseX;
    (0, $lwME4.appState).dragOffsetY = mouseY;
    // Update resize handles
    (0, $f2jpm.updateResizeHandles)(shape);
    // Update connections
    (0, $hkA3I.updateShapeConnections)(shape);
// Note: Circle update moved to mouseup for better performance
}
/**
 * Handle circle resize
 */ function $90d2422062f07627$var$handleCircleResize(shape, deltaX, deltaY) {
    const r = parseFloat(shape.getAttribute('r'));
    const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;
    const newR = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).CIRCLE_RADIUS, r + delta);
    shape.setAttribute('r', newR);
}
/**
 * Handle ellipse resize
 */ function $90d2422062f07627$var$handleEllipseResize(shape, handleType, deltaX, deltaY) {
    const rx = parseFloat(shape.getAttribute('rx'));
    const ry = parseFloat(shape.getAttribute('ry'));
    let newRx = rx;
    let newRy = ry;
    // Handle horizontal resize with proper direction
    if ([
        'e',
        'ne',
        'se'
    ].includes(handleType)) newRx = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).ELLIPSE_RADIUS, rx + deltaX);
    else if ([
        'w',
        'nw',
        'sw'
    ].includes(handleType)) newRx = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).ELLIPSE_RADIUS, rx - deltaX);
    // Handle vertical resize with proper direction
    if ([
        's',
        'se',
        'sw'
    ].includes(handleType)) newRy = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).ELLIPSE_RADIUS, ry + deltaY);
    else if ([
        'n',
        'ne',
        'nw'
    ].includes(handleType)) newRy = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).ELLIPSE_RADIUS, ry - deltaY);
    shape.setAttribute('rx', newRx);
    shape.setAttribute('ry', newRy);
}
/**
 * Handle rectangle resize
 */ function $90d2422062f07627$var$handleRectResize(shape, handleType, deltaX, deltaY) {
    const x = parseFloat(shape.getAttribute('x'));
    const y = parseFloat(shape.getAttribute('y'));
    const width = parseFloat(shape.getAttribute('width'));
    const height = parseFloat(shape.getAttribute('height'));
    let newX = x;
    let newY = y;
    let newWidth = width;
    let newHeight = height;
    switch(handleType){
        case 'nw':
            newX = x + deltaX;
            newY = y + deltaY;
            newWidth = width - deltaX;
            newHeight = height - deltaY;
            break;
        case 'ne':
            newY = y + deltaY;
            newWidth = width + deltaX;
            newHeight = height - deltaY;
            break;
        case 'se':
            newWidth = width + deltaX;
            newHeight = height + deltaY;
            break;
        case 'sw':
            newX = x + deltaX;
            newWidth = width - deltaX;
            newHeight = height + deltaY;
            break;
        case 'n':
            newY = y + deltaY;
            newHeight = height - deltaY;
            break;
        case 'e':
            newWidth = width + deltaX;
            break;
        case 's':
            newHeight = height + deltaY;
            break;
        case 'w':
            newX = x + deltaX;
            newWidth = width - deltaX;
            break;
    }
    // Ensure minimum size
    newWidth = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).RECT_WIDTH, newWidth);
    newHeight = Math.max((0, $b8j1A.MIN_SHAPE_SIZE).RECT_HEIGHT, newHeight);
    // Adjust position if width/height changed due to minimum constraints
    if (newWidth === (0, $b8j1A.MIN_SHAPE_SIZE).RECT_WIDTH && handleType.includes('w')) newX = x + width - (0, $b8j1A.MIN_SHAPE_SIZE).RECT_WIDTH;
    if (newHeight === (0, $b8j1A.MIN_SHAPE_SIZE).RECT_HEIGHT && handleType.includes('n')) newY = y + height - (0, $b8j1A.MIN_SHAPE_SIZE).RECT_HEIGHT;
    shape.setAttribute('x', newX);
    shape.setAttribute('y', newY);
    shape.setAttribute('width', newWidth);
    shape.setAttribute('height', newHeight);
}
/**
 * Handle group (Cisco shape) resize
 */ function $90d2422062f07627$var$handleGroupResize(shape, handleType, deltaX, deltaY) {
    // Get the current transform
    const transform = shape.getAttribute('transform');
    let tx = 0, ty = 0;
    if (transform) {
        const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
        if (match) {
            tx = parseFloat(match[1]);
            ty = parseFloat(match[2]);
        }
    }
    // Get the SVG element inside the group
    const svg = shape.querySelector('svg');
    if (!svg) return;
    const currentWidth = parseFloat(svg.getAttribute('width'));
    const currentHeight = parseFloat(svg.getAttribute('height'));
    let newX = tx;
    let newY = ty;
    let newWidth = currentWidth;
    let newHeight = currentHeight;
    // Calculate new dimensions based on handle type
    switch(handleType){
        case 'nw':
            newX = tx + deltaX;
            newY = ty + deltaY;
            newWidth = currentWidth - deltaX;
            newHeight = currentHeight - deltaY;
            break;
        case 'ne':
            newY = ty + deltaY;
            newWidth = currentWidth + deltaX;
            newHeight = currentHeight - deltaY;
            break;
        case 'se':
            newWidth = currentWidth + deltaX;
            newHeight = currentHeight + deltaY;
            break;
        case 'sw':
            newX = tx + deltaX;
            newWidth = currentWidth - deltaX;
            newHeight = currentHeight + deltaY;
            break;
        case 'n':
            newY = ty + deltaY;
            newHeight = currentHeight - deltaY;
            break;
        case 'e':
            newWidth = currentWidth + deltaX;
            break;
        case 's':
            newHeight = currentHeight + deltaY;
            break;
        case 'w':
            newX = tx + deltaX;
            newWidth = currentWidth - deltaX;
            break;
    }
    // Ensure minimum size
    const minSize = 20;
    newWidth = Math.max(minSize, newWidth);
    newHeight = Math.max(minSize, newHeight);
    // Adjust position if size changed due to minimum constraints
    if (newWidth === minSize && handleType.includes('w')) newX = tx + currentWidth - minSize;
    if (newHeight === minSize && handleType.includes('n')) newY = ty + currentHeight - minSize;
    // Update the group transform
    shape.setAttribute('transform', `translate(${newX}, ${newY})`);
    // Update the SVG dimensions
    svg.setAttribute('width', newWidth);
    svg.setAttribute('height', newHeight);
    // Update the label position if it exists
    const label = shape.querySelector('text');
    if (label) {
        label.setAttribute('x', newWidth / 2);
        label.setAttribute('y', newHeight + 12);
    }
}

});
parcelRegister("hkA3I", function(module, exports) {

$parcel$export(module.exports, "setupConnectionMode", () => $c9e04676a0cce4e6$export$83af2c2251d6b1c5);
$parcel$export(module.exports, "handleConnectionShapeClick", () => $c9e04676a0cce4e6$export$dcba70f377010357);
$parcel$export(module.exports, "handleConnectionShapeHover", () => $c9e04676a0cce4e6$export$c41886eda0f9efdd);
$parcel$export(module.exports, "handleConnectionShapeLeave", () => $c9e04676a0cce4e6$export$bd0cd656c32f7ef);
$parcel$export(module.exports, "createConnection", () => $c9e04676a0cce4e6$export$f28ca1a95bdaacaa);
$parcel$export(module.exports, "updateShapeConnections", () => $c9e04676a0cce4e6$export$196527244e94809a);
$parcel$export(module.exports, "deleteShapeConnections", () => $c9e04676a0cce4e6$export$6eb397713b08f485);
$parcel$export(module.exports, "migrateExistingConnections", () => $c9e04676a0cce4e6$export$d552c449281dc8eb);
/**
 * Connection/Edge management
 * Handles creation and management of connections between shapes
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $gLqu3 = parcelRequire("gLqu3");

var $f2jpm = parcelRequire("f2jpm");

var $4DKvQ = parcelRequire("4DKvQ");

var $cgpVJ = parcelRequire("cgpVJ");

var $le39T = parcelRequire("le39T");
function $c9e04676a0cce4e6$export$83af2c2251d6b1c5() {
    // Keep this function for compatibility but connection mode
    // is now initiated through the shape overlay panel
    console.log('Connection manager initialized (overlay mode)');
}
/**
 * Start connection mode
 */ function $c9e04676a0cce4e6$var$startConnectionMode() {
    (0, $lwME4.appState).startConnectionMode();
    // Update button state
    (0, $162Oa.elements).addConnectionBtn.classList.add('active', 'btn-success');
    (0, $162Oa.elements).addConnectionBtn.classList.remove('btn-outline-success');
    (0, $162Oa.elements).addConnectionBtn.innerHTML = '<i class="bi bi-x-circle"></i> Cancel Connection';
    // Change button handler to cancel
    (0, $162Oa.elements).addConnectionBtn.onclick = $c9e04676a0cce4e6$export$efe3dff3467ad0d3;
    // If a shape is already selected, use it as the source
    if ((0, $lwME4.appState).selectedShape) {
        (0, $lwME4.appState).setConnectionSource((0, $lwME4.appState).selectedShape);
        (0, $lwME4.appState).selectedShape.classList.add('connection-source');
        // Show resize handles in different color
        $c9e04676a0cce4e6$var$changeResizeHandlesColor('#28a745'); // Green color for connection mode
        console.log('Connection mode activated with pre-selected source:', (0, $lwME4.appState).selectedShape.id);
    } else console.log('Connection mode activated - select two shapes');
}
function $c9e04676a0cce4e6$export$efe3dff3467ad0d3() {
    (0, $lwME4.appState).cancelConnectionMode();
    // Reset button state
    (0, $162Oa.elements).addConnectionBtn.classList.remove('active', 'btn-success');
    (0, $162Oa.elements).addConnectionBtn.classList.add('btn-outline-success');
    (0, $162Oa.elements).addConnectionBtn.innerHTML = '<i class="bi bi-arrow-left-right"></i> Add Connection';
    // Reset button handler
    (0, $162Oa.elements).addConnectionBtn.onclick = $c9e04676a0cce4e6$var$startConnectionMode;
    // Remove connection mode styling from any shapes
    document.querySelectorAll('.connection-source').forEach((el)=>{
        el.classList.remove('connection-source');
        (0, $f2jpm.removeResizeHandles)();
    });
    console.log('Connection mode cancelled');
}
function $c9e04676a0cce4e6$export$dcba70f377010357(shape) {
    if (!(0, $lwME4.appState).isAddingConnection) return false;
    // First shape selection
    if (!(0, $lwME4.appState).connectionSourceShape) {
        (0, $lwME4.appState).setConnectionSource(shape);
        shape.classList.add('connection-source');
        // Show resize handles in different color
        (0, $f2jpm.updateResizeHandles)(shape);
        $c9e04676a0cce4e6$var$changeResizeHandlesColor('#28a745'); // Green color for connection mode
        console.log('Source shape selected:', shape.id);
        return true;
    }
    // Second shape selection (can't be the same as first)
    if (!(0, $lwME4.appState).connectionTargetShape && shape !== (0, $lwME4.appState).connectionSourceShape) {
        (0, $lwME4.appState).setConnectionTarget(shape);
        // Show the label modal
        $c9e04676a0cce4e6$var$showConnectionLabelModal();
        console.log('Target shape selected:', shape.id);
        return true;
    }
    return false;
}
function $c9e04676a0cce4e6$export$c41886eda0f9efdd(shape) {
    if (!(0, $lwME4.appState).isAddingConnection) return;
    if (!(0, $lwME4.appState).connectionSourceShape) return; // Only after source is selected
    if (shape === (0, $lwME4.appState).connectionSourceShape) return; // Can't hover source
    // Add hover effect
    const currentFill = shape.getAttribute('fill');
    shape.setAttribute('data-original-fill', currentFill);
    shape.setAttribute('fill', '#d4edda'); // Light green hover
}
function $c9e04676a0cce4e6$export$bd0cd656c32f7ef(shape) {
    if (!(0, $lwME4.appState).isAddingConnection) return;
    // Restore original fill
    const originalFill = shape.getAttribute('data-original-fill');
    if (originalFill) {
        shape.setAttribute('fill', originalFill);
        shape.removeAttribute('data-original-fill');
    }
}
/**
 * Change resize handles color for connection mode
 * @param {string} color - The color to apply
 */ function $c9e04676a0cce4e6$var$changeResizeHandlesColor(color) {
    (0, $lwME4.appState).resizeHandles.forEach((handle)=>{
        handle.setAttribute('fill', color);
        handle.setAttribute('stroke', color);
    });
}
/**
 * Show the connection label modal
 */ function $c9e04676a0cce4e6$var$showConnectionLabelModal() {
    // Clear previous values
    (0, $162Oa.elements).sourceLabel.value = '';
    (0, $162Oa.elements).targetLabel.value = '';
    // Show modal using Bootstrap
    const modal = new bootstrap.Modal((0, $162Oa.elements).connectionLabelModal);
    modal.show();
}
/**
 * Handle connection label form submission
 */ function $c9e04676a0cce4e6$var$handleConnectionLabelSubmit() {
    const sourceLabel = (0, $162Oa.elements).sourceLabel.value.trim();
    const targetLabel = (0, $162Oa.elements).targetLabel.value.trim();
    if (!sourceLabel || !targetLabel) {
        (0, $le39T.showAlert)('Please enter labels for both connection ends', 'Missing Labels', 'warning');
        return;
    }
    // Create the connection
    $c9e04676a0cce4e6$export$f28ca1a95bdaacaa((0, $lwME4.appState).connectionSourceShape, (0, $lwME4.appState).connectionTargetShape, sourceLabel, targetLabel);
    // Hide modal
    const modal = bootstrap.Modal.getInstance((0, $162Oa.elements).connectionLabelModal);
    modal.hide();
    // Exit connection mode
    $c9e04676a0cce4e6$export$efe3dff3467ad0d3();
}
function $c9e04676a0cce4e6$export$f28ca1a95bdaacaa(sourceShape, targetShape, sourceLabel, targetLabel, centerLabel = '', strokeWidth = 3, strokeColor = '#6c757d') {
    const connectionId = (0, $lwME4.appState).getNextConnectionId();
    // Get bounds of both shapes
    const sourceBounds = (0, $gLqu3.getShapeBounds)(sourceShape);
    const targetBounds = (0, $gLqu3.getShapeBounds)(targetShape);
    // Find closest points between the two shapes
    const { sourcePoint: sourcePoint, targetPoint: targetPoint } = $c9e04676a0cce4e6$var$findClosestPoints(sourceBounds, targetBounds);
    // Calculate connection angle for label positioning
    const dx = targetPoint.x - sourcePoint.x;
    const dy = targetPoint.y - sourcePoint.y;
    // Calculate center point for center label
    const centerPoint = {
        x: (sourcePoint.x + targetPoint.x) / 2,
        y: (sourcePoint.y + targetPoint.y) / 2
    };
    // Create connection group
    const connectionGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    connectionGroup.id = connectionId;
    connectionGroup.classList.add('connection');
    connectionGroup.setAttribute('data-source', sourceShape.id);
    connectionGroup.setAttribute('data-target', targetShape.id);
    // Create the line
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', sourcePoint.x);
    line.setAttribute('y1', sourcePoint.y);
    line.setAttribute('x2', targetPoint.x);
    line.setAttribute('y2', targetPoint.y);
    line.setAttribute('stroke', strokeColor);
    line.setAttribute('stroke-width', strokeWidth.toString());
    line.classList.add('connection-line');
    // Use inline styles to override CSS
    line.style.stroke = strokeColor;
    line.style.strokeWidth = strokeWidth + 'px';
    // Create invisible wider line for easier clicking (hit target)
    const hitTarget = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    hitTarget.setAttribute('x1', sourcePoint.x);
    hitTarget.setAttribute('y1', sourcePoint.y);
    hitTarget.setAttribute('x2', targetPoint.x);
    hitTarget.setAttribute('y2', targetPoint.y);
    hitTarget.setAttribute('stroke', 'transparent');
    hitTarget.setAttribute('stroke-width', '12'); // Wider hit area
    hitTarget.classList.add('connection-hit-target');
    hitTarget.style.cursor = 'pointer';
    hitTarget.style.strokeWidth = '12px';
    // Get shape centers for label positioning
    const sourceCenter = {
        x: sourceBounds.x + sourceBounds.width / 2,
        y: sourceBounds.y + sourceBounds.height / 2
    };
    const targetCenter = {
        x: targetBounds.x + targetBounds.width / 2,
        y: targetBounds.y + targetBounds.height / 2
    };
    // Create source label positioned on circle around source shape
    const sourceLabelEl = $c9e04676a0cce4e6$var$createConnectionLabel(connectionId, sourceLabel, sourcePoint.x, sourcePoint.y, 'source', sourceShape, sourceCenter, targetCenter);
    // Create target label positioned on circle around target shape
    const targetLabelEl = $c9e04676a0cce4e6$var$createConnectionLabel(connectionId, targetLabel, targetPoint.x, targetPoint.y, 'target', targetShape, targetCenter, sourceCenter);
    // Create center label (always empty initially)
    const centerLabelEl = $c9e04676a0cce4e6$var$createConnectionLabel(connectionId, centerLabel, centerPoint.x, centerPoint.y, 'center');
    // Add line to the group
    connectionGroup.appendChild(line); // Add visible line first
    connectionGroup.appendChild(hitTarget); // Add hit target last (on top for mouse events)
    // Add connection to the connections layer
    const connectionsLayer = document.getElementById('connectionsLayer');
    if (connectionsLayer) connectionsLayer.appendChild(connectionGroup);
    else {
        // Fallback: Insert connection group before shapes so lines appear behind them
        const gridRect = (0, $162Oa.elements).canvas.querySelector('rect[fill="url(#grid)"]');
        if (gridRect && gridRect.nextSibling) (0, $162Oa.elements).canvas.insertBefore(connectionGroup, gridRect.nextSibling);
        else if (gridRect) (0, $162Oa.elements).canvas.appendChild(connectionGroup);
        else (0, $162Oa.elements).canvas.appendChild(connectionGroup);
    }
    // Add labels to the labels layer
    const labelsLayer = document.getElementById('labelsLayer');
    const labelTarget = labelsLayer || (0, $162Oa.elements).canvas;
    labelTarget.appendChild(sourceLabelEl);
    labelTarget.appendChild(targetLabelEl);
    labelTarget.appendChild(centerLabelEl);
    // Add event listeners to labels for selection, editing, and dragging
    (0, $cgpVJ.addLabelListeners)(sourceLabelEl);
    (0, $cgpVJ.addLabelListeners)(targetLabelEl);
    (0, $cgpVJ.addLabelListeners)(centerLabelEl);
    // Set IDs on labels so we can find them
    sourceLabelEl.id = `label-${connectionId}-source`;
    targetLabelEl.id = `label-${connectionId}-target`;
    centerLabelEl.id = `label-${connectionId}-center`;
    // Store label references in connection group for updates
    connectionGroup.setAttribute('data-source-label-id', sourceLabelEl.id);
    connectionGroup.setAttribute('data-target-label-id', targetLabelEl.id);
    connectionGroup.setAttribute('data-center-label-id', centerLabelEl.id);
    // Store connection data on shapes for updates
    if (!sourceShape.dataset.connections) sourceShape.dataset.connections = '';
    sourceShape.dataset.connections += connectionId + ',';
    if (!targetShape.dataset.connections) targetShape.dataset.connections = '';
    targetShape.dataset.connections += connectionId + ',';
    // Save state
    (0, $4DKvQ.saveAppState)();
    // Return the connection group for further operations
    return connectionGroup;
}
/**
 * Create a connection label
 * @param {string} connectionId - The connection ID
 * @param {string} text - Label text
 * @param {number} x - Connection point X (intersection with shape)
 * @param {number} y - Connection point Y (intersection with shape)
 * @param {string} type - 'source', 'target', or 'center'
 * @param {SVGElement} shape - The shape element (for source/target)
 * @param {Object} shapeCenter - Center of the shape {x, y}
 * @param {Object} otherCenter - Center of the other shape {x, y}
 * @returns {SVGTextElement} The label element
 */ function $c9e04676a0cce4e6$var$createConnectionLabel(connectionId, text, x, y, type, shape = null, shapeCenter = null, otherCenter = null) {
    const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    // Define constraint circle radius (distance from shape center)
    const CONSTRAINT_RADIUS = 60; // pixels from shape center
    let labelX = x;
    let labelY = y;
    // For source/target labels, position on the constraint circle
    if ((type === 'source' || type === 'target') && shapeCenter && otherCenter) {
        // Calculate angle from shape center to other shape center (connection direction)
        const dx = otherCenter.x - shapeCenter.x;
        const dy = otherCenter.y - shapeCenter.y;
        const angle = Math.atan2(dy, dx);
        // Position label on the constraint circle at this angle
        labelX = shapeCenter.x + Math.cos(angle) * CONSTRAINT_RADIUS;
        labelY = shapeCenter.y + Math.sin(angle) * CONSTRAINT_RADIUS;
        // Store the shape center and radius as data attributes for dragging
        label.setAttribute('data-constraint-center-x', shapeCenter.x);
        label.setAttribute('data-constraint-center-y', shapeCenter.y);
        label.setAttribute('data-constraint-radius', CONSTRAINT_RADIUS);
    }
    label.setAttribute('x', labelX);
    label.setAttribute('y', labelY);
    label.setAttribute('fill', '#495057');
    label.setAttribute('font-size', '12');
    label.setAttribute('font-family', 'Arial, sans-serif');
    label.setAttribute('font-weight', 'bold');
    label.classList.add('connection-label', `connection-label-${type}`);
    label.setAttribute('data-connection-id', connectionId);
    label.setAttribute('data-label-type', type);
    // Set text anchor based on position relative to shape center
    if (type === 'source' || type === 'target') {
        const dx = labelX - shapeCenter.x;
        const dy = labelY - shapeCenter.y;
        if (Math.abs(dx) > Math.abs(dy)) // More horizontal
        label.setAttribute('text-anchor', dx > 0 ? 'start' : 'end');
        else // More vertical
        label.setAttribute('text-anchor', 'middle');
        // Vertical alignment offset
        label.setAttribute('dy', '0.35em'); // Center vertically
    } else if (type === 'center') {
        // Center label is positioned horizontally centered
        label.setAttribute('text-anchor', 'middle');
        label.setAttribute('dy', '-5');
        label.setAttribute('fill', '#212529'); // Darker for center label
    }
    label.textContent = text;
    // Make label draggable
    $c9e04676a0cce4e6$var$makeLabelDraggable(label);
    return label;
}
/**
 * Make a label draggable with circular constraint around its shape
 * @param {SVGTextElement} label - The label element
 */ function $c9e04676a0cce4e6$var$makeLabelDraggable(label) {
    let isDragging = false;
    let shapeCenter = null;
    let constraintRadius = 0;
    label.style.cursor = 'pointer';
    label._isDragging = false;
    label.addEventListener('mousedown', (e)=>{
        if ((0, $lwME4.appState).isAddingConnection) return; // Don't drag during connection mode
        e.stopPropagation();
        e.preventDefault(); // Prevent text selection during drag
        isDragging = true;
        label._isDragging = false; // Reset at start
        // Try to get constraint data from label attributes first
        const centerX = label.getAttribute('data-constraint-center-x');
        const centerY = label.getAttribute('data-constraint-center-y');
        const radius = label.getAttribute('data-constraint-radius');
        if (centerX && centerY && radius) {
            // Use stored constraint data
            shapeCenter = {
                x: parseFloat(centerX),
                y: parseFloat(centerY)
            };
            constraintRadius = parseFloat(radius);
        } else {
            // Fallback: calculate from shape bounds
            const connectionId = label.getAttribute('data-connection-id');
            const labelType = label.getAttribute('data-label-type');
            const connection = document.getElementById(connectionId);
            if (connection) {
                const sourceId = connection.getAttribute('data-source');
                const targetId = connection.getAttribute('data-target');
                const shapeId = labelType === 'source' ? sourceId : targetId;
                const shape = document.getElementById(shapeId);
                if (shape) {
                    const shapeBounds = (0, $gLqu3.getShapeBounds)(shape);
                    shapeCenter = {
                        x: shapeBounds.x + shapeBounds.width / 2,
                        y: shapeBounds.y + shapeBounds.height / 2
                    };
                    // Calculate current distance as radius
                    const currentX = parseFloat(label.getAttribute('x'));
                    const currentY = parseFloat(label.getAttribute('y'));
                    const dx = currentX - shapeCenter.x;
                    const dy = currentY - shapeCenter.y;
                    constraintRadius = Math.sqrt(dx * dx + dy * dy);
                    // Ensure minimum radius
                    if (constraintRadius < 50) constraintRadius = 50;
                    // Store for future use
                    label.setAttribute('data-constraint-center-x', shapeCenter.x);
                    label.setAttribute('data-constraint-center-y', shapeCenter.y);
                    label.setAttribute('data-constraint-radius', constraintRadius);
                }
            }
        }
        label.style.cursor = 'grabbing';
    });
    const handleMouseMove = (e)=>{
        if (!isDragging || !shapeCenter) return;
        // Set flag that we're actually dragging
        label._isDragging = true;
        const canvasRect = (0, $162Oa.elements).canvas.getBoundingClientRect();
        const mouseX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
        const mouseY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
        // Calculate angle from shape center to mouse position
        const dx = mouseX - shapeCenter.x;
        const dy = mouseY - shapeCenter.y;
        const angle = Math.atan2(dy, dx);
        // Position label on the circle at this angle
        const newX = shapeCenter.x + Math.cos(angle) * constraintRadius;
        const newY = shapeCenter.y + Math.sin(angle) * constraintRadius;
        label.setAttribute('x', newX);
        label.setAttribute('y', newY);
    };
    const handleMouseUp = ()=>{
        if (isDragging) {
            isDragging = false;
            shapeCenter = null;
            label.style.cursor = 'pointer';
            (0, $4DKvQ.saveAppState)();
            // Reset drag flag after a short delay
            setTimeout(()=>{
                label._isDragging = false;
            }, 100);
        }
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}
/**
 * Find closest points on the boundaries of two shapes for connection
 * @param {Object} sourceBounds - Bounds of source shape {x, y, width, height}
 * @param {Object} targetBounds - Bounds of target shape
 * @returns {Object} {sourcePoint: {x, y}, targetPoint: {x, y}}
 */ function $c9e04676a0cce4e6$var$findClosestPoints(sourceBounds, targetBounds) {
    // Calculate centers
    const sourceCenter = {
        x: sourceBounds.x + sourceBounds.width / 2,
        y: sourceBounds.y + sourceBounds.height / 2
    };
    const targetCenter = {
        x: targetBounds.x + targetBounds.width / 2,
        y: targetBounds.y + targetBounds.height / 2
    };
    // Calculate the direction from source to target
    const dx = targetCenter.x - sourceCenter.x;
    const dy = targetCenter.y - sourceCenter.y;
    // Find intersection points on the boundaries
    const sourcePoint = $c9e04676a0cce4e6$var$findBoundaryIntersection(sourceBounds, sourceCenter, dx, dy);
    const targetPoint = $c9e04676a0cce4e6$var$findBoundaryIntersection(targetBounds, targetCenter, -dx, -dy);
    return {
        sourcePoint: sourcePoint,
        targetPoint: targetPoint
    };
}
/**
 * Find the intersection point on a shape's boundary
 * @param {Object} bounds - Shape bounds {x, y, width, height}
 * @param {Object} center - Shape center {x, y}
 * @param {number} dx - Direction x component
 * @param {number} dy - Direction y component
 * @returns {Object} {x, y} intersection point
 */ function $c9e04676a0cce4e6$var$findBoundaryIntersection(bounds, center, dx, dy) {
    const halfWidth = bounds.width / 2;
    const halfHeight = bounds.height / 2;
    // Normalize direction
    const length = Math.sqrt(dx * dx + dy * dy);
    if (length === 0) return {
        x: center.x,
        y: center.y
    };
    const normalizedDx = dx / length;
    const normalizedDy = dy / length;
    // Calculate which edge the line intersects
    // Check horizontal edges (top/bottom)
    const tHorizontal = halfHeight / Math.abs(normalizedDy);
    // Check vertical edges (left/right)
    const tVertical = halfWidth / Math.abs(normalizedDx);
    // Use the smaller t value (first intersection)
    const t = Math.min(tHorizontal, tVertical);
    return {
        x: center.x + normalizedDx * t,
        y: center.y + normalizedDy * t
    };
}
function $c9e04676a0cce4e6$export$196527244e94809a(shape) {
    const connectionIds = shape.dataset.connections;
    if (!connectionIds) return;
    // Get all connection IDs for this shape
    const ids = connectionIds.split(',').filter((id)=>id);
    ids.forEach((connectionId)=>{
        const connection = document.getElementById(connectionId);
        if (!connection) return;
        const sourceId = connection.getAttribute('data-source');
        const targetId = connection.getAttribute('data-target');
        const sourceShape = document.getElementById(sourceId);
        const targetShape = document.getElementById(targetId);
        if (!sourceShape || !targetShape) return;
        // Recalculate connection points
        const sourceBounds = (0, $gLqu3.getShapeBounds)(sourceShape);
        const targetBounds = (0, $gLqu3.getShapeBounds)(targetShape);
        const { sourcePoint: sourcePoint, targetPoint: targetPoint } = $c9e04676a0cce4e6$var$findClosestPoints(sourceBounds, targetBounds);
        // Calculate shape centers for label constraint circles
        const sourceCenter = {
            x: sourceBounds.x + sourceBounds.width / 2,
            y: sourceBounds.y + sourceBounds.height / 2
        };
        const targetCenter = {
            x: targetBounds.x + targetBounds.width / 2,
            y: targetBounds.y + targetBounds.height / 2
        };
        // Calculate center point
        const centerPoint = {
            x: (sourcePoint.x + targetPoint.x) / 2,
            y: (sourcePoint.y + targetPoint.y) / 2
        };
        // Update line
        const line = connection.querySelector('.connection-line');
        if (line) {
            line.setAttribute('x1', sourcePoint.x);
            line.setAttribute('y1', sourcePoint.y);
            line.setAttribute('x2', targetPoint.x);
            line.setAttribute('y2', targetPoint.y);
        }
        // Update hit target
        const hitTarget = connection.querySelector('.connection-hit-target');
        if (hitTarget) {
            hitTarget.setAttribute('x1', sourcePoint.x);
            hitTarget.setAttribute('y1', sourcePoint.y);
            hitTarget.setAttribute('x2', targetPoint.x);
            hitTarget.setAttribute('y2', targetPoint.y);
        }
        // Update labels with constraint circle repositioning
        const sourceLabelId = connection.getAttribute('data-source-label-id');
        const targetLabelId = connection.getAttribute('data-target-label-id');
        const centerLabelId = connection.getAttribute('data-center-label-id');
        if (sourceLabelId) {
            const sourceLabel = document.getElementById(sourceLabelId);
            if (sourceLabel) {
                // Update constraint center
                const oldCenterX = parseFloat(sourceLabel.getAttribute('data-constraint-center-x'));
                const oldCenterY = parseFloat(sourceLabel.getAttribute('data-constraint-center-y'));
                sourceLabel.setAttribute('data-constraint-center-x', sourceCenter.x);
                sourceLabel.setAttribute('data-constraint-center-y', sourceCenter.y);
                // Get constraint radius and current label position
                const radius = parseFloat(sourceLabel.getAttribute('data-constraint-radius')) || 60;
                const currentX = parseFloat(sourceLabel.getAttribute('x'));
                const currentY = parseFloat(sourceLabel.getAttribute('y'));
                // Calculate current angle relative to OLD center
                let angle;
                if (!isNaN(oldCenterX) && !isNaN(oldCenterY)) {
                    const dx = currentX - oldCenterX;
                    const dy = currentY - oldCenterY;
                    angle = Math.atan2(dy, dx);
                } else {
                    // Fallback: use connection direction
                    const dx = targetCenter.x - sourceCenter.x;
                    const dy = targetCenter.y - sourceCenter.y;
                    angle = Math.atan2(dy, dx);
                }
                // Position label on constraint circle at the SAME angle relative to NEW center
                const labelX = sourceCenter.x + Math.cos(angle) * radius;
                const labelY = sourceCenter.y + Math.sin(angle) * radius;
                sourceLabel.setAttribute('x', labelX);
                sourceLabel.setAttribute('y', labelY);
            }
        }
        if (targetLabelId) {
            const targetLabel = document.getElementById(targetLabelId);
            if (targetLabel) {
                // Update constraint center
                const oldCenterX = parseFloat(targetLabel.getAttribute('data-constraint-center-x'));
                const oldCenterY = parseFloat(targetLabel.getAttribute('data-constraint-center-y'));
                targetLabel.setAttribute('data-constraint-center-x', targetCenter.x);
                targetLabel.setAttribute('data-constraint-center-y', targetCenter.y);
                // Get constraint radius and current label position
                const radius = parseFloat(targetLabel.getAttribute('data-constraint-radius')) || 60;
                const currentX = parseFloat(targetLabel.getAttribute('x'));
                const currentY = parseFloat(targetLabel.getAttribute('y'));
                // Calculate current angle relative to OLD center
                let angle;
                if (!isNaN(oldCenterX) && !isNaN(oldCenterY)) {
                    const dx = currentX - oldCenterX;
                    const dy = currentY - oldCenterY;
                    angle = Math.atan2(dy, dx);
                } else {
                    // Fallback: use connection direction
                    const dx = sourceCenter.x - targetCenter.x;
                    const dy = sourceCenter.y - targetCenter.y;
                    angle = Math.atan2(dy, dx);
                }
                // Position label on constraint circle at the SAME angle relative to NEW center
                const labelX = targetCenter.x + Math.cos(angle) * radius;
                const labelY = targetCenter.y + Math.sin(angle) * radius;
                targetLabel.setAttribute('x', labelX);
                targetLabel.setAttribute('y', labelY);
            }
        }
        if (centerLabelId) {
            const centerLabel = document.getElementById(centerLabelId);
            if (centerLabel) {
                centerLabel.setAttribute('x', centerPoint.x);
                centerLabel.setAttribute('y', centerPoint.y);
            }
        }
    });
}
function $c9e04676a0cce4e6$export$6eb397713b08f485(shape) {
    const connectionIds = shape.dataset.connections;
    if (!connectionIds) return;
    const ids = connectionIds.split(',').filter((id)=>id);
    ids.forEach((connectionId)=>{
        const connection = document.getElementById(connectionId);
        if (connection) {
            // Get label IDs before removing the connection
            const sourceLabelId = connection.getAttribute('data-source-label-id');
            const targetLabelId = connection.getAttribute('data-target-label-id');
            const centerLabelId = connection.getAttribute('data-center-label-id');
            // Remove the connection line
            connection.remove();
            // Remove the separate label elements
            if (sourceLabelId) {
                const sourceLabel = document.getElementById(sourceLabelId);
                if (sourceLabel) sourceLabel.remove();
            }
            if (targetLabelId) {
                const targetLabel = document.getElementById(targetLabelId);
                if (targetLabel) targetLabel.remove();
            }
            if (centerLabelId) {
                const centerLabel = document.getElementById(centerLabelId);
                if (centerLabel) centerLabel.remove();
            }
        }
    });
}
function $c9e04676a0cce4e6$export$d552c449281dc8eb() {
    console.log('Migrating existing connections...');
    const connections = document.querySelectorAll('.connection');
    let migratedCount = 0;
    connections.forEach((connection)=>{
        const connectionId = connection.id;
        // Check if connection already has label IDs
        const hasSourceId = connection.getAttribute('data-source-label-id');
        const hasTargetId = connection.getAttribute('data-target-label-id');
        if (hasSourceId && hasTargetId) // Already migrated
        return;
        // Find the labels by their expected IDs based on connection ID
        const sourceLabel = document.getElementById(`label-${connectionId}-source`);
        const targetLabel = document.getElementById(`label-${connectionId}-target`);
        const centerLabel = document.getElementById(`label-${connectionId}-center`);
        // Set the data attributes if labels exist
        if (sourceLabel) {
            connection.setAttribute('data-source-label-id', sourceLabel.id);
            migratedCount++;
        }
        if (targetLabel) connection.setAttribute('data-target-label-id', targetLabel.id);
        if (centerLabel) connection.setAttribute('data-center-label-id', centerLabel.id);
    });
    if (migratedCount > 0) {
        console.log(`Migrated ${migratedCount} connections`);
        // Save the updated state
        (0, $4DKvQ.saveAppState)();
    } else console.log('No connections needed migration');
}

});
parcelRegister("4DKvQ", function(module, exports) {

$parcel$export(module.exports, "saveTopology", () => $360ee26689381257$export$56a347f484e72cdd);
$parcel$export(module.exports, "loadTopology", () => $360ee26689381257$export$f2ca600a9f0c1fa8);
$parcel$export(module.exports, "saveZoom", () => $360ee26689381257$export$69f667e2112e0566);
$parcel$export(module.exports, "loadZoom", () => $360ee26689381257$export$19ddffdfbf279a66);
$parcel$export(module.exports, "saveScrollPosition", () => $360ee26689381257$export$6ed27cb48b29daa8);
$parcel$export(module.exports, "loadScrollPosition", () => $360ee26689381257$export$fe2bb388ff4704a1);
$parcel$export(module.exports, "saveShapeCounter", () => $360ee26689381257$export$7f95d962b053a518);
$parcel$export(module.exports, "loadShapeCounter", () => $360ee26689381257$export$9f3e13f72fb4ec4a);
$parcel$export(module.exports, "saveConnectionCounter", () => $360ee26689381257$export$9ec8e92adace09fe);
$parcel$export(module.exports, "loadConnectionCounter", () => $360ee26689381257$export$df6f37dd9e83bc6c);
$parcel$export(module.exports, "saveAppState", () => $360ee26689381257$export$56d64b5914f816c4);
$parcel$export(module.exports, "clearStorage", () => $360ee26689381257$export$d7a0b846d036443e);
$parcel$export(module.exports, "hasSavedData", () => $360ee26689381257$export$86583c74458fdd1e);
/**
 * Storage service for persisting application state
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");
const $360ee26689381257$var$STORAGE_KEYS = {
    TOPOLOGY: 'topologyBuilder_topology',
    ZOOM: 'topologyBuilder_zoom',
    SCROLL: 'topologyBuilder_scroll',
    SHAPE_COUNTER: 'topologyBuilder_shapeCounter',
    CONNECTION_COUNTER: 'topologyBuilder_connectionCounter'
};
function $360ee26689381257$export$56a347f484e72cdd() {
    try {
        const shapes = Array.from((0, $162Oa.elements).topologyCanvas.querySelectorAll('.canvas-shape'));
        const connections = Array.from((0, $162Oa.elements).topologyCanvas.querySelectorAll('.connection'));
        const topology = {
            version: '1.0',
            saved: new Date().toISOString(),
            shapes: shapes.map((shape)=>{
                const shapeData = {
                    id: shape.id,
                    tagName: shape.tagName.toLowerCase(),
                    shapeType: shape.getAttribute('data-shape-type'),
                    layer: shape.parentElement?.id || 'shapesLayer',
                    attributes: Array.from(shape.attributes).reduce((acc, attr)=>{
                        // Skip internal attributes
                        if (attr.name !== 'class' && attr.name !== 'id') acc[attr.name] = attr.value;
                        return acc;
                    }, {}),
                    style: {
                        cursor: shape.style.cursor || ''
                    }
                };
                // For group elements (Cisco shapes), save the innerHTML
                if (shape.tagName.toLowerCase() === 'g') shapeData.innerHTML = shape.innerHTML;
                return shapeData;
            }),
            connections: connections.map((connection)=>{
                const sourceLabelId = connection.getAttribute('data-source-label-id');
                const targetLabelId = connection.getAttribute('data-target-label-id');
                const centerLabelId = connection.getAttribute('data-center-label-id');
                const sourceLabel = document.getElementById(sourceLabelId);
                const targetLabel = document.getElementById(targetLabelId);
                const centerLabel = document.getElementById(centerLabelId);
                const line = connection.querySelector('.connection-line');
                return {
                    id: connection.id,
                    sourceId: connection.getAttribute('data-source'),
                    targetId: connection.getAttribute('data-target'),
                    line: {
                        x1: line.getAttribute('x1'),
                        y1: line.getAttribute('y1'),
                        x2: line.getAttribute('x2'),
                        y2: line.getAttribute('y2'),
                        stroke: line.getAttribute('stroke') || '#6c757d',
                        strokeWidth: line.getAttribute('stroke-width') || '3',
                        strokeDasharray: line.getAttribute('stroke-dasharray') || ''
                    },
                    sourceLabel: sourceLabel ? {
                        text: sourceLabel.textContent || '',
                        x: sourceLabel.getAttribute('x') || '0',
                        y: sourceLabel.getAttribute('y') || '0',
                        dx: sourceLabel.getAttribute('dx') || '0',
                        dy: sourceLabel.getAttribute('dy') || '0',
                        textAnchor: sourceLabel.getAttribute('text-anchor') || 'start',
                        constraintCenterX: sourceLabel.getAttribute('data-constraint-center-x') || null,
                        constraintCenterY: sourceLabel.getAttribute('data-constraint-center-y') || null,
                        constraintRadius: sourceLabel.getAttribute('data-constraint-radius') || '60'
                    } : {
                        text: '',
                        x: '0',
                        y: '0',
                        dx: '-5',
                        dy: '-10',
                        textAnchor: 'end'
                    },
                    targetLabel: targetLabel ? {
                        text: targetLabel.textContent || '',
                        x: targetLabel.getAttribute('x') || '0',
                        y: targetLabel.getAttribute('y') || '0',
                        dx: targetLabel.getAttribute('dx') || '0',
                        dy: targetLabel.getAttribute('dy') || '0',
                        textAnchor: targetLabel.getAttribute('text-anchor') || 'start',
                        constraintCenterX: targetLabel.getAttribute('data-constraint-center-x') || null,
                        constraintCenterY: targetLabel.getAttribute('data-constraint-center-y') || null,
                        constraintRadius: targetLabel.getAttribute('data-constraint-radius') || '60'
                    } : {
                        text: '',
                        x: '0',
                        y: '0',
                        dx: '5',
                        dy: '-10',
                        textAnchor: 'start'
                    },
                    centerLabel: centerLabel ? {
                        text: centerLabel.textContent || '',
                        x: centerLabel.getAttribute('x') || '0',
                        y: centerLabel.getAttribute('y') || '0',
                        dx: centerLabel.getAttribute('dx') || '0',
                        dy: centerLabel.getAttribute('dy') || '0',
                        textAnchor: centerLabel.getAttribute('text-anchor') || 'middle',
                        fill: centerLabel.getAttribute('fill') || '#212529',
                        fontSize: centerLabel.getAttribute('font-size') || '12'
                    } : {
                        text: '',
                        x: '0',
                        y: '0',
                        dx: '0',
                        dy: '-5',
                        textAnchor: 'middle',
                        fill: '#212529',
                        fontSize: '12'
                    }
                };
            })
        };
        localStorage.setItem($360ee26689381257$var$STORAGE_KEYS.TOPOLOGY, JSON.stringify(topology));
        return true;
    } catch (error) {
        console.error('Error saving topology:', error);
        return false;
    }
}
function $360ee26689381257$export$f2ca600a9f0c1fa8() {
    try {
        const data = localStorage.getItem($360ee26689381257$var$STORAGE_KEYS.TOPOLOGY);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error('Error loading topology:', error);
        return null;
    }
}
function $360ee26689381257$export$69f667e2112e0566() {
    try {
        localStorage.setItem($360ee26689381257$var$STORAGE_KEYS.ZOOM, (0, $lwME4.appState).currentZoom.toString());
        return true;
    } catch (error) {
        console.error('Error saving zoom:', error);
        return false;
    }
}
function $360ee26689381257$export$19ddffdfbf279a66() {
    try {
        const zoom = localStorage.getItem($360ee26689381257$var$STORAGE_KEYS.ZOOM);
        return zoom ? parseFloat(zoom) : null;
    } catch (error) {
        console.error('Error loading zoom:', error);
        return null;
    }
}
function $360ee26689381257$export$6ed27cb48b29daa8() {
    try {
        const scroll = {
            left: (0, $162Oa.elements).canvasWrapper.scrollLeft,
            top: (0, $162Oa.elements).canvasWrapper.scrollTop
        };
        localStorage.setItem($360ee26689381257$var$STORAGE_KEYS.SCROLL, JSON.stringify(scroll));
        return true;
    } catch (error) {
        console.error('Error saving scroll position:', error);
        return false;
    }
}
function $360ee26689381257$export$fe2bb388ff4704a1() {
    try {
        const data = localStorage.getItem($360ee26689381257$var$STORAGE_KEYS.SCROLL);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error('Error loading scroll position:', error);
        return null;
    }
}
function $360ee26689381257$export$7f95d962b053a518() {
    try {
        localStorage.setItem($360ee26689381257$var$STORAGE_KEYS.SHAPE_COUNTER, (0, $lwME4.appState).shapeIdCounter.toString());
        return true;
    } catch (error) {
        console.error('Error saving shape counter:', error);
        return false;
    }
}
function $360ee26689381257$export$9f3e13f72fb4ec4a() {
    try {
        const counter = localStorage.getItem($360ee26689381257$var$STORAGE_KEYS.SHAPE_COUNTER);
        return counter ? parseInt(counter, 10) : null;
    } catch (error) {
        console.error('Error loading shape counter:', error);
        return null;
    }
}
function $360ee26689381257$export$9ec8e92adace09fe() {
    try {
        localStorage.setItem($360ee26689381257$var$STORAGE_KEYS.CONNECTION_COUNTER, (0, $lwME4.appState).connectionIdCounter.toString());
        return true;
    } catch (error) {
        console.error('Error saving connection counter:', error);
        return false;
    }
}
function $360ee26689381257$export$df6f37dd9e83bc6c() {
    try {
        const counter = localStorage.getItem($360ee26689381257$var$STORAGE_KEYS.CONNECTION_COUNTER);
        return counter ? parseInt(counter, 10) : null;
    } catch (error) {
        console.error('Error loading connection counter:', error);
        return null;
    }
}
function $360ee26689381257$export$56d64b5914f816c4() {
    $360ee26689381257$export$56a347f484e72cdd();
    $360ee26689381257$export$69f667e2112e0566();
    $360ee26689381257$export$6ed27cb48b29daa8();
    $360ee26689381257$export$7f95d962b053a518();
    $360ee26689381257$export$9ec8e92adace09fe();
}
function $360ee26689381257$export$d7a0b846d036443e() {
    try {
        Object.values($360ee26689381257$var$STORAGE_KEYS).forEach((key)=>{
            localStorage.removeItem(key);
        });
        return true;
    } catch (error) {
        console.error('Error clearing storage:', error);
        return false;
    }
}
function $360ee26689381257$export$86583c74458fdd1e() {
    return localStorage.getItem($360ee26689381257$var$STORAGE_KEYS.TOPOLOGY) !== null;
}

});

parcelRegister("cgpVJ", function(module, exports) {

$parcel$export(module.exports, "setShowOverlayCallback", () => $8edb17dd49790d32$export$2da22bb5ec9658f1);
$parcel$export(module.exports, "initializeConnectionInteractions", () => $8edb17dd49790d32$export$19253fe031074e03);
$parcel$export(module.exports, "addLabelListeners", () => $8edb17dd49790d32$export$c33cef3a4688f230);
$parcel$export(module.exports, "deselectAll", () => $8edb17dd49790d32$export$7a9dd4135e68de26);
/**
 * Connection and label selection, editing, and deletion
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $4DKvQ = parcelRequire("4DKvQ");

var $f2jpm = parcelRequire("f2jpm");
let $8edb17dd49790d32$export$706ea0c97e55182 = null;
let $8edb17dd49790d32$export$dc7980f0b0977f39 = null;
let $8edb17dd49790d32$var$editingLabel = null;
let $8edb17dd49790d32$var$showOverlayCallback = null;
function $8edb17dd49790d32$export$2da22bb5ec9658f1(callback) {
    $8edb17dd49790d32$var$showOverlayCallback = callback;
}
function $8edb17dd49790d32$export$19253fe031074e03() {
    // Add click handlers to existing connections and labels
    $8edb17dd49790d32$var$setupConnectionListeners();
    // Set up mutation observer to handle dynamically added connections/labels
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            mutation.addedNodes.forEach((node)=>{
                if (node.classList) {
                    if (node.classList.contains('connection')) $8edb17dd49790d32$var$addConnectionListeners(node);
                    else if (node.classList.contains('connection-label')) $8edb17dd49790d32$export$c33cef3a4688f230(node);
                }
            });
        });
    });
    observer.observe((0, $162Oa.elements).canvas, {
        childList: true,
        subtree: true
    });
    // Global delete key handler
    document.addEventListener('keydown', $8edb17dd49790d32$var$handleDeleteKey);
}
/**
 * Setup listeners for all existing connections and labels
 */ function $8edb17dd49790d32$var$setupConnectionListeners() {
    // Connections
    document.querySelectorAll('.connection').forEach($8edb17dd49790d32$var$addConnectionListeners);
    // Labels
    document.querySelectorAll('.connection-label').forEach($8edb17dd49790d32$export$c33cef3a4688f230);
}
/**
 * Add listeners to a connection
 * @param {SVGElement} connection - The connection element
 */ function $8edb17dd49790d32$var$addConnectionListeners(connection) {
    const line = connection.querySelector('.connection-line');
    const hitTarget = connection.querySelector('.connection-hit-target');
    if (!line) return;
    // Make the line interactive
    line.style.pointerEvents = 'auto';
    line.style.cursor = 'pointer';
    const clickHandler = (e)=>{
        e.stopPropagation();
        $8edb17dd49790d32$var$selectConnectionAndShowOverlay(connection);
    };
    line.addEventListener('click', clickHandler);
    // Also add listener to hit target if it exists
    if (hitTarget) hitTarget.addEventListener('click', clickHandler);
}
/**
 * Select a connection and show overlay to edit labels
 * @param {SVGElement} connection - The connection to select
 */ function $8edb17dd49790d32$var$selectConnectionAndShowOverlay(connection) {
    // Deselect everything else
    $8edb17dd49790d32$export$7a9dd4135e68de26();
    (0, $f2jpm.deselectShape)();
    $8edb17dd49790d32$export$706ea0c97e55182 = connection;
    connection.classList.add('selected');
    console.log('Selected connection:', connection.id);
    // Get the connection's labels
    const sourceLabelId = connection.getAttribute('data-source-label-id');
    const targetLabelId = connection.getAttribute('data-target-label-id');
    const centerLabelId = connection.getAttribute('data-center-label-id');
    const sourceLabel = document.getElementById(sourceLabelId);
    const targetLabel = document.getElementById(targetLabelId);
    const centerLabel = document.getElementById(centerLabelId);
    // Show connection panel with current properties (use callback to avoid circular dependency)
    if ($8edb17dd49790d32$var$showOverlayCallback) $8edb17dd49790d32$var$showOverlayCallback(connection, sourceLabel ? sourceLabel.textContent : '', targetLabel ? targetLabel.textContent : '', centerLabel ? centerLabel.textContent : '');
}
/**
 * Add listeners to a label
 * @param {SVGElement} label - The label element
 */ function $8edb17dd49790d32$export$c33cef3a4688f230(label) {
    // Labels are edited via the Connection Details modal, not inline
    // Just make them look interactive
    label.style.cursor = 'pointer';
}
/**
 * Select a connection
 * @param {SVGElement} connection - The connection to select
 */ function $8edb17dd49790d32$var$selectConnection(connection) {
    // Deselect everything else
    $8edb17dd49790d32$export$7a9dd4135e68de26();
    (0, $f2jpm.deselectShape)();
    $8edb17dd49790d32$export$706ea0c97e55182 = connection;
    connection.classList.add('selected');
    console.log('Selected connection:', connection.id);
}
/**
 * Select a label
 * @param {SVGElement} label - The label to select
 */ function $8edb17dd49790d32$var$selectLabel(label) {
    // Deselect everything else
    $8edb17dd49790d32$export$7a9dd4135e68de26();
    (0, $f2jpm.deselectShape)();
    $8edb17dd49790d32$export$dc7980f0b0977f39 = label;
    label.classList.add('selected');
    console.log('Selected label:', label.id);
}
function $8edb17dd49790d32$export$7a9dd4135e68de26() {
    // Deselect connection
    if ($8edb17dd49790d32$export$706ea0c97e55182) {
        $8edb17dd49790d32$export$706ea0c97e55182.classList.remove('selected');
        $8edb17dd49790d32$export$706ea0c97e55182 = null;
    }
    // Deselect label - clear from tracked variable
    if ($8edb17dd49790d32$export$dc7980f0b0977f39) {
        $8edb17dd49790d32$export$dc7980f0b0977f39.classList.remove('selected');
        $8edb17dd49790d32$export$dc7980f0b0977f39 = null;
    }
    // Also remove 'selected' class from any other labels that might have it
    // (defensive programming to prevent orphaned selections)
    document.querySelectorAll('.connection-label.selected').forEach((label)=>{
        label.classList.remove('selected');
    });
    // Stop editing if active
    if ($8edb17dd49790d32$var$editingLabel) $8edb17dd49790d32$var$stopEditingLabel(false);
}
/**
 * Start editing a label's text
 * @param {SVGElement} label - The label to edit
 */ function $8edb17dd49790d32$var$startEditingLabel(label) {
    if ($8edb17dd49790d32$var$editingLabel) {
        // Set the cleanup flag before calling stopEditingLabel to prevent blur handler from firing
        if ($8edb17dd49790d32$var$editingLabel._editorCleanupFlag) {
            // Get the closure and set it to true
            const previousLabel = $8edb17dd49790d32$var$editingLabel;
            const previousForeignObject = $8edb17dd49790d32$var$editingLabel._editorElement;
            if (previousForeignObject && previousForeignObject._setCleaningUp) previousForeignObject._setCleaningUp();
        }
        $8edb17dd49790d32$var$stopEditingLabel(true);
    }
    $8edb17dd49790d32$var$editingLabel = label;
    const currentText = label.textContent;
    // Create a foreign object to hold an input
    const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    const x = parseFloat(label.getAttribute('x'));
    const y = parseFloat(label.getAttribute('y'));
    foreignObject.setAttribute('x', x - 50);
    foreignObject.setAttribute('y', y - 20);
    foreignObject.setAttribute('width', 200);
    foreignObject.setAttribute('height', 40);
    foreignObject.setAttribute('class', 'label-editor-foreign');
    // Add a flag to track if cleanup is in progress
    let isCleaningUp = false;
    const input = document.createElement('input');
    input.type = 'text';
    input.value = currentText;
    input.className = 'form-control form-control-sm';
    input.style.fontSize = '12px';
    foreignObject.appendChild(input);
    // Store a function to set the cleanup flag from outside
    foreignObject._setCleaningUp = ()=>{
        isCleaningUp = true;
    };
    (0, $162Oa.elements).canvas.appendChild(foreignObject);
    // Focus and place cursor at the end
    input.focus();
    // Set cursor position to end of text
    input.setSelectionRange(input.value.length, input.value.length);
    // Save on blur or Enter
    input.addEventListener('blur', ()=>{
        // Only process if this editor is still active and not already cleaning up
        if ($8edb17dd49790d32$var$editingLabel === label && foreignObject.parentNode && !isCleaningUp) {
            isCleaningUp = true;
            label.textContent = input.value || currentText;
            foreignObject.remove();
            delete label._editorElement;
            $8edb17dd49790d32$var$editingLabel = null;
            (0, $4DKvQ.saveAppState)();
        }
    });
    input.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') input.blur();
        else if (e.key === 'Escape') // Only process if this editor is still active and not already cleaning up
        {
            if ($8edb17dd49790d32$var$editingLabel === label && foreignObject.parentNode && !isCleaningUp) {
                isCleaningUp = true;
                label.textContent = currentText;
                foreignObject.remove();
                delete label._editorElement;
                $8edb17dd49790d32$var$editingLabel = null;
            }
        }
    });
    // Store reference for cleanup
    label._editorElement = foreignObject;
    label._editorCleanupFlag = ()=>isCleaningUp;
}
/**
 * Stop editing a label
 * @param {boolean} save - Whether to save the changes
 */ function $8edb17dd49790d32$var$stopEditingLabel(save) {
    if (!$8edb17dd49790d32$var$editingLabel || !$8edb17dd49790d32$var$editingLabel._editorElement) return;
    const foreignObject = $8edb17dd49790d32$var$editingLabel._editorElement;
    const input = foreignObject.querySelector('input');
    // Check if already cleaning up (via blur/escape handler)
    if ($8edb17dd49790d32$var$editingLabel._editorCleanupFlag && $8edb17dd49790d32$var$editingLabel._editorCleanupFlag()) return;
    if (save && input) $8edb17dd49790d32$var$editingLabel.textContent = input.value || $8edb17dd49790d32$var$editingLabel.textContent;
    // Safely remove the foreign object
    try {
        if (foreignObject && foreignObject.parentNode) foreignObject.remove();
    } catch (e) {
    // Element already removed or not in DOM - this is fine
    }
    delete $8edb17dd49790d32$var$editingLabel._editorElement;
    delete $8edb17dd49790d32$var$editingLabel._editorCleanupFlag;
    $8edb17dd49790d32$var$editingLabel = null;
    if (save) (0, $4DKvQ.saveAppState)();
}
/**
 * Handle delete key press
 * @param {KeyboardEvent} e - The keyboard event
 */ function $8edb17dd49790d32$var$handleDeleteKey(e) {
    if (e.key !== 'Delete' && e.key !== 'Backspace') return;
    // Don't delete if typing in an input
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
    if ($8edb17dd49790d32$export$706ea0c97e55182) $8edb17dd49790d32$var$deleteConnection($8edb17dd49790d32$export$706ea0c97e55182);
    else if ($8edb17dd49790d32$export$dc7980f0b0977f39) $8edb17dd49790d32$var$deleteLabel($8edb17dd49790d32$export$dc7980f0b0977f39);
}
/**
 * Delete a connection and its labels
 * @param {SVGElement} connection - The connection to delete
 */ function $8edb17dd49790d32$var$deleteConnection(connection) {
    const sourceLabelId = connection.getAttribute('data-source-label-id');
    const targetLabelId = connection.getAttribute('data-target-label-id');
    // Remove labels
    if (sourceLabelId) {
        const sourceLabel = document.getElementById(sourceLabelId);
        if (sourceLabel) sourceLabel.remove();
    }
    if (targetLabelId) {
        const targetLabel = document.getElementById(targetLabelId);
        if (targetLabel) targetLabel.remove();
    }
    // Update shape connection data
    const sourceId = connection.getAttribute('data-source');
    const targetId = connection.getAttribute('data-target');
    const connectionId = connection.id;
    [
        sourceId,
        targetId
    ].forEach((shapeId)=>{
        const shape = document.getElementById(shapeId);
        if (shape && shape.dataset.connections) shape.dataset.connections = shape.dataset.connections.split(',').filter((id)=>id !== connectionId).join(',');
    });
    // Remove connection
    connection.remove();
    $8edb17dd49790d32$export$706ea0c97e55182 = null;
    (0, $4DKvQ.saveAppState)();
    console.log('Deleted connection:', connectionId);
}
/**
 * Delete a label
 * @param {SVGElement} label - The label to delete
 */ function $8edb17dd49790d32$var$deleteLabel(label) {
    if (!confirm('Delete this label?')) return;
    label.remove();
    $8edb17dd49790d32$export$dc7980f0b0977f39 = null;
    (0, $4DKvQ.saveAppState)();
    console.log('Deleted label:', label.id);
}
function $8edb17dd49790d32$export$c81fde0d35bf9a63(connection, text) {
    const line = connection.querySelector('.connection-line');
    if (!line) return;
    const x1 = parseFloat(line.getAttribute('x1'));
    const y1 = parseFloat(line.getAttribute('y1'));
    const x2 = parseFloat(line.getAttribute('x2'));
    const y2 = parseFloat(line.getAttribute('y2'));
    const centerX = (x1 + x2) / 2;
    const centerY = (y1 + y2) / 2;
    const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    const labelId = `label-${connection.id}-center`;
    label.id = labelId;
    label.setAttribute('x', centerX);
    label.setAttribute('y', centerY);
    label.setAttribute('text-anchor', 'middle');
    label.setAttribute('dy', '-5');
    label.setAttribute('fill', '#495057');
    label.setAttribute('font-size', '12');
    label.setAttribute('font-weight', 'bold');
    label.classList.add('connection-label');
    label.classList.add('connection-label-center');
    label.textContent = text;
    label.style.cursor = 'move';
    label.style.userSelect = 'none';
    (0, $162Oa.elements).canvas.appendChild(label);
    $8edb17dd49790d32$export$c33cef3a4688f230(label);
    // Make it draggable
    $8edb17dd49790d32$var$makeLabelDraggable(label);
    (0, $4DKvQ.saveAppState)();
    return label;
}
/**
 * Make a label draggable
 * @param {SVGElement} label - The label element
 */ function $8edb17dd49790d32$var$makeLabelDraggable(label) {
    let isDragging = false;
    let startX, startY, labelX, labelY;
    label.addEventListener('mousedown', (e)=>{
        if (e.button !== 0) return; // Only left click
        isDragging = true;
        const canvasRect = (0, $162Oa.elements).canvas.getBoundingClientRect();
        startX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
        startY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
        labelX = parseFloat(label.getAttribute('x'));
        labelY = parseFloat(label.getAttribute('y'));
        e.stopPropagation();
        e.preventDefault();
    });
    document.addEventListener('mousemove', (e)=>{
        if (!isDragging) return;
        const canvasRect = (0, $162Oa.elements).canvas.getBoundingClientRect();
        const currentX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
        const currentY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
        const dx = currentX - startX;
        const dy = currentY - startY;
        label.setAttribute('x', labelX + dx);
        label.setAttribute('y', labelY + dy);
    });
    document.addEventListener('mouseup', ()=>{
        if (isDragging) {
            isDragging = false;
            (0, $4DKvQ.saveAppState)();
        }
    });
}

});

parcelRegister("le39T", function(module, exports) {

$parcel$export(module.exports, "showAlert", () => $f73d5b041425bba4$export$de026b00723010c1);
/**
 * Bootstrap modal utility functions
 */ /**
 * Show an alert modal with a message
 * @param {string} message - The message to display
 * @param {string} title - The title (optional, defaults to "Alert")
 * @param {string} type - The type: 'info', 'warning', 'error', 'success' (optional)
 */ function $f73d5b041425bba4$export$de026b00723010c1(message, title = 'Alert', type = 'info') {
    const modal = document.getElementById('alertModal');
    const modalHeader = document.getElementById('alertModalHeader');
    const modalTitle = document.getElementById('alertModalTitle');
    const modalMessage = document.getElementById('alertModalMessage');
    const titleIcon = modalTitle.previousElementSibling;
    // Set title
    modalTitle.textContent = title;
    // Set message
    modalMessage.textContent = message;
    // Set icon and header color based on type
    modalHeader.className = 'modal-header';
    switch(type){
        case 'warning':
            modalHeader.classList.add('bg-warning', 'text-dark');
            titleIcon.className = 'bi bi-exclamation-triangle';
            break;
        case 'error':
            modalHeader.classList.add('bg-danger', 'text-white');
            titleIcon.className = 'bi bi-exclamation-circle';
            break;
        case 'success':
            modalHeader.classList.add('bg-success', 'text-white');
            titleIcon.className = 'bi bi-check-circle';
            break;
        default:
            modalHeader.classList.add('bg-info', 'text-white');
            titleIcon.className = 'bi bi-info-circle';
    }
    // Show the modal
    const bsModal = new bootstrap.Modal(modal);
    bsModal.show();
}
function $f73d5b041425bba4$export$2b8c3b960bb992d3(message, title, onConfirm, confirmBtnText = 'Confirm', confirmBtnClass = 'btn-primary') {
    // For now, we'll use the newTopologyModal pattern
    // In a more robust implementation, you'd create a reusable confirm modal
    // For this specific case, we're handling it in the fileOperations.js
    console.warn('showConfirm is not yet implemented as a generic function');
}

});


parcelRegister("hqYiK", function(module, exports) {

$parcel$export(module.exports, "showInteractionCircle", () => $cb13a4001a7bc520$export$f4165f844973bc6);
$parcel$export(module.exports, "hideInteractionCircle", () => $cb13a4001a7bc520$export$c774376366d7aacc);
$parcel$export(module.exports, "updateInteractionCirclePosition", () => $cb13a4001a7bc520$export$404f2baadb2ae77);
/**
 * Interactive circle overlay for shape actions
 * Shows a semi-transparent circle around a shape with left/right action zones
 */ parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $gLqu3 = parcelRequire("gLqu3");

var $1cdEC = parcelRequire("1cdEC");
let $cb13a4001a7bc520$var$interactionCircle = null;
let $cb13a4001a7bc520$var$leftHalfPath = null;
let $cb13a4001a7bc520$var$rightHalfPath = null;
let $cb13a4001a7bc520$var$currentShape = null;
let $cb13a4001a7bc520$var$isInitializing = false; // Flag to prevent immediate dismissal
const $cb13a4001a7bc520$var$CIRCLE_RADIUS = 80; // Larger than connection label constraint circle
function $cb13a4001a7bc520$export$f4165f844973bc6(shape) {
    console.log('showInteractionCircle called:', {
        shapeId: shape?.id,
        hasExistingCircle: !!$cb13a4001a7bc520$var$interactionCircle,
        currentShapeId: $cb13a4001a7bc520$var$currentShape?.id,
        isSameShape: $cb13a4001a7bc520$var$currentShape === shape,
        isInitializing: $cb13a4001a7bc520$var$isInitializing
    });
    // If the circle is already showing for this shape, don't reinitialize
    if ($cb13a4001a7bc520$var$currentShape === shape && ($cb13a4001a7bc520$var$interactionCircle || $cb13a4001a7bc520$var$isInitializing)) {
        console.log('Interaction circle already showing/initializing for this shape, ignoring');
        return;
    }
    $cb13a4001a7bc520$export$c774376366d7aacc();
    $cb13a4001a7bc520$var$isInitializing = true; // Set flag before showing
    $cb13a4001a7bc520$var$currentShape = shape;
    // Get shape bounds and calculate center
    const bounds = (0, $gLqu3.getShapeBounds)(shape);
    const centerX = bounds.x + bounds.width / 2;
    const centerY = bounds.y + bounds.height / 2;
    // Get shape type to determine overlay style
    const dataType = shape.getAttribute('data-shape-type');
    const isCiscoShape = shape.getAttribute('data-cisco') === 'true';
    const isBasicShape = shape.tagName === 'rect' || shape.tagName === 'ellipse' || shape.tagName === 'g' && shape.querySelector('rect, ellipse');
    const isCircle = shape.tagName === 'circle' || shape.tagName === 'g' && shape.querySelector('circle');
    const isLine = dataType === 'line' || dataType === 'arrow';
    // Create SVG group for the interaction overlay
    $cb13a4001a7bc520$var$interactionCircle = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    $cb13a4001a7bc520$var$interactionCircle.id = 'interaction-circle';
    $cb13a4001a7bc520$var$interactionCircle.style.pointerEvents = 'auto';
    // Create shape-specific overlay
    // Cisco shapes ALWAYS use circular overlay regardless of their actual shape
    if (isCiscoShape) $cb13a4001a7bc520$var$createCircularOverlay(centerX, centerY);
    else if (isLine) $cb13a4001a7bc520$var$createLineOverlay(shape, bounds, centerX, centerY);
    else if (isBasicShape || isCircle) $cb13a4001a7bc520$var$createShapeMatchingOverlay(shape, bounds, centerX, centerY);
    else // Default: circular overlay for text and other shapes
    $cb13a4001a7bc520$var$createCircularOverlay(centerX, centerY);
    // Insert the overlay BEFORE the shape so it appears behind it
    const shapesLayer = document.getElementById('shapesLayer');
    if (shapesLayer && shape.parentNode === shapesLayer) // Insert before the shape in the shapes layer
    shapesLayer.insertBefore($cb13a4001a7bc520$var$interactionCircle, shape);
    else {
        // Fallback: Insert before the shape in its current parent
        const parent = shape.parentNode;
        if (parent) parent.insertBefore($cb13a4001a7bc520$var$interactionCircle, shape);
        else // Last resort: add to canvas
        (0, $162Oa.elements).canvas.appendChild($cb13a4001a7bc520$var$interactionCircle);
    }
    // Set up click-outside handler after a delay to avoid catching the initial click
    setTimeout(()=>{
        $cb13a4001a7bc520$var$isInitializing = false;
        console.log('Interaction circle initialized, adding click-outside handler');
        document.addEventListener('click', $cb13a4001a7bc520$var$handleClickOutside, true);
    }, 300);
}
/**
 * Create circular overlay (for Cisco shapes and text)
 */ function $cb13a4001a7bc520$var$createCircularOverlay(centerX, centerY) {
    // Create background circle (full circle for visual reference)
    const bgCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    bgCircle.setAttribute('cx', centerX);
    bgCircle.setAttribute('cy', centerY);
    bgCircle.setAttribute('r', $cb13a4001a7bc520$var$CIRCLE_RADIUS);
    bgCircle.setAttribute('fill', 'none');
    bgCircle.setAttribute('stroke', '#007bff');
    bgCircle.setAttribute('stroke-width', '2');
    bgCircle.setAttribute('stroke-dasharray', '5,5');
    bgCircle.setAttribute('opacity', '0.3');
    // Create left half (Edit action) - clickable
    $cb13a4001a7bc520$var$leftHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    const leftHalfD = `M ${centerX},${centerY - $cb13a4001a7bc520$var$CIRCLE_RADIUS} A ${$cb13a4001a7bc520$var$CIRCLE_RADIUS},${$cb13a4001a7bc520$var$CIRCLE_RADIUS} 0 0,0 ${centerX},${centerY + $cb13a4001a7bc520$var$CIRCLE_RADIUS} Z`;
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('d', leftHalfD);
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('fill', '#28a745');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('opacity', '0.2');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke', '#28a745');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke-width', '2');
    $cb13a4001a7bc520$var$leftHalfPath.style.cursor = 'pointer';
    // Create right half (Connect action) - clickable
    $cb13a4001a7bc520$var$rightHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    const rightHalfD = `M ${centerX},${centerY - $cb13a4001a7bc520$var$CIRCLE_RADIUS} A ${$cb13a4001a7bc520$var$CIRCLE_RADIUS},${$cb13a4001a7bc520$var$CIRCLE_RADIUS} 0 0,1 ${centerX},${centerY + $cb13a4001a7bc520$var$CIRCLE_RADIUS} Z`;
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('d', rightHalfD);
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('fill', '#007bff');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('opacity', '0.2');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke', '#007bff');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke-width', '2');
    $cb13a4001a7bc520$var$rightHalfPath.style.cursor = 'pointer';
    // Add hover effects
    $cb13a4001a7bc520$var$addHoverEffects();
    // Add click handlers
    $cb13a4001a7bc520$var$addClickHandlers();
    // Add Bootstrap tooltips
    $cb13a4001a7bc520$var$addTooltips();
    // Assemble the overlay
    $cb13a4001a7bc520$var$interactionCircle.appendChild(bgCircle);
    $cb13a4001a7bc520$var$interactionCircle.appendChild($cb13a4001a7bc520$var$leftHalfPath);
    $cb13a4001a7bc520$var$interactionCircle.appendChild($cb13a4001a7bc520$var$rightHalfPath);
}
/**
 * Create shape-matching overlay (for basic shapes: rect, ellipse, circle)
 */ function $cb13a4001a7bc520$var$createShapeMatchingOverlay(shape, bounds, centerX, centerY) {
    const padding = 25; // Padding around the shape for easier clicking
    const x = bounds.x - padding;
    const y = bounds.y - padding;
    const width = bounds.width + padding * 2;
    const height = bounds.height + padding * 2;
    // Determine if it's a circle/ellipse or rectangle
    const isCircular = shape.tagName === 'circle' || shape.tagName === 'ellipse' || shape.tagName === 'g' && (shape.querySelector('circle') || shape.querySelector('ellipse'));
    if (isCircular) {
        // Use ellipse for circular shapes
        const rx = width / 2;
        const ry = height / 2;
        // Background outline
        const bgEllipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        bgEllipse.setAttribute('cx', centerX);
        bgEllipse.setAttribute('cy', centerY);
        bgEllipse.setAttribute('rx', rx);
        bgEllipse.setAttribute('ry', ry);
        bgEllipse.setAttribute('fill', 'none');
        bgEllipse.setAttribute('stroke', '#007bff');
        bgEllipse.setAttribute('stroke-width', '2');
        bgEllipse.setAttribute('stroke-dasharray', '5,5');
        bgEllipse.setAttribute('opacity', '0.3');
        // Left half (Edit)
        $cb13a4001a7bc520$var$leftHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('d', `M ${centerX},${centerY - ry} A ${rx},${ry} 0 0,0 ${centerX},${centerY + ry} Z`);
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('fill', '#28a745');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('opacity', '0.2');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke', '#28a745');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke-width', '2');
        $cb13a4001a7bc520$var$leftHalfPath.style.cursor = 'pointer';
        // Right half (Connect)
        $cb13a4001a7bc520$var$rightHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('d', `M ${centerX},${centerY - ry} A ${rx},${ry} 0 0,1 ${centerX},${centerY + ry} Z`);
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('fill', '#007bff');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('opacity', '0.2');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke', '#007bff');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke-width', '2');
        $cb13a4001a7bc520$var$rightHalfPath.style.cursor = 'pointer';
        $cb13a4001a7bc520$var$interactionCircle.appendChild(bgEllipse);
    } else {
        // Use rectangle for rectangular shapes
        // Background outline
        const bgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        bgRect.setAttribute('x', x);
        bgRect.setAttribute('y', y);
        bgRect.setAttribute('width', width);
        bgRect.setAttribute('height', height);
        bgRect.setAttribute('fill', 'none');
        bgRect.setAttribute('stroke', '#007bff');
        bgRect.setAttribute('stroke-width', '2');
        bgRect.setAttribute('stroke-dasharray', '5,5');
        bgRect.setAttribute('opacity', '0.3');
        bgRect.setAttribute('rx', '3');
        // Left half (Edit)
        $cb13a4001a7bc520$var$leftHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('x', x);
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('y', y);
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('width', width / 2);
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('height', height);
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('fill', '#28a745');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('opacity', '0.2');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke', '#28a745');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke-width', '2');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('rx', '3');
        $cb13a4001a7bc520$var$leftHalfPath.style.cursor = 'pointer';
        // Right half (Connect)
        $cb13a4001a7bc520$var$rightHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('x', centerX);
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('y', y);
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('width', width / 2);
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('height', height);
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('fill', '#007bff');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('opacity', '0.2');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke', '#007bff');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke-width', '2');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('rx', '3');
        $cb13a4001a7bc520$var$rightHalfPath.style.cursor = 'pointer';
        $cb13a4001a7bc520$var$interactionCircle.appendChild(bgRect);
    }
    // Add hover effects
    $cb13a4001a7bc520$var$addHoverEffects();
    // Add click handlers
    $cb13a4001a7bc520$var$addClickHandlers();
    // Add Bootstrap tooltips
    $cb13a4001a7bc520$var$addTooltips();
    // Assemble the overlay
    $cb13a4001a7bc520$var$interactionCircle.appendChild($cb13a4001a7bc520$var$leftHalfPath);
    $cb13a4001a7bc520$var$interactionCircle.appendChild($cb13a4001a7bc520$var$rightHalfPath);
}
/**
 * Create line/arrow overlay (rotated rectangle following the line)
 */ function $cb13a4001a7bc520$var$createLineOverlay(shape, bounds, centerX, centerY) {
    const padding = 30; // Padding around the line for easier clicking
    // Get line endpoints
    let x1, y1, x2, y2;
    const dataType = shape.getAttribute('data-shape-type');
    if (dataType === 'line') {
        const line = shape.tagName === 'line' ? shape : shape.querySelector('line');
        if (line) {
            x1 = parseFloat(line.getAttribute('x1'));
            y1 = parseFloat(line.getAttribute('y1'));
            x2 = parseFloat(line.getAttribute('x2'));
            y2 = parseFloat(line.getAttribute('y2'));
        }
    } else if (dataType === 'arrow') {
        const line = shape.querySelector('.arrow-line');
        if (line) {
            x1 = parseFloat(line.getAttribute('x1'));
            y1 = parseFloat(line.getAttribute('y1'));
            x2 = parseFloat(line.getAttribute('x2'));
            y2 = parseFloat(line.getAttribute('y2'));
        }
    }
    if (x1 === undefined) return $cb13a4001a7bc520$var$createCircularOverlay(centerX, centerY); // Fallback
    // Calculate angle
    const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
    const length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    const width = 40; // Width of the overlay box
    // Create a rotated rectangle
    const bgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    bgRect.setAttribute('x', -length / 2 - padding);
    bgRect.setAttribute('y', -width / 2);
    bgRect.setAttribute('width', length + padding * 2);
    bgRect.setAttribute('height', width);
    bgRect.setAttribute('fill', 'none');
    bgRect.setAttribute('stroke', '#007bff');
    bgRect.setAttribute('stroke-width', '2');
    bgRect.setAttribute('stroke-dasharray', '5,5');
    bgRect.setAttribute('opacity', '0.3');
    bgRect.setAttribute('rx', '5');
    bgRect.setAttribute('transform', `translate(${centerX}, ${centerY}) rotate(${angle})`);
    // Left half (Edit)
    $cb13a4001a7bc520$var$leftHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('x', -length / 2 - padding);
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('y', -width / 2);
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('width', (length + padding * 2) / 2);
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('height', width);
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('fill', '#28a745');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('opacity', '0.2');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke', '#28a745');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('stroke-width', '2');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('rx', '5');
    $cb13a4001a7bc520$var$leftHalfPath.setAttribute('transform', `translate(${centerX}, ${centerY}) rotate(${angle})`);
    $cb13a4001a7bc520$var$leftHalfPath.style.cursor = 'pointer';
    // Right half (Connect)
    $cb13a4001a7bc520$var$rightHalfPath = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('x', 0);
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('y', -width / 2);
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('width', (length + padding * 2) / 2);
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('height', width);
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('fill', '#007bff');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('opacity', '0.2');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke', '#007bff');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('stroke-width', '2');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('rx', '5');
    $cb13a4001a7bc520$var$rightHalfPath.setAttribute('transform', `translate(${centerX}, ${centerY}) rotate(${angle})`);
    $cb13a4001a7bc520$var$rightHalfPath.style.cursor = 'pointer';
    // Add hover effects
    $cb13a4001a7bc520$var$addHoverEffects();
    // Add click handlers
    $cb13a4001a7bc520$var$addClickHandlers();
    // Add hover effects
    $cb13a4001a7bc520$var$addHoverEffects();
    // Add click handlers
    $cb13a4001a7bc520$var$addClickHandlers();
    // Add Bootstrap tooltips
    $cb13a4001a7bc520$var$addTooltips();
    // Assemble the overlay
    $cb13a4001a7bc520$var$interactionCircle.appendChild(bgRect);
    $cb13a4001a7bc520$var$interactionCircle.appendChild($cb13a4001a7bc520$var$leftHalfPath);
    $cb13a4001a7bc520$var$interactionCircle.appendChild($cb13a4001a7bc520$var$rightHalfPath);
}
/**
 * Add hover effects to the half paths
 */ function $cb13a4001a7bc520$var$addHoverEffects() {
    if ($cb13a4001a7bc520$var$leftHalfPath) {
        $cb13a4001a7bc520$var$leftHalfPath.addEventListener('mouseenter', ()=>{
            $cb13a4001a7bc520$var$leftHalfPath.setAttribute('opacity', '0.4');
        });
        $cb13a4001a7bc520$var$leftHalfPath.addEventListener('mouseleave', ()=>{
            $cb13a4001a7bc520$var$leftHalfPath.setAttribute('opacity', '0.2');
        });
    }
    if ($cb13a4001a7bc520$var$rightHalfPath) {
        $cb13a4001a7bc520$var$rightHalfPath.addEventListener('mouseenter', ()=>{
            $cb13a4001a7bc520$var$rightHalfPath.setAttribute('opacity', '0.4');
        });
        $cb13a4001a7bc520$var$rightHalfPath.addEventListener('mouseleave', ()=>{
            $cb13a4001a7bc520$var$rightHalfPath.setAttribute('opacity', '0.2');
        });
    }
}
/**
 * Add click handlers to the half paths
 */ function $cb13a4001a7bc520$var$addClickHandlers() {
    if ($cb13a4001a7bc520$var$leftHalfPath) $cb13a4001a7bc520$var$leftHalfPath.addEventListener('click', (e)=>{
        e.stopPropagation();
        $cb13a4001a7bc520$var$hideTooltips();
        if ($cb13a4001a7bc520$var$currentShape) (0, $1cdEC.showOverlayPanel)($cb13a4001a7bc520$var$currentShape);
    });
    if ($cb13a4001a7bc520$var$rightHalfPath) $cb13a4001a7bc520$var$rightHalfPath.addEventListener('click', (e)=>{
        e.stopPropagation();
        $cb13a4001a7bc520$var$hideTooltips();
        if ($cb13a4001a7bc520$var$currentShape) {
            (0, $1cdEC.startConnectionFromShape)($cb13a4001a7bc520$var$currentShape);
            $cb13a4001a7bc520$export$c774376366d7aacc();
        }
    });
}
/**
 * Add Bootstrap tooltips to the half paths
 */ function $cb13a4001a7bc520$var$addTooltips() {
    if ($cb13a4001a7bc520$var$leftHalfPath) {
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('data-bs-toggle', 'tooltip');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('data-bs-placement', 'top');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('data-bs-title', 'Edit');
        $cb13a4001a7bc520$var$leftHalfPath.setAttribute('data-bs-trigger', 'hover');
        // Initialize Bootstrap tooltip
        new window.bootstrap.Tooltip($cb13a4001a7bc520$var$leftHalfPath, {
            container: 'body',
            trigger: 'hover'
        });
    }
    if ($cb13a4001a7bc520$var$rightHalfPath) {
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('data-bs-toggle', 'tooltip');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('data-bs-placement', 'top');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('data-bs-title', 'Connect');
        $cb13a4001a7bc520$var$rightHalfPath.setAttribute('data-bs-trigger', 'hover');
        // Initialize Bootstrap tooltip
        new window.bootstrap.Tooltip($cb13a4001a7bc520$var$rightHalfPath, {
            container: 'body',
            trigger: 'hover'
        });
    }
}
/**
 * Hide all tooltips for the interaction overlay
 */ function $cb13a4001a7bc520$var$hideTooltips() {
    try {
        if ($cb13a4001a7bc520$var$leftHalfPath) {
            const leftTooltipInstance = window.bootstrap.Tooltip.getInstance($cb13a4001a7bc520$var$leftHalfPath);
            if (leftTooltipInstance) leftTooltipInstance.hide();
        }
    } catch (error) {
        console.debug('Error hiding left tooltip:', error);
    }
    try {
        if ($cb13a4001a7bc520$var$rightHalfPath) {
            const rightTooltipInstance = window.bootstrap.Tooltip.getInstance($cb13a4001a7bc520$var$rightHalfPath);
            if (rightTooltipInstance) rightTooltipInstance.hide();
        }
    } catch (error) {
        console.debug('Error hiding right tooltip:', error);
    }
}
function $cb13a4001a7bc520$export$c774376366d7aacc() {
    if ($cb13a4001a7bc520$var$interactionCircle) {
        // Dispose of Bootstrap tooltips before removing elements
        try {
            if ($cb13a4001a7bc520$var$leftHalfPath) {
                const leftTooltipInstance = window.bootstrap.Tooltip.getInstance($cb13a4001a7bc520$var$leftHalfPath);
                if (leftTooltipInstance) leftTooltipInstance.dispose();
            }
        } catch (error) {
            console.debug('Error disposing left tooltip:', error);
        }
        try {
            if ($cb13a4001a7bc520$var$rightHalfPath) {
                const rightTooltipInstance = window.bootstrap.Tooltip.getInstance($cb13a4001a7bc520$var$rightHalfPath);
                if (rightTooltipInstance) rightTooltipInstance.dispose();
            }
        } catch (error) {
            console.debug('Error disposing right tooltip:', error);
        }
        $cb13a4001a7bc520$var$interactionCircle.remove();
        $cb13a4001a7bc520$var$interactionCircle = null;
        $cb13a4001a7bc520$var$leftHalfPath = null;
        $cb13a4001a7bc520$var$rightHalfPath = null;
        $cb13a4001a7bc520$var$currentShape = null;
        $cb13a4001a7bc520$var$isInitializing = false;
        document.removeEventListener('click', $cb13a4001a7bc520$var$handleClickOutside, true);
    }
}
/**
 * Handle click on left half (Edit action)
 */ function $cb13a4001a7bc520$var$handleLeftHalfClick() {
    if ($cb13a4001a7bc520$var$currentShape) (0, $1cdEC.showOverlayPanel)($cb13a4001a7bc520$var$currentShape);
    $cb13a4001a7bc520$export$c774376366d7aacc();
}
/**
 * Handle click on right half (Connect action)
 */ function $cb13a4001a7bc520$var$handleRightHalfClick() {
    if ($cb13a4001a7bc520$var$currentShape) (0, $1cdEC.startConnectionFromShape)($cb13a4001a7bc520$var$currentShape);
    $cb13a4001a7bc520$export$c774376366d7aacc();
}
/**
 * Handle clicks outside the circle
 * @param {MouseEvent} e - Click event
 */ function $cb13a4001a7bc520$var$handleClickOutside(e) {
    console.log('handleClickOutside triggered:', {
        isInitializing: $cb13a4001a7bc520$var$isInitializing,
        target: e.target.id || e.target.tagName,
        hasInteractionCircle: !!$cb13a4001a7bc520$var$interactionCircle
    });
    // Don't process if we're still initializing
    if ($cb13a4001a7bc520$var$isInitializing) {
        console.log('Still initializing, ignoring click');
        return;
    }
    // Get the actual element at the click position (important for SVG elements)
    const clickedElement = document.elementFromPoint(e.clientX, e.clientY);
    console.log('Actual clicked element:', {
        id: clickedElement?.id,
        tagName: clickedElement?.tagName,
        classList: Array.from(clickedElement?.classList || [])
    });
    // Don't hide if clicking on the circle elements themselves
    // Don't stop propagation - let the event reach the circle half handlers
    if (clickedElement === $cb13a4001a7bc520$var$leftHalfPath || clickedElement === $cb13a4001a7bc520$var$rightHalfPath) {
        console.log('Clicked on circle half, ignoring in handleClickOutside');
        return;
    }
    // Don't hide if clicking within the interaction circle group
    if ($cb13a4001a7bc520$var$interactionCircle && $cb13a4001a7bc520$var$interactionCircle.contains(clickedElement)) {
        console.log('Clicked inside interaction circle, ignoring');
        return;
    }
    // Don't hide if clicking on the shape itself
    if ($cb13a4001a7bc520$var$currentShape && (clickedElement === $cb13a4001a7bc520$var$currentShape || $cb13a4001a7bc520$var$currentShape.contains(clickedElement))) {
        console.log('Clicked on shape, ignoring');
        return;
    }
    // Don't hide if clicking on ANY shape on the canvas (not just the current one)
    const clickedOnShape = clickedElement?.closest('.canvas-shape, .cisco-shape, g[data-shape-id]');
    if (clickedOnShape) {
        console.log('Clicked on a shape, ignoring');
        return;
    }
    // Don't hide if clicking on a resize handle
    if (clickedElement?.classList.contains('resize-handle')) {
        console.log('Clicked on resize handle, ignoring');
        return;
    }
    // Hide tooltips and circle for any other click
    console.log('Hiding interaction circle - click was outside');
    $cb13a4001a7bc520$var$hideTooltips();
    $cb13a4001a7bc520$export$c774376366d7aacc();
}
function $cb13a4001a7bc520$export$404f2baadb2ae77(shape) {
    // If no interaction circle exists, nothing to update
    if (!$cb13a4001a7bc520$var$interactionCircle) return;
    // Check if this is the same shape by ID (handles case where DOM element was replaced)
    const isSameShapeById = $cb13a4001a7bc520$var$currentShape && shape && $cb13a4001a7bc520$var$currentShape.getAttribute('id') === shape.getAttribute('id');
    // Only update if it's the current shape (by reference or ID)
    if ($cb13a4001a7bc520$var$currentShape !== shape && !isSameShapeById) return;
    // Simply recreate the overlay with updated position
    $cb13a4001a7bc520$export$c774376366d7aacc();
    $cb13a4001a7bc520$export$f4165f844973bc6(shape);
}

});
parcelRegister("1cdEC", function(module, exports) {

$parcel$export(module.exports, "initializeShapeOverlay", () => $0df180e0a21dca5a$export$b3a2f0e7441d41b5);
$parcel$export(module.exports, "isInConnectionMode", () => $0df180e0a21dca5a$export$a1ab752282f1a407);
$parcel$export(module.exports, "handleTargetShapeClick", () => $0df180e0a21dca5a$export$b0145e7e102c7ffe);
$parcel$export(module.exports, "showOverlayPanel", () => $0df180e0a21dca5a$export$f2e0e248fee33266);
$parcel$export(module.exports, "hideOverlayPanel", () => $0df180e0a21dca5a$export$50132675b7c847d9);
$parcel$export(module.exports, "startConnectionFromShape", () => $0df180e0a21dca5a$export$f099c7a917e14c30);
/**
 * Shape overlay panel for connection creation and other shape actions
 */ parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $hkA3I = parcelRequire("hkA3I");

var $4DKvQ = parcelRequire("4DKvQ");

var $cgpVJ = parcelRequire("cgpVJ");

var $le39T = parcelRequire("le39T");
parcelRequire("89InF");

var $9srb1 = parcelRequire("9srb1");
let $0df180e0a21dca5a$var$overlaySourceShape = null;
let $0df180e0a21dca5a$var$selectedConnection = null;
let $0df180e0a21dca5a$var$isWaitingForTarget = false;
let $0df180e0a21dca5a$var$connectionClickHandler = null;
// Dragging state for shape panel
let $0df180e0a21dca5a$var$isShapePanelDragging = false;
let $0df180e0a21dca5a$var$shapePanelDragOffsetX = 0;
let $0df180e0a21dca5a$var$shapePanelDragOffsetY = 0;
// Dragging state for connection panel
let $0df180e0a21dca5a$var$isConnectionPanelDragging = false;
let $0df180e0a21dca5a$var$connectionPanelDragOffsetX = 0;
let $0df180e0a21dca5a$var$connectionPanelDragOffsetY = 0;
function $0df180e0a21dca5a$export$b3a2f0e7441d41b5() {
    // Register the callback to avoid circular dependency
    (0, $cgpVJ.setShowOverlayCallback)($0df180e0a21dca5a$export$94d7fe6439e0775a);
    // Shape panel controls
    (0, $162Oa.elements).closeOverlayPanel.addEventListener('click', $0df180e0a21dca5a$var$hideShapePanel);
    // Start connection button (if it exists - may be removed in some versions)
    if ((0, $162Oa.elements).startConnectionBtn) (0, $162Oa.elements).startConnectionBtn.addEventListener('click', $0df180e0a21dca5a$var$startConnectionMode);
    // Apply Changes button for shape attributes
    if ((0, $162Oa.elements).applyShapeChanges) (0, $162Oa.elements).applyShapeChanges.addEventListener('click', $0df180e0a21dca5a$var$applyShapeChanges);
    // New action buttons
    const duplicateBtn = document.getElementById('duplicateShape');
    if (duplicateBtn) duplicateBtn.addEventListener('click', ()=>{
        if ($0df180e0a21dca5a$var$overlaySourceShape) {
            const shapeId = $0df180e0a21dca5a$var$overlaySourceShape.id;
            (0, $9srb1.duplicateShape)(shapeId);
            // Don't hide panel immediately - let user see the result
            setTimeout(()=>$0df180e0a21dca5a$var$hideShapePanel(), 100);
        }
    });
    const moveToFrontBtn = document.getElementById('moveToFront');
    if (moveToFrontBtn) moveToFrontBtn.addEventListener('click', ()=>{
        if ($0df180e0a21dca5a$var$overlaySourceShape) {
            const shapeId = $0df180e0a21dca5a$var$overlaySourceShape.id;
            (0, $9srb1.moveShapeToFront)(shapeId);
        }
    });
    const moveToBackBtn = document.getElementById('moveToBack');
    if (moveToBackBtn) moveToBackBtn.addEventListener('click', ()=>{
        if ($0df180e0a21dca5a$var$overlaySourceShape) {
            const shapeId = $0df180e0a21dca5a$var$overlaySourceShape.id;
            (0, $9srb1.moveShapeToBack)(shapeId);
        }
    });
    // Add Enter key handler for shape panel inputs
    const shapeInputs = [
        (0, $162Oa.elements).shapeLabelText,
        (0, $162Oa.elements).shapeLabelFontSize
    ];
    shapeInputs.forEach((input)=>{
        if (input) input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                $0df180e0a21dca5a$var$applyShapeChanges();
            }
        });
    });
    // Connection panel controls
    (0, $162Oa.elements).closeConnectionPanel.addEventListener('click', $0df180e0a21dca5a$var$hideConnectionPanel);
    if ((0, $162Oa.elements).applyConnectionChanges) (0, $162Oa.elements).applyConnectionChanges.addEventListener('click', $0df180e0a21dca5a$var$applyConnectionChanges);
    // Add Enter key handler for connection panel inputs
    const connectionInputs = [
        (0, $162Oa.elements).connectionCenterLabel,
        (0, $162Oa.elements).connectionSourceLabel,
        (0, $162Oa.elements).connectionTargetLabel,
        (0, $162Oa.elements).connectionLabelFontSize
    ];
    connectionInputs.forEach((input)=>{
        if (input) input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                $0df180e0a21dca5a$var$applyConnectionChanges();
            }
        });
    });
    // Make shape panel draggable by its header
    const shapePanelHeader = document.getElementById('overlayPanelHeader');
    if (shapePanelHeader) shapePanelHeader.addEventListener('mousedown', $0df180e0a21dca5a$var$startShapePanelDrag);
    // Make connection panel draggable by its header
    const connectionPanelHeader = document.getElementById('connectionPanelHeader');
    if (connectionPanelHeader) connectionPanelHeader.addEventListener('mousedown', $0df180e0a21dca5a$var$startConnectionPanelDrag);
    // Add global Escape key handler to close panels
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') {
            // Close shape panel if visible
            if ((0, $162Oa.elements).shapeOverlayPanel.style.display !== 'none') {
                $0df180e0a21dca5a$var$hideShapePanel();
                e.preventDefault();
            } else if ((0, $162Oa.elements).connectionOverlayPanel.style.display !== 'none') {
                $0df180e0a21dca5a$var$hideConnectionPanel();
                e.preventDefault();
            }
        }
    });
    // Close panels when clicking outside
    document.addEventListener('click', (e)=>{
        // Close shape panel if clicking outside
        if ((0, $162Oa.elements).shapeOverlayPanel.style.display !== 'none' && !(0, $162Oa.elements).shapeOverlayPanel.contains(e.target) && !e.target.classList.contains('canvas-shape') && !e.target.classList.contains('cisco-shape') && !$0df180e0a21dca5a$var$isWaitingForTarget) $0df180e0a21dca5a$var$hideShapePanel();
        // Close connection panel if clicking outside
        if ((0, $162Oa.elements).connectionOverlayPanel.style.display !== 'none' && !(0, $162Oa.elements).connectionOverlayPanel.contains(e.target) && !e.target.classList.contains('connection-line')) $0df180e0a21dca5a$var$hideConnectionPanel();
    });
}
/**
 * Start dragging the shape panel
 * @param {MouseEvent} e - Mouse event
 */ function $0df180e0a21dca5a$var$startShapePanelDrag(e) {
    // Don't drag if clicking the close button
    if (e.target.classList.contains('btn-close')) return;
    $0df180e0a21dca5a$var$isShapePanelDragging = true;
    const panel = (0, $162Oa.elements).shapeOverlayPanel;
    const rect = panel.getBoundingClientRect();
    $0df180e0a21dca5a$var$shapePanelDragOffsetX = e.clientX - rect.left;
    $0df180e0a21dca5a$var$shapePanelDragOffsetY = e.clientY - rect.top;
    document.addEventListener('mousemove', $0df180e0a21dca5a$var$doShapePanelDrag);
    document.addEventListener('mouseup', $0df180e0a21dca5a$var$stopShapePanelDrag);
    e.preventDefault();
}
/**
 * Drag the shape panel
 * @param {MouseEvent} e - Mouse event
 */ function $0df180e0a21dca5a$var$doShapePanelDrag(e) {
    if (!$0df180e0a21dca5a$var$isShapePanelDragging) return;
    const panel = (0, $162Oa.elements).shapeOverlayPanel;
    let newLeft = e.clientX - $0df180e0a21dca5a$var$shapePanelDragOffsetX;
    let newTop = e.clientY - $0df180e0a21dca5a$var$shapePanelDragOffsetY;
    // Keep panel within viewport
    const panelRect = panel.getBoundingClientRect();
    const maxLeft = window.innerWidth - panelRect.width;
    const maxTop = window.innerHeight - panelRect.height;
    newLeft = Math.max(0, Math.min(newLeft, maxLeft));
    newTop = Math.max(0, Math.min(newTop, maxTop));
    panel.style.left = `${newLeft}px`;
    panel.style.top = `${newTop}px`;
}
/**
 * Stop dragging the shape panel
 */ function $0df180e0a21dca5a$var$stopShapePanelDrag() {
    $0df180e0a21dca5a$var$isShapePanelDragging = false;
    document.removeEventListener('mousemove', $0df180e0a21dca5a$var$doShapePanelDrag);
    document.removeEventListener('mouseup', $0df180e0a21dca5a$var$stopShapePanelDrag);
}
/**
 * Start dragging the connection panel
 * @param {MouseEvent} e - Mouse event
 */ function $0df180e0a21dca5a$var$startConnectionPanelDrag(e) {
    // Don't drag if clicking the close button
    if (e.target.classList.contains('btn-close')) return;
    $0df180e0a21dca5a$var$isConnectionPanelDragging = true;
    const panel = (0, $162Oa.elements).connectionOverlayPanel;
    const rect = panel.getBoundingClientRect();
    $0df180e0a21dca5a$var$connectionPanelDragOffsetX = e.clientX - rect.left;
    $0df180e0a21dca5a$var$connectionPanelDragOffsetY = e.clientY - rect.top;
    document.addEventListener('mousemove', $0df180e0a21dca5a$var$doConnectionPanelDrag);
    document.addEventListener('mouseup', $0df180e0a21dca5a$var$stopConnectionPanelDrag);
    e.preventDefault();
}
/**
 * Drag the connection panel
 * @param {MouseEvent} e - Mouse event
 */ function $0df180e0a21dca5a$var$doConnectionPanelDrag(e) {
    if (!$0df180e0a21dca5a$var$isConnectionPanelDragging) return;
    const panel = (0, $162Oa.elements).connectionOverlayPanel;
    let newLeft = e.clientX - $0df180e0a21dca5a$var$connectionPanelDragOffsetX;
    let newTop = e.clientY - $0df180e0a21dca5a$var$connectionPanelDragOffsetY;
    // Keep panel within viewport
    const panelRect = panel.getBoundingClientRect();
    const maxLeft = window.innerWidth - panelRect.width;
    const maxTop = window.innerHeight - panelRect.height;
    newLeft = Math.max(0, Math.min(newLeft, maxLeft));
    newTop = Math.max(0, Math.min(newTop, maxTop));
    panel.style.left = `${newLeft}px`;
    panel.style.top = `${newTop}px`;
}
/**
 * Stop dragging the connection panel
 */ function $0df180e0a21dca5a$var$stopConnectionPanelDrag() {
    $0df180e0a21dca5a$var$isConnectionPanelDragging = false;
    document.removeEventListener('mousemove', $0df180e0a21dca5a$var$doConnectionPanelDrag);
    document.removeEventListener('mouseup', $0df180e0a21dca5a$var$stopConnectionPanelDrag);
}

/**
 * Update shape label text
 */ function $0df180e0a21dca5a$var$updateShapeLabel() {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    const dataType = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-shape-type');
    const isTextShape = dataType === 'text';
    const isCiscoShape = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-cisco') === 'true';
    const isBasicShape = $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'circle' || $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'rect' || $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'ellipse';
    // For text shapes, update the text-content element
    if (isTextShape) {
        const labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('.text-content');
        if (labelEl) {
            labelEl.textContent = (0, $162Oa.elements).shapeLabelText.value;
            const { updateTextBackground: updateTextBackground } = (parcelRequire("gLqu3"));
            updateTextBackground($0df180e0a21dca5a$var$overlaySourceShape);
        }
        return;
    }
    // Find the label element based on shape type
    // For basic shapes: look for sibling label with matching shape-id
    // For Cisco shapes: look for child text without data-label
    // For groups: look for child text with data-label="true"
    let labelEl;
    if (isBasicShape) {
        const shapeId = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('id');
        labelEl = $0df180e0a21dca5a$var$overlaySourceShape.parentNode.querySelector(`text[data-shape-id="${shapeId}"]`);
    } else labelEl = isCiscoShape ? $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text:not([data-label])') : $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text[data-label="true"]');
    const labelText = (0, $162Oa.elements).shapeLabelText.value;
    // If label element doesn't exist and text is provided, create it
    if (!labelEl && labelText) {
        // For basic shapes (circle, rect, ellipse), add label as a sibling element
        if (isBasicShape) {
            console.log('Adding label to basic shape as sibling element');
            // Create label element
            labelEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            labelEl.setAttribute('data-label', 'true');
            labelEl.setAttribute('fill', (0, $162Oa.elements).shapeLabelColor.value || '#333333');
            labelEl.setAttribute('font-size', (0, $162Oa.elements).shapeLabelFontSize.value || '14');
            labelEl.setAttribute('font-weight', 'normal');
            labelEl.setAttribute('data-position', (0, $162Oa.elements).shapeLabelPosition.value || 'below');
            labelEl.setAttribute('text-anchor', 'middle');
            labelEl.textContent = labelText;
            // Store reference to label on shape and vice versa
            const shapeId = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('id');
            labelEl.setAttribute('data-shape-id', shapeId);
            $0df180e0a21dca5a$var$overlaySourceShape.setAttribute('data-has-label', 'true');
            // Add label to the same parent (canvas layer)
            $0df180e0a21dca5a$var$overlaySourceShape.parentNode.appendChild(labelEl);
            // Position the label based on shape dimensions and position
            $0df180e0a21dca5a$var$updateShapeLabelPosition();
            console.log('Label added as sibling to basic shape');
            return; // Exit early, label is created
        }
        // For Cisco shapes and groups, add label as child (existing behavior)
        labelEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        labelEl.setAttribute('data-label', 'true');
        labelEl.setAttribute('fill', (0, $162Oa.elements).shapeLabelColor.value || '#333333');
        labelEl.setAttribute('font-size', (0, $162Oa.elements).shapeLabelFontSize.value || '14');
        labelEl.setAttribute('font-weight', 'normal');
        labelEl.setAttribute('data-position', (0, $162Oa.elements).shapeLabelPosition.value || 'below');
        labelEl.setAttribute('text-anchor', 'middle');
        $0df180e0a21dca5a$var$overlaySourceShape.appendChild(labelEl);
        // Position the label based on shape
        $0df180e0a21dca5a$var$updateShapeLabelPosition();
    }
    if (labelEl) {
        // If text is empty and it's not a Cisco shape (which should keep default label), remove the label
        if (!labelText && !isCiscoShape) {
            labelEl.remove();
            return;
        }
        labelEl.textContent = labelText;
    }
}
/**
 * Update shape label position
 */ function $0df180e0a21dca5a$var$updateShapeLabelPosition() {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    const dataType = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-shape-type');
    const isTextShape = dataType === 'text';
    const isCiscoShape = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-cisco') === 'true';
    const isBasicShape = $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'circle' || $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'rect' || $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'ellipse';
    // Don't reposition text shapes (they are the label itself)
    if (isTextShape) return;
    // Find the label element
    let labelEl;
    if (isBasicShape) {
        // For basic shapes, find sibling label
        const shapeId = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('id');
        labelEl = $0df180e0a21dca5a$var$overlaySourceShape.parentNode?.querySelector(`text[data-shape-id="${shapeId}"]`);
    } else // For Cisco shapes and groups, find child label
    labelEl = isCiscoShape ? $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text:not([data-label])') : $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text[data-label="true"]');
    if (!labelEl) return;
    const position = (0, $162Oa.elements).shapeLabelPosition.value;
    let width, height, x, y;
    const offset = 20;
    // Get shape dimensions based on shape type
    if (isBasicShape) {
        // Handle basic shapes directly (not in a group)
        if ($0df180e0a21dca5a$var$overlaySourceShape.tagName === 'circle') {
            const r = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('r')) || 30;
            const cx = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('cx')) || 0;
            const cy = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('cy')) || 0;
            width = r * 2;
            height = r * 2;
            x = cx;
            y = cy;
        } else if ($0df180e0a21dca5a$var$overlaySourceShape.tagName === 'ellipse') {
            const rx = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('rx')) || 40;
            const ry = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('ry')) || 30;
            const cx = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('cx')) || 0;
            const cy = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('cy')) || 0;
            width = rx * 2;
            height = ry * 2;
            x = cx;
            y = cy;
        } else if ($0df180e0a21dca5a$var$overlaySourceShape.tagName === 'rect') {
            width = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('width')) || 60;
            height = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('height')) || 40;
            x = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('x')) || 0;
            y = parseFloat($0df180e0a21dca5a$var$overlaySourceShape.getAttribute('y')) || 0;
        }
    } else if ($0df180e0a21dca5a$var$overlaySourceShape.tagName === 'g') {
        // For groups, check if it's a Cisco shape or a converted basic shape
        const svg = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('svg');
        if (svg) {
            // Cisco shape - SVG child with viewBox coordinates
            width = parseFloat(svg.getAttribute('width')) || 60;
            height = parseFloat(svg.getAttribute('height')) || 60;
            x = 0; // Cisco shapes use transform on the group
            y = 0;
        } else {
            // Converted basic shape - get dimensions from child shape
            const childShape = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('circle, rect, ellipse');
            if (childShape) {
                if (childShape.tagName === 'circle') {
                    const r = parseFloat(childShape.getAttribute('r')) || 30;
                    const cx = parseFloat(childShape.getAttribute('cx')) || 0;
                    const cy = parseFloat(childShape.getAttribute('cy')) || 0;
                    width = r * 2;
                    height = r * 2;
                    x = cx;
                    y = cy;
                } else if (childShape.tagName === 'ellipse') {
                    const rx = parseFloat(childShape.getAttribute('rx')) || 40;
                    const ry = parseFloat(childShape.getAttribute('ry')) || 30;
                    const cx = parseFloat(childShape.getAttribute('cx')) || 0;
                    const cy = parseFloat(childShape.getAttribute('cy')) || 0;
                    width = rx * 2;
                    height = ry * 2;
                    x = cx;
                    y = cy;
                } else if (childShape.tagName === 'rect') {
                    width = parseFloat(childShape.getAttribute('width')) || 60;
                    height = parseFloat(childShape.getAttribute('height')) || 40;
                    x = parseFloat(childShape.getAttribute('x')) || 0;
                    y = parseFloat(childShape.getAttribute('y')) || 0;
                }
            } else {
                // Fallback
                width = 60;
                height = 60;
                x = 0;
                y = 0;
            }
        }
    } else {
        // Default fallback for other shape types
        width = 60;
        height = 60;
        x = 0;
        y = 0;
    }
    // Calculate label position
    // For circles/ellipses, x and y are center coords; for rects, they're top-left
    let labelX, labelY;
    const isCircular = $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'circle' || $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'ellipse' || $0df180e0a21dca5a$var$overlaySourceShape.tagName === 'g' && $0df180e0a21dca5a$var$overlaySourceShape.querySelector('circle, ellipse');
    switch(position){
        case 'above':
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y - height / 2 - offset : y - offset;
            labelEl.setAttribute('text-anchor', 'middle');
            break;
        case 'below':
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y + height / 2 + offset : y + height + offset;
            labelEl.setAttribute('text-anchor', 'middle');
            break;
        case 'left':
            labelX = isCircular ? x - width / 2 - offset : x - offset;
            labelY = isCircular ? y : y + height / 2;
            labelEl.setAttribute('text-anchor', 'end');
            break;
        case 'right':
            labelX = isCircular ? x + width / 2 + offset : x + width + offset;
            labelY = isCircular ? y : y + height / 2;
            labelEl.setAttribute('text-anchor', 'start');
            break;
        case 'center':
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y + 5 : y + height / 2 + 5; // Slightly offset for better centering
            labelEl.setAttribute('text-anchor', 'middle');
            labelEl.setAttribute('dominant-baseline', 'middle');
            break;
        default:
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y + height / 2 + offset : y + height + offset;
            labelEl.setAttribute('text-anchor', 'middle');
    }
    labelEl.setAttribute('x', labelX);
    labelEl.setAttribute('y', labelY);
    labelEl.setAttribute('data-position', position);
}
/**
 * Update shape label color
 */ function $0df180e0a21dca5a$var$updateShapeLabelColor() {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    const dataType = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-shape-type');
    const isTextShape = dataType === 'text';
    const isCiscoShape = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-cisco') === 'true';
    let labelEl;
    if (isTextShape) labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('.text-content');
    else if (isCiscoShape) labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text:not([data-label])');
    else labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text[data-label="true"]');
    if (labelEl) labelEl.setAttribute('fill', (0, $162Oa.elements).shapeLabelColor.value);
}

/**
 * Update shape label font size
 */ function $0df180e0a21dca5a$var$updateShapeLabelFontSize() {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    const dataType = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-shape-type');
    const isTextShape = dataType === 'text';
    const isCiscoShape = $0df180e0a21dca5a$var$overlaySourceShape.getAttribute('data-cisco') === 'true';
    let labelEl;
    if (isTextShape) labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('.text-content');
    else if (isCiscoShape) labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text:not([data-label])');
    else labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text[data-label="true"]');
    if (labelEl) {
        const fontSize = (0, $162Oa.elements).shapeLabelFontSize.value || '14';
        labelEl.setAttribute('font-size', fontSize);
        // If it's a text shape, update the background to fit new size
        if (isTextShape) {
            const { updateTextBackground: updateTextBackground } = (parcelRequire("gLqu3"));
            updateTextBackground($0df180e0a21dca5a$var$overlaySourceShape);
        }
    }
}
/**
 * Toggle shape label style (bold, italic, underline)
 * @param {string} style - Style to toggle ('bold', 'italic', 'underline')
 */ function $0df180e0a21dca5a$var$toggleShapeLabelStyle(style) {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    const labelEl = $0df180e0a21dca5a$var$overlaySourceShape.querySelector('text');
    if (!labelEl) return;
    let button;
    switch(style){
        case 'bold':
            button = (0, $162Oa.elements).shapeLabelBold;
            const currentWeight = labelEl.getAttribute('font-weight') || 'normal';
            labelEl.setAttribute('font-weight', currentWeight === 'bold' ? 'normal' : 'bold');
            break;
        case 'italic':
            button = (0, $162Oa.elements).shapeLabelItalic;
            const currentStyle = labelEl.getAttribute('font-style') || 'normal';
            labelEl.setAttribute('font-style', currentStyle === 'italic' ? 'normal' : 'italic');
            break;
        case 'underline':
            button = (0, $162Oa.elements).shapeLabelUnderline;
            const currentDecoration = labelEl.getAttribute('text-decoration') || 'none';
            labelEl.setAttribute('text-decoration', currentDecoration === 'underline' ? 'none' : 'underline');
            break;
    }
    // Toggle button active state
    if (button) button.classList.toggle('active');
}
/**
 * Apply all shape changes and save state
 */ function $0df180e0a21dca5a$var$applyShapeChanges() {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    // Apply all changes
    $0df180e0a21dca5a$var$updateShapeLabel();
    $0df180e0a21dca5a$var$updateShapeLabelPosition();
    $0df180e0a21dca5a$var$updateShapeLabelColor();
    $0df180e0a21dca5a$var$updateShapeLabelFontSize();
    // Apply shape styling
    const shapeFillInput = document.getElementById('shapeFillColor');
    const shapeStrokeInput = document.getElementById('shapeStrokeColor');
    const shapeStrokeWidthInput = document.getElementById('shapeStrokeWidth');
    if (shapeFillInput && shapeStrokeInput && shapeStrokeWidthInput) {
        (0, $9srb1.applyShapeFill)($0df180e0a21dca5a$var$overlaySourceShape.id, shapeFillInput.value);
        (0, $9srb1.applyShapeStroke)($0df180e0a21dca5a$var$overlaySourceShape.id, shapeStrokeInput.value, parseInt(shapeStrokeWidthInput.value));
    }
    // Save state after applying all changes
    (0, $4DKvQ.saveAppState)();
    // Hide the panel
    $0df180e0a21dca5a$var$hideShapePanel();
}
function $0df180e0a21dca5a$export$a1ab752282f1a407() {
    return $0df180e0a21dca5a$var$isWaitingForTarget;
}
function $0df180e0a21dca5a$export$b0145e7e102c7ffe(targetShape) {
    if (!$0df180e0a21dca5a$var$isWaitingForTarget || !$0df180e0a21dca5a$var$overlaySourceShape) return;
    if (targetShape === $0df180e0a21dca5a$var$overlaySourceShape) {
        // Can't connect to itself - provide feedback
        console.log('Cannot connect a shape to itself');
        (0, $le39T.showAlert)('Cannot connect a shape to itself', 'Invalid Connection', 'warning');
        return;
    }
    // Create the connection with default values
    $0df180e0a21dca5a$var$finishConnectionWithTarget(targetShape);
}
function $0df180e0a21dca5a$export$f2e0e248fee33266(shape) {
    if (!shape) return;
    // Don't show overlay if we're waiting for a target shape
    if ($0df180e0a21dca5a$var$isWaitingForTarget) {
        console.log('Cannot show overlay - waiting for connection target');
        return;
    }
    const shapeRect = shape.getBoundingClientRect();
    // Position the panel below the shape
    const panelWidth = 320; // Increased width for two columns
    const panelHeight = 500;
    let left = shapeRect.left;
    let top = shapeRect.bottom + 10;
    // Adjust if panel goes off screen horizontally
    if (left + panelWidth > window.innerWidth) left = window.innerWidth - panelWidth - 10;
    // Adjust if panel goes off screen vertically (show above if needed)
    if (top + panelHeight > window.innerHeight) {
        top = shapeRect.top - panelHeight - 10;
        // If still off screen, just position at bottom of viewport
        if (top < 10) top = 10;
    }
    (0, $162Oa.elements).shapeOverlayPanel.style.left = `${left}px`;
    (0, $162Oa.elements).shapeOverlayPanel.style.top = `${top}px`;
    (0, $162Oa.elements).shapeOverlayPanel.style.display = 'block';
    $0df180e0a21dca5a$var$overlaySourceShape = shape;
    // Check if this is a text shape
    const dataType = shape.getAttribute('data-shape-type');
    const isTextShape = dataType === 'text';
    const isCiscoShape = shape.getAttribute('data-cisco') === 'true';
    // Update panel labels for text shapes
    const leftColumnTitle = document.getElementById('leftColumnTitle');
    const labelTextLabel = document.getElementById('labelTextLabel');
    const labelColorLabel = document.getElementById('labelColorLabel');
    const labelPositionContainer = document.getElementById('labelPositionContainer');
    if (isTextShape) {
        if (leftColumnTitle) leftColumnTitle.textContent = 'Text Customization';
        if (labelTextLabel) labelTextLabel.textContent = 'Text Content';
        if (labelColorLabel) labelColorLabel.textContent = 'Text Color';
        if (labelPositionContainer) labelPositionContainer.style.display = 'none';
        (0, $162Oa.elements).shapeLabelText.placeholder = 'Enter text';
    } else {
        if (leftColumnTitle) leftColumnTitle.textContent = 'Label Customization';
        if (labelTextLabel) labelTextLabel.textContent = 'Label Text';
        if (labelColorLabel) labelColorLabel.textContent = 'Label Color';
        if (labelPositionContainer) labelPositionContainer.style.display = 'block';
        (0, $162Oa.elements).shapeLabelText.placeholder = 'Shape label';
    }
    // Load current shape label properties
    // For text shapes, load from .text-content
    // For Cisco shapes, load from text without data-label
    // For basic shapes, load from text with data-label="true"
    let labelEl;
    if (isTextShape) labelEl = shape.querySelector('.text-content');
    else if (isCiscoShape) labelEl = shape.querySelector('text:not([data-label])');
    else labelEl = shape.querySelector('text[data-label="true"]');
    if (labelEl) {
        (0, $162Oa.elements).shapeLabelText.value = labelEl.textContent || '';
        (0, $162Oa.elements).shapeLabelColor.value = labelEl.getAttribute('fill') || '#333333';
        (0, $162Oa.elements).shapeLabelFontSize.value = labelEl.getAttribute('font-size') || '14';
        (0, $162Oa.elements).shapeLabelPosition.value = labelEl.getAttribute('data-position') || 'below';
        // Update style button states
        const isBold = labelEl.getAttribute('font-weight') === 'bold';
        const isItalic = labelEl.getAttribute('font-style') === 'italic';
        const isUnderline = labelEl.getAttribute('text-decoration') === 'underline';
        (0, $162Oa.elements).shapeLabelBold.classList.toggle('active', isBold);
        (0, $162Oa.elements).shapeLabelItalic.classList.toggle('active', isItalic);
        (0, $162Oa.elements).shapeLabelUnderline.classList.toggle('active', isUnderline);
    } else {
        // No label yet - set defaults
        (0, $162Oa.elements).shapeLabelText.value = '';
        (0, $162Oa.elements).shapeLabelColor.value = '#333333';
        (0, $162Oa.elements).shapeLabelFontSize.value = '14';
        (0, $162Oa.elements).shapeLabelPosition.value = 'below';
        (0, $162Oa.elements).shapeLabelBold.classList.remove('active');
        (0, $162Oa.elements).shapeLabelItalic.classList.remove('active');
        (0, $162Oa.elements).shapeLabelUnderline.classList.remove('active');
    }
    // Load shape styling
    const shapeFillInput = document.getElementById('shapeFillColor');
    const shapeStrokeInput = document.getElementById('shapeStrokeColor');
    const shapeStrokeWidthInput = document.getElementById('shapeStrokeWidth');
    if (shapeFillInput && shapeStrokeInput && shapeStrokeWidthInput) {
        const styles = (0, $9srb1.getShapeStyles)(shape.id);
        if (styles) {
            shapeFillInput.value = styles.fill;
            shapeStrokeInput.value = styles.stroke;
            shapeStrokeWidthInput.value = styles.strokeWidth;
        }
    }
    // Set focus on label text field after a short delay to ensure panel is visible
    setTimeout(()=>{
        (0, $162Oa.elements).shapeLabelText.focus();
        (0, $162Oa.elements).shapeLabelText.select();
    }, 100);
}
function $0df180e0a21dca5a$export$94d7fe6439e0775a(connection, sourceLabel, targetLabel, centerLabel) {
    // Position the panel in the center of screen
    const panelWidth = 280;
    const panelHeight = 300;
    const left = (window.innerWidth - panelWidth) / 2;
    const top = (window.innerHeight - panelHeight) / 2;
    (0, $162Oa.elements).connectionOverlayPanel.style.left = `${left}px`;
    (0, $162Oa.elements).connectionOverlayPanel.style.top = `${top}px`;
    (0, $162Oa.elements).connectionOverlayPanel.style.display = 'block';
    $0df180e0a21dca5a$var$selectedConnection = connection;
    // Get the line element from the connection group
    const line = connection.querySelector('.connection-line');
    // Load current connection properties
    (0, $162Oa.elements).connectionSourceLabel.value = sourceLabel || '';
    (0, $162Oa.elements).connectionTargetLabel.value = targetLabel || '';
    (0, $162Oa.elements).connectionCenterLabel.value = centerLabel || '';
    const strokeWidth = line ? line.getAttribute('stroke-width') || '3' : '3';
    const strokeColor = line ? line.getAttribute('stroke') || '#6c757d' : '#6c757d';
    const strokeDasharray = line ? line.getAttribute('stroke-dasharray') || '' : '';
    (0, $162Oa.elements).connectionStrokeWidth.value = strokeWidth;
    (0, $162Oa.elements).connectionStrokeColor.value = strokeColor;
    // Determine line style from stroke-dasharray
    if (!strokeDasharray || strokeDasharray === 'none') (0, $162Oa.elements).connectionStrokeStyle.value = 'solid';
    else if (strokeDasharray === '10,5') (0, $162Oa.elements).connectionStrokeStyle.value = 'dashed';
    else if (strokeDasharray === '2,3') (0, $162Oa.elements).connectionStrokeStyle.value = 'dotted';
    else (0, $162Oa.elements).connectionStrokeStyle.value = 'solid';
    // Get label styling from source label (both labels should have same styling)
    const sourceLabelId = $0df180e0a21dca5a$var$selectedConnection.getAttribute('data-source-label-id');
    const sourceLabelEl = sourceLabelId ? document.getElementById(sourceLabelId) : null;
    if (sourceLabelEl) {
        (0, $162Oa.elements).connectionLabelColor.value = sourceLabelEl.getAttribute('fill') || '#333333';
        (0, $162Oa.elements).connectionLabelFontSize.value = sourceLabelEl.getAttribute('font-size') || '12';
    } else {
        (0, $162Oa.elements).connectionLabelColor.value = '#333333';
        (0, $162Oa.elements).connectionLabelFontSize.value = '12';
    }
    // Set focus on center label field after a short delay to ensure panel is visible
    setTimeout(()=>{
        (0, $162Oa.elements).connectionCenterLabel.focus();
        (0, $162Oa.elements).connectionCenterLabel.select();
    }, 100);
}
/**
 * Apply connection changes from the connection panel
 */ function $0df180e0a21dca5a$var$applyConnectionChanges() {
    if (!$0df180e0a21dca5a$var$selectedConnection) return;
    // Update labels
    const sourceLabelId = $0df180e0a21dca5a$var$selectedConnection.getAttribute('data-source-label-id');
    const targetLabelId = $0df180e0a21dca5a$var$selectedConnection.getAttribute('data-target-label-id');
    const centerLabelId = $0df180e0a21dca5a$var$selectedConnection.getAttribute('data-center-label-id');
    const sourceEl = sourceLabelId ? document.getElementById(sourceLabelId) : null;
    const targetEl = targetLabelId ? document.getElementById(targetLabelId) : null;
    const centerEl = centerLabelId ? document.getElementById(centerLabelId) : null;
    if (sourceEl) {
        // Clear existing content and set new text
        while(sourceEl.firstChild)sourceEl.removeChild(sourceEl.firstChild);
        const textNode = document.createTextNode((0, $162Oa.elements).connectionSourceLabel.value);
        sourceEl.appendChild(textNode);
        // Update label styling
        sourceEl.setAttribute('fill', (0, $162Oa.elements).connectionLabelColor.value);
        sourceEl.setAttribute('font-size', (0, $162Oa.elements).connectionLabelFontSize.value);
    }
    if (targetEl) {
        // Clear existing content and set new text
        while(targetEl.firstChild)targetEl.removeChild(targetEl.firstChild);
        const textNode = document.createTextNode((0, $162Oa.elements).connectionTargetLabel.value);
        targetEl.appendChild(textNode);
        // Update label styling
        targetEl.setAttribute('fill', (0, $162Oa.elements).connectionLabelColor.value);
        targetEl.setAttribute('font-size', (0, $162Oa.elements).connectionLabelFontSize.value);
    }
    if (centerEl) {
        // Clear existing content and set new text
        while(centerEl.firstChild)centerEl.removeChild(centerEl.firstChild);
        const textNode = document.createTextNode((0, $162Oa.elements).connectionCenterLabel.value);
        centerEl.appendChild(textNode);
        // Update label styling
        centerEl.setAttribute('fill', (0, $162Oa.elements).connectionLabelColor.value);
        centerEl.setAttribute('font-size', (0, $162Oa.elements).connectionLabelFontSize.value);
    }
    // Update line style
    const line = $0df180e0a21dca5a$var$selectedConnection.querySelector('.connection-line');
    if (line) {
        // Use style properties to override CSS rules
        line.style.strokeWidth = (0, $162Oa.elements).connectionStrokeWidth.value + 'px';
        line.style.stroke = (0, $162Oa.elements).connectionStrokeColor.value;
        // Also update attributes for persistence
        line.setAttribute('stroke-width', (0, $162Oa.elements).connectionStrokeWidth.value);
        line.setAttribute('stroke', (0, $162Oa.elements).connectionStrokeColor.value);
        // Update stroke style (dasharray)
        const strokeStyle = (0, $162Oa.elements).connectionStrokeStyle.value;
        let dasharray = 'none';
        switch(strokeStyle){
            case 'dashed':
                dasharray = '10,5';
                break;
            case 'dotted':
                dasharray = '2,3';
                break;
            case 'solid':
            default:
                dasharray = 'none';
                break;
        }
        if (dasharray === 'none') {
            line.removeAttribute('stroke-dasharray');
            line.style.strokeDasharray = '';
        } else {
            line.setAttribute('stroke-dasharray', dasharray);
            line.style.strokeDasharray = dasharray;
        }
    }
    (0, $4DKvQ.saveAppState)();
    $0df180e0a21dca5a$var$hideConnectionPanel();
}
/**
 * Hide connection panel
 */ function $0df180e0a21dca5a$var$hideConnectionPanel() {
    (0, $162Oa.elements).connectionOverlayPanel.style.display = 'none';
    $0df180e0a21dca5a$var$selectedConnection = null;
}
/**
 * Hide shape panel
 */ function $0df180e0a21dca5a$var$hideShapePanel() {
    (0, $162Oa.elements).shapeOverlayPanel.style.display = 'none';
    $0df180e0a21dca5a$var$overlaySourceShape = null;
    $0df180e0a21dca5a$var$isWaitingForTarget = false;
    // Reset canvas and shape cursors
    (0, $162Oa.elements).canvas.style.cursor = 'default';
    const allShapes = (0, $162Oa.elements).canvas.querySelectorAll('.canvas-shape, .cisco-shape');
    allShapes.forEach((shape)=>{
        shape.style.cursor = 'move';
    });
    // Remove any connection mode styling
    document.querySelectorAll('.connection-source').forEach((el)=>{
        el.classList.remove('connection-source');
    });
    // Clean up any click handler
    if ($0df180e0a21dca5a$var$connectionClickHandler) {
        (0, $162Oa.elements).canvas.removeEventListener('click', $0df180e0a21dca5a$var$connectionClickHandler);
        $0df180e0a21dca5a$var$connectionClickHandler = null;
    }
}
const $0df180e0a21dca5a$export$50132675b7c847d9 = $0df180e0a21dca5a$var$hideShapePanel;
/**
 * Start connection mode - wait for user to click target shape
 */ function $0df180e0a21dca5a$var$startConnectionMode() {
    if (!$0df180e0a21dca5a$var$overlaySourceShape) return;
    // Add visual feedback to source shape
    $0df180e0a21dca5a$var$overlaySourceShape.classList.add('connection-source');
    // Set waiting flag
    $0df180e0a21dca5a$var$isWaitingForTarget = true;
    // Change cursor to indicate connection mode
    (0, $162Oa.elements).canvas.style.cursor = 'crosshair';
    // Add hover effect to all shapes to show they're clickable
    const allShapes = (0, $162Oa.elements).canvas.querySelectorAll('.canvas-shape, .cisco-shape');
    allShapes.forEach((shape)=>{
        if (shape !== $0df180e0a21dca5a$var$overlaySourceShape) shape.style.cursor = 'crosshair';
    });
}
/**
 * Finish connection creation with target shape
 * @param {SVGElement} targetShape - The target shape
 */ function $0df180e0a21dca5a$var$finishConnectionWithTarget(targetShape) {
    // Create the connection with default values (empty labels, default styling)
    const connectionGroup = (0, $hkA3I.createConnection)($0df180e0a21dca5a$var$overlaySourceShape, targetShape, '', '', '', 3, '#6c757d');
    // Clean up
    $0df180e0a21dca5a$var$overlaySourceShape.classList.remove('connection-source');
    $0df180e0a21dca5a$var$isWaitingForTarget = false;
    $0df180e0a21dca5a$var$hideShapePanel();
    (0, $4DKvQ.saveAppState)();
    // Automatically open the connection details panel
    if (connectionGroup) {
        // Get the label elements
        const sourceLabelId = connectionGroup.getAttribute('data-source-label-id');
        const targetLabelId = connectionGroup.getAttribute('data-target-label-id');
        const sourceLabel = sourceLabelId ? document.getElementById(sourceLabelId) : null;
        const targetLabel = targetLabelId ? document.getElementById(targetLabelId) : null;
        // Show the connection panel with the newly created connection
        $0df180e0a21dca5a$export$94d7fe6439e0775a(connectionGroup, sourceLabel ? sourceLabel.textContent : '', targetLabel ? targetLabel.textContent : '', '' // center label is empty initially
        );
    }
}
function $0df180e0a21dca5a$export$a26569ba8173c2c1(shape) {
    if ((0, $162Oa.elements).shapeOverlayPanel.style.display !== 'none' && $0df180e0a21dca5a$var$overlaySourceShape === shape) $0df180e0a21dca5a$export$f2e0e248fee33266(shape);
}
function $0df180e0a21dca5a$export$f099c7a917e14c30(sourceShape) {
    // Set the source shape
    $0df180e0a21dca5a$var$overlaySourceShape = sourceShape;
    // Add visual feedback to source shape
    sourceShape.classList.add('connection-source');
    // Set waiting flag
    $0df180e0a21dca5a$var$isWaitingForTarget = true;
    // Change cursor to indicate connection mode
    (0, $162Oa.elements).canvas.style.cursor = 'crosshair';
    // Add hover effect to all shapes to show they're clickable
    const allShapes = (0, $162Oa.elements).canvas.querySelectorAll('.canvas-shape, .cisco-shape');
    allShapes.forEach((shape)=>{
        if (shape !== sourceShape) shape.style.cursor = 'crosshair';
    });
}

});
parcelRegister("9srb1", function(module, exports) {

$parcel$export(module.exports, "duplicateShape", () => $6e2bcf56de31fcad$export$2401289249a83df5);
$parcel$export(module.exports, "moveShapeToFront", () => $6e2bcf56de31fcad$export$4f3f914343dc8d1d);
$parcel$export(module.exports, "moveShapeToBack", () => $6e2bcf56de31fcad$export$55b3aa9ce92986f8);
$parcel$export(module.exports, "applyShapeFill", () => $6e2bcf56de31fcad$export$f27ddda6ae866293);
$parcel$export(module.exports, "applyShapeStroke", () => $6e2bcf56de31fcad$export$933c50df6d33d08c);
$parcel$export(module.exports, "getShapeStyles", () => $6e2bcf56de31fcad$export$73099a0677a5c6a6);
/**
 * Shape Actions - Duplicate, Z-index, Styling
 */ 
var $lwME4 = parcelRequire("lwME4");

var $4DKvQ = parcelRequire("4DKvQ");

var $89InF = parcelRequire("89InF");
function $6e2bcf56de31fcad$export$2401289249a83df5(shapeId) {
    const originalShape = document.getElementById(shapeId);
    if (!originalShape) return;
    // Clone the shape element
    const clonedShape = originalShape.cloneNode(true);
    // Generate new ID
    const newShapeId = (0, $lwME4.appState).getNextShapeId();
    clonedShape.setAttribute('id', newShapeId);
    // Offset the position by 50 pixels
    const offset = 50;
    const shapeType = originalShape.getAttribute('data-shape-type');
    if (originalShape.tagName === 'g') {
        // Handle groups (Cisco shapes, arrows, lines, text)
        const transform = originalShape.getAttribute('transform');
        if (transform) {
            const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
            if (match) {
                const x = parseFloat(match[1]) + offset;
                const y = parseFloat(match[2]) + offset;
                clonedShape.setAttribute('transform', `translate(${x}, ${y})`);
            }
        }
    } else if (originalShape.tagName === 'circle' || originalShape.tagName === 'ellipse') {
        const cx = parseFloat(originalShape.getAttribute('cx')) + offset;
        const cy = parseFloat(originalShape.getAttribute('cy')) + offset;
        clonedShape.setAttribute('cx', cx);
        clonedShape.setAttribute('cy', cy);
    } else if (originalShape.tagName === 'rect') {
        const x = parseFloat(originalShape.getAttribute('x')) + offset;
        const y = parseFloat(originalShape.getAttribute('y')) + offset;
        clonedShape.setAttribute('x', x);
        clonedShape.setAttribute('y', y);
    } else if (originalShape.tagName === 'line') {
        const x1 = parseFloat(originalShape.getAttribute('x1')) + offset;
        const y1 = parseFloat(originalShape.getAttribute('y1')) + offset;
        const x2 = parseFloat(originalShape.getAttribute('x2')) + offset;
        const y2 = parseFloat(originalShape.getAttribute('y2')) + offset;
        clonedShape.setAttribute('x1', x1);
        clonedShape.setAttribute('y1', y1);
        clonedShape.setAttribute('x2', x2);
        clonedShape.setAttribute('y2', y2);
    }
    // Update label if present (append " (copy)")
    const labelElement = clonedShape.querySelector('[data-label="true"]');
    if (labelElement && labelElement.textContent) labelElement.textContent = `${labelElement.textContent} (copy)`;
    // Add event listeners to the cloned shape
    (0, $89InF.addShapeEventListeners)(clonedShape);
    // Add the duplicated shape to the shapes layer
    const shapesLayer = document.getElementById('shapesLayer');
    if (shapesLayer) shapesLayer.appendChild(clonedShape);
    else {
        // Fallback: add to canvas directly
        const canvas = document.getElementById('topologyCanvas');
        if (canvas) canvas.appendChild(clonedShape);
    }
    // Save state
    (0, $4DKvQ.saveAppState)();
    return clonedShape;
}
function $6e2bcf56de31fcad$export$4f3f914343dc8d1d(shapeId) {
    const shapeGroup = document.getElementById(shapeId);
    if (!shapeGroup) return;
    const shapesLayer = document.getElementById('shapesLayer');
    const targetParent = shapesLayer || document.getElementById('topologyCanvas');
    targetParent.appendChild(shapeGroup);
    (0, $4DKvQ.saveAppState)();
    console.log(`Moved shape ${shapeId} to front`);
}
function $6e2bcf56de31fcad$export$55b3aa9ce92986f8(shapeId) {
    const shapeGroup = document.getElementById(shapeId);
    if (!shapeGroup) return;
    // Move to backgroundShapesLayer (which is below connections)
    const backgroundShapesLayer = document.getElementById('backgroundShapesLayer');
    const targetParent = backgroundShapesLayer || document.getElementById('topologyCanvas');
    console.log('moveShapeToBack:', {
        shapeId: shapeId,
        hasBackgroundLayer: !!backgroundShapesLayer,
        currentParent: shapeGroup.parentElement?.id,
        targetParent: targetParent.id
    });
    // Move the shape to the background layer
    targetParent.appendChild(shapeGroup);
    (0, $4DKvQ.saveAppState)();
    console.log(`Moved shape ${shapeId} to background layer (behind connections)`);
}
function $6e2bcf56de31fcad$export$f27ddda6ae866293(shapeId, fillColor) {
    const shape = document.getElementById(shapeId);
    if (!shape) return;
    // Check if this is a text shape
    const dataType = shape.getAttribute('data-shape-type');
    if (dataType === 'text') {
        // For text shapes, apply fill to the background rectangle
        const bgRect = shape.querySelector('.text-background');
        if (bgRect) bgRect.setAttribute('fill', fillColor);
        (0, $4DKvQ.saveAppState)();
        return;
    }
    // For basic shapes (circle, rect, ellipse) that are direct elements
    if (shape.tagName === 'circle' || shape.tagName === 'rect' || shape.tagName === 'ellipse') {
        shape.setAttribute('fill', fillColor);
        (0, $4DKvQ.saveAppState)();
        return;
    }
    // For groups (Cisco shapes, arrows, lines), find the visual elements inside
    if (shape.tagName === 'g') {
        // First try to find basic shapes inside the group
        const shapeElement = shape.querySelector('circle, rect, ellipse, path');
        if (shapeElement && shapeElement.tagName !== 'path') // Basic shapes support fill
        shapeElement.setAttribute('fill', fillColor);
        else if (shapeElement && shapeElement.tagName === 'path') {
            // SVG paths (Cisco shapes) - apply to all paths in the group
            const paths = shape.querySelectorAll('path');
            paths.forEach((path)=>{
                // Only change fill if it's not 'none'
                const currentFill = path.getAttribute('fill');
                if (currentFill && currentFill !== 'none') path.setAttribute('fill', fillColor);
            });
        }
    }
    (0, $4DKvQ.saveAppState)();
}
function $6e2bcf56de31fcad$export$933c50df6d33d08c(shapeId, strokeColor, strokeWidth = 2) {
    const shape = document.getElementById(shapeId);
    if (!shape) return;
    // Convert to number to handle string values from select
    const width = Number(strokeWidth);
    // Check if this is a text shape
    const dataType = shape.getAttribute('data-shape-type');
    if (dataType === 'text') {
        // For text shapes, apply stroke to the background rectangle
        const bgRect = shape.querySelector('.text-background');
        if (bgRect) {
            if (width === 0) {
                bgRect.setAttribute('stroke', 'none');
                bgRect.setAttribute('stroke-width', '0');
            } else {
                bgRect.setAttribute('stroke', strokeColor);
                bgRect.setAttribute('stroke-width', width);
            }
        }
        (0, $4DKvQ.saveAppState)();
        return;
    }
    // For basic shapes (circle, rect, ellipse) that are direct elements
    if (shape.tagName === 'circle' || shape.tagName === 'rect' || shape.tagName === 'ellipse') {
        if (width === 0) {
            shape.setAttribute('stroke', 'none');
            shape.setAttribute('stroke-width', '0');
        } else {
            shape.setAttribute('stroke', strokeColor);
            shape.setAttribute('stroke-width', width);
        }
        (0, $4DKvQ.saveAppState)();
        return;
    }
    // For groups (Cisco shapes, arrows, lines), find the visual elements inside
    if (shape.tagName === 'g') {
        // First try to find basic shapes inside the group
        const shapeElement = shape.querySelector('circle, rect, ellipse, path');
        if (shapeElement && shapeElement.tagName !== 'path') {
            // Basic shapes
            if (width === 0) {
                shapeElement.setAttribute('stroke', 'none');
                shapeElement.setAttribute('stroke-width', '0');
            } else {
                shapeElement.setAttribute('stroke', strokeColor);
                shapeElement.setAttribute('stroke-width', width);
            }
        } else if (shapeElement && shapeElement.tagName === 'path') {
            // SVG paths - apply to all paths
            const paths = shape.querySelectorAll('path');
            paths.forEach((path)=>{
                const currentStroke = path.getAttribute('stroke');
                if (currentStroke && currentStroke !== 'none') {
                    if (width === 0) {
                        path.setAttribute('stroke', 'none');
                        path.setAttribute('stroke-width', '0');
                    } else {
                        path.setAttribute('stroke', strokeColor);
                        path.setAttribute('stroke-width', width);
                    }
                }
            });
        }
    }
    (0, $4DKvQ.saveAppState)();
}
function $6e2bcf56de31fcad$export$73099a0677a5c6a6(shapeId) {
    const shape = document.getElementById(shapeId);
    if (!shape) return null;
    // Check if this is a text shape
    const isTextShape = shape.getAttribute('data-shape-type') === 'text';
    let shapeElement;
    // For text shapes, read from .text-background
    if (isTextShape) shapeElement = shape.querySelector('.text-background');
    else if (shape.tagName === 'circle' || shape.tagName === 'rect' || shape.tagName === 'ellipse') shapeElement = shape;
    else if (shape.tagName === 'g') shapeElement = shape.querySelector('circle, rect, ellipse, path');
    if (!shapeElement) return null;
    // Get styles from DOM attributes
    const fill = shapeElement.getAttribute('fill') || '#ffffff';
    const domStroke = shapeElement.getAttribute('stroke') || '#000000';
    const domStrokeWidth = shapeElement.getAttribute('stroke-width') || '2';
    // If stroke is 'none' or width is '0', treat as no border
    const finalStroke = domStroke === 'none' ? '#000000' : domStroke;
    const finalStrokeWidth = domStroke === 'none' || domStrokeWidth === '0' ? '0' : domStrokeWidth;
    return {
        fill: fill,
        stroke: finalStroke,
        strokeWidth: finalStrokeWidth
    };
}

});




parcelRegister("k5XSw", function(module, exports) {

$parcel$export(module.exports, "createEndpointHandles", () => $ea12b8e382b9eaa8$export$c77270a83d033b90);
$parcel$export(module.exports, "removeEndpointHandles", () => $ea12b8e382b9eaa8$export$8a9af937093aa8f7);
$parcel$export(module.exports, "handleEndpointDrag", () => $ea12b8e382b9eaa8$export$4743809bd1f4064b);
$parcel$export(module.exports, "stopEndpointDrag", () => $ea12b8e382b9eaa8$export$ca388c577c2cb630);
/**
 * Line and Arrow endpoint handle functionality
 * Allows users to drag endpoints to reposition them
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $hkA3I = parcelRequire("hkA3I");
function $ea12b8e382b9eaa8$export$c77270a83d033b90(shape) {
    $ea12b8e382b9eaa8$export$8a9af937093aa8f7();
    const dataType = shape.getAttribute('data-shape-type');
    if (dataType === 'line') $ea12b8e382b9eaa8$var$createLineEndpointHandles(shape);
    else if (dataType === 'arrow') $ea12b8e382b9eaa8$var$createArrowEndpointHandles(shape);
}
/**
 * Create endpoint handles for a line shape
 * @param {SVGElement} line - The line element
 */ function $ea12b8e382b9eaa8$var$createLineEndpointHandles(line) {
    const x1 = parseFloat(line.getAttribute('x1'));
    const y1 = parseFloat(line.getAttribute('y1'));
    const x2 = parseFloat(line.getAttribute('x2'));
    const y2 = parseFloat(line.getAttribute('y2'));
    // Create start point handle
    const startHandle = $ea12b8e382b9eaa8$var$createEndpointHandle(x1, y1, 'start', line);
    (0, $162Oa.elements).topologyCanvas.appendChild(startHandle);
    (0, $lwME4.appState).addEndpointHandle(startHandle);
    // Create end point handle
    const endHandle = $ea12b8e382b9eaa8$var$createEndpointHandle(x2, y2, 'end', line);
    (0, $162Oa.elements).topologyCanvas.appendChild(endHandle);
    (0, $lwME4.appState).addEndpointHandle(endHandle);
}
/**
 * Create endpoint handles for an arrow shape
 * @param {SVGElement} arrowGroup - The arrow group element
 */ function $ea12b8e382b9eaa8$var$createArrowEndpointHandles(arrowGroup) {
    const line = arrowGroup.querySelector('.arrow-line');
    if (!line) return;
    const x1 = parseFloat(line.getAttribute('x1'));
    const y1 = parseFloat(line.getAttribute('y1'));
    const x2 = parseFloat(line.getAttribute('x2'));
    const y2 = parseFloat(line.getAttribute('y2'));
    // Create start point handle
    const startHandle = $ea12b8e382b9eaa8$var$createEndpointHandle(x1, y1, 'start', arrowGroup);
    (0, $162Oa.elements).topologyCanvas.appendChild(startHandle);
    (0, $lwME4.appState).addEndpointHandle(startHandle);
    // Create end point handle
    const endHandle = $ea12b8e382b9eaa8$var$createEndpointHandle(x2, y2, 'end', arrowGroup);
    (0, $162Oa.elements).topologyCanvas.appendChild(endHandle);
    (0, $lwME4.appState).addEndpointHandle(endHandle);
}
/**
 * Create a single endpoint handle
 * @param {number} x - X position
 * @param {number} y - Y position
 * @param {string} endpointType - 'start' or 'end'
 * @param {SVGElement} shape - The parent shape
 * @returns {SVGElement} The handle element
 */ function $ea12b8e382b9eaa8$var$createEndpointHandle(x, y, endpointType, shape) {
    const handle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    handle.setAttribute('class', 'endpoint-handle');
    handle.setAttribute('cx', x);
    handle.setAttribute('cy', y);
    handle.setAttribute('r', 6);
    handle.setAttribute('fill', '#FF9800');
    handle.setAttribute('stroke', '#ffffff');
    handle.setAttribute('stroke-width', 2);
    handle.style.cursor = 'move';
    handle.setAttribute('data-endpoint-type', endpointType);
    // Add drag event listeners
    handle.addEventListener('mousedown', (e)=>{
        e.stopPropagation();
        $ea12b8e382b9eaa8$var$startEndpointDrag(shape, endpointType, e);
    });
    return handle;
}
/**
 * Start dragging an endpoint
 * @param {SVGElement} shape - The shape being modified
 * @param {string} endpointType - 'start' or 'end'
 * @param {MouseEvent} e - The mouse event
 */ function $ea12b8e382b9eaa8$var$startEndpointDrag(shape, endpointType, e) {
    (0, $lwME4.appState).isDraggingEndpoint = true;
    (0, $lwME4.appState).draggingEndpointType = endpointType;
    (0, $lwME4.appState).selectShape(shape);
    // Prevent text selection during endpoint drag
    document.body.classList.add('no-select');
    document.body.style.cursor = 'move';
}
function $ea12b8e382b9eaa8$export$4743809bd1f4064b(shape, endpointType, mouseX, mouseY) {
    const dataType = shape.getAttribute('data-shape-type');
    if (dataType === 'line') {
        // Update line endpoints
        if (endpointType === 'start') {
            shape.setAttribute('x1', mouseX);
            shape.setAttribute('y1', mouseY);
        } else {
            shape.setAttribute('x2', mouseX);
            shape.setAttribute('y2', mouseY);
        }
    } else if (dataType === 'arrow') {
        // Update arrow components
        const line = shape.querySelector('.arrow-line');
        const arrowhead = shape.querySelector('.arrow-head');
        const startCircle = shape.querySelector('.arrow-start');
        if (!line) return;
        if (endpointType === 'start') {
            // Update line start
            line.setAttribute('x1', mouseX);
            line.setAttribute('y1', mouseY);
            // Update start circle
            if (startCircle) {
                startCircle.setAttribute('cx', mouseX);
                startCircle.setAttribute('cy', mouseY);
            }
        } else {
            // Update line end
            line.setAttribute('x2', mouseX);
            line.setAttribute('y2', mouseY);
            // Update arrowhead position and orientation
            if (arrowhead) {
                const x1 = parseFloat(line.getAttribute('x1'));
                const y1 = parseFloat(line.getAttribute('y1'));
                const angle = Math.atan2(mouseY - y1, mouseX - x1);
                const headSize = 10;
                const arrowX = mouseX;
                const arrowY = mouseY;
                // Calculate arrowhead points based on angle
                const point1X = arrowX;
                const point1Y = arrowY;
                const point2X = arrowX - headSize * Math.cos(angle - Math.PI / 6);
                const point2Y = arrowY - headSize * Math.sin(angle - Math.PI / 6);
                const point3X = arrowX - headSize * Math.cos(angle + Math.PI / 6);
                const point3Y = arrowY - headSize * Math.sin(angle + Math.PI / 6);
                arrowhead.setAttribute('points', `${point1X},${point1Y} ${point2X},${point2Y} ${point3X},${point3Y}`);
            }
        }
    }
    // Update endpoint handles
    $ea12b8e382b9eaa8$export$cf512ed718143034(shape);
    // Update connections
    (0, $hkA3I.updateShapeConnections)(shape);
}
function $ea12b8e382b9eaa8$export$cf512ed718143034(shape) {
    if ((0, $lwME4.appState).endpointHandles.length === 0) return;
    const dataType = shape.getAttribute('data-shape-type');
    let x1, y1, x2, y2;
    if (dataType === 'line') {
        x1 = parseFloat(shape.getAttribute('x1'));
        y1 = parseFloat(shape.getAttribute('y1'));
        x2 = parseFloat(shape.getAttribute('x2'));
        y2 = parseFloat(shape.getAttribute('y2'));
    } else if (dataType === 'arrow') {
        const line = shape.querySelector('.arrow-line');
        if (!line) return;
        x1 = parseFloat(line.getAttribute('x1'));
        y1 = parseFloat(line.getAttribute('y1'));
        x2 = parseFloat(line.getAttribute('x2'));
        y2 = parseFloat(line.getAttribute('y2'));
    } else return;
    // Update handle positions
    if ((0, $lwME4.appState).endpointHandles[0]) {
        (0, $lwME4.appState).endpointHandles[0].setAttribute('cx', x1);
        (0, $lwME4.appState).endpointHandles[0].setAttribute('cy', y1);
    }
    if ((0, $lwME4.appState).endpointHandles[1]) {
        (0, $lwME4.appState).endpointHandles[1].setAttribute('cx', x2);
        (0, $lwME4.appState).endpointHandles[1].setAttribute('cy', y2);
    }
}
function $ea12b8e382b9eaa8$export$8a9af937093aa8f7() {
    (0, $lwME4.appState).clearEndpointHandles();
}
function $ea12b8e382b9eaa8$export$ca388c577c2cb630() {
    (0, $lwME4.appState).isDraggingEndpoint = false;
    (0, $lwME4.appState).draggingEndpointType = null;
    document.body.style.cursor = 'default';
}

});




/**
 * Main application entry point
 */ 
var $162Oa = parcelRequire("162Oa");
/**
 * Event listener setup for UI elements
 */ 
var $162Oa = parcelRequire("162Oa");
/**
 * API service for backend communication
 */ 
var $b8j1A = parcelRequire("b8j1A");

var $162Oa = parcelRequire("162Oa");
async function $7ed3f2ca01046419$export$e6e3d7943645aa22() {
    try {
        (0, $162Oa.elements).apiResponse.textContent = 'Connecting...';
        (0, $162Oa.elements).apiResponse.className = 'response loading';
        const response = await fetch(`${(0, $b8j1A.API_BASE_URL)}/api/health`);
        const data = await response.json();
        (0, $162Oa.elements).apiResponse.textContent = `API Connected`;
        (0, $162Oa.elements).apiResponse.className = 'response success';
        setTimeout(()=>{
            (0, $162Oa.elements).apiResponse.textContent = '';
            (0, $162Oa.elements).apiResponse.className = '';
        }, 3000);
    } catch (error) {
        (0, $162Oa.elements).apiResponse.textContent = `API Error: ${error.message}`;
        (0, $162Oa.elements).apiResponse.className = 'response error';
        setTimeout(()=>{
            (0, $162Oa.elements).apiResponse.textContent = '';
            (0, $162Oa.elements).apiResponse.className = '';
        }, 5000);
    }
}


/**
 * Topology file operations (export, import, clear)
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");
parcelRequire("b8j1A");

var $89InF = parcelRequire("89InF");

var $f2jpm = parcelRequire("f2jpm");

var $4DKvQ = parcelRequire("4DKvQ");

var $le39T = parcelRequire("le39T");
function $1c2baf1cfca3dbed$export$f5ba530d10156f5d() {
    // Show confirmation modal
    const modal = document.getElementById('newTopologyModal');
    const bsModal = new bootstrap.Modal(modal);
    // Set up one-time event listener for confirmation
    const confirmBtn = document.getElementById('confirmNewTopology');
    const handleConfirm = ()=>{
        $1c2baf1cfca3dbed$export$a1c066623ac679d3();
        (0, $4DKvQ.clearStorage)();
        bsModal.hide();
        confirmBtn.removeEventListener('click', handleConfirm);
    };
    confirmBtn.addEventListener('click', handleConfirm);
    bsModal.show();
}
function $1c2baf1cfca3dbed$export$d5e3c7064fd1767d() {
    const shapes = Array.from((0, $162Oa.elements).topologyCanvas.querySelectorAll('.canvas-shape'));
    const connections = Array.from((0, $162Oa.elements).topologyCanvas.querySelectorAll('.connection'));
    const topology = {
        version: '1.0',
        created: new Date().toISOString(),
        shapes: shapes.map((shape)=>{
            const shapeData = {
                id: shape.id,
                tagName: shape.tagName.toLowerCase(),
                shapeType: shape.getAttribute('data-shape-type'),
                attributes: Array.from(shape.attributes).reduce((acc, attr)=>{
                    if (attr.name !== 'class' && attr.name !== 'id') acc[attr.name] = attr.value;
                    return acc;
                }, {}),
                style: {
                    cursor: shape.style.cursor || ''
                }
            };
            // For group elements (Cisco shapes), save the innerHTML
            if (shape.tagName.toLowerCase() === 'g') shapeData.innerHTML = shape.innerHTML;
            return shapeData;
        }),
        connections: connections.map((connection)=>{
            const sourceLabelId = connection.getAttribute('data-source-label-id');
            const targetLabelId = connection.getAttribute('data-target-label-id');
            const centerLabelId = connection.getAttribute('data-center-label-id');
            const sourceLabel = sourceLabelId ? document.getElementById(sourceLabelId) : null;
            const targetLabel = targetLabelId ? document.getElementById(targetLabelId) : null;
            const centerLabel = centerLabelId ? document.getElementById(centerLabelId) : null;
            const line = connection.querySelector('.connection-line');
            return {
                id: connection.id,
                sourceId: connection.getAttribute('data-source'),
                targetId: connection.getAttribute('data-target'),
                line: line ? {
                    x1: line.getAttribute('x1'),
                    y1: line.getAttribute('y1'),
                    x2: line.getAttribute('x2'),
                    y2: line.getAttribute('y2'),
                    stroke: line.getAttribute('stroke') || '#6c757d',
                    strokeWidth: line.getAttribute('stroke-width') || '3',
                    strokeDasharray: line.getAttribute('stroke-dasharray') || ''
                } : {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                    stroke: '#6c757d',
                    strokeWidth: '3',
                    strokeDasharray: ''
                },
                sourceLabel: sourceLabel ? {
                    text: sourceLabel.textContent || '',
                    x: sourceLabel.getAttribute('x') || '0',
                    y: sourceLabel.getAttribute('y') || '0',
                    dx: sourceLabel.getAttribute('dx') || '0',
                    dy: sourceLabel.getAttribute('dy') || '0',
                    textAnchor: sourceLabel.getAttribute('text-anchor') || 'start',
                    fill: sourceLabel.getAttribute('fill') || '#333333',
                    fontSize: sourceLabel.getAttribute('font-size') || '12'
                } : {
                    text: '',
                    x: '0',
                    y: '0',
                    dx: '-5',
                    dy: '-10',
                    textAnchor: 'end',
                    fill: '#333333',
                    fontSize: '12'
                },
                targetLabel: targetLabel ? {
                    text: targetLabel.textContent || '',
                    x: targetLabel.getAttribute('x') || '0',
                    y: targetLabel.getAttribute('y') || '0',
                    dx: targetLabel.getAttribute('dx') || '0',
                    dy: targetLabel.getAttribute('dy') || '0',
                    textAnchor: targetLabel.getAttribute('text-anchor') || 'start',
                    fill: targetLabel.getAttribute('fill') || '#333333',
                    fontSize: targetLabel.getAttribute('font-size') || '12'
                } : {
                    text: '',
                    x: '0',
                    y: '0',
                    dx: '5',
                    dy: '-10',
                    textAnchor: 'start',
                    fill: '#333333',
                    fontSize: '12'
                },
                centerLabel: centerLabel ? {
                    text: centerLabel.textContent || '',
                    x: centerLabel.getAttribute('x') || '0',
                    y: centerLabel.getAttribute('y') || '0',
                    dx: centerLabel.getAttribute('dx') || '0',
                    dy: centerLabel.getAttribute('dy') || '0',
                    textAnchor: centerLabel.getAttribute('text-anchor') || 'middle',
                    fill: centerLabel.getAttribute('fill') || '#212529',
                    fontSize: centerLabel.getAttribute('font-size') || '12'
                } : {
                    text: '',
                    x: '0',
                    y: '0',
                    dx: '0',
                    dy: '-5',
                    textAnchor: 'middle',
                    fill: '#212529',
                    fontSize: '12'
                }
            };
        })
    };
    const dataStr = JSON.stringify(topology, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
    const exportFileDefaultName = `topology-${Date.now()}.json`;
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
}
function $1c2baf1cfca3dbed$export$fb6d00c0fc525e11() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = (e)=>{
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e)=>{
            try {
                const topology = JSON.parse(e.target.result);
                $1c2baf1cfca3dbed$export$f2ca600a9f0c1fa8(topology);
            } catch (error) {
                (0, $le39T.showAlert)('Error loading topology file: ' + error.message, 'Import Error', 'error');
            }
        };
        reader.readAsText(file);
    };
    input.click();
}
/**
 * Load topology from data object
 * @param {Object} topology - The topology data
 */ function $1c2baf1cfca3dbed$export$f2ca600a9f0c1fa8(topology) {
    $1c2baf1cfca3dbed$export$a1c066623ac679d3();
    if (!topology.shapes) return;
    // Restore shapes first
    topology.shapes.forEach((shapeData)=>{
        const shape = document.createElementNS('http://www.w3.org/2000/svg', shapeData.tagName || 'rect');
        // Set ID first
        shape.id = shapeData.id;
        // Restore attributes
        Object.entries(shapeData.attributes || {}).forEach(([attr, value])=>{
            if (attr !== 'class') shape.setAttribute(attr, value);
        });
        // Restore style
        if (shapeData.style && shapeData.style.cursor) shape.style.cursor = shapeData.style.cursor;
        shape.setAttribute('class', 'canvas-shape');
        (0, $89InF.addShapeEventListeners)(shape);
        const shapesLayer = document.getElementById('shapesLayer') || (0, $162Oa.elements).topologyCanvas;
        shapesLayer.appendChild(shape);
    });
    // Restore connections after shapes
    if (topology.connections && topology.connections.length > 0) topology.connections.forEach((connectionData)=>{
        try {
            // Create connection group
            const connectionGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
            connectionGroup.id = connectionData.id;
            connectionGroup.classList.add('connection');
            connectionGroup.setAttribute('data-source', connectionData.sourceId);
            connectionGroup.setAttribute('data-target', connectionData.targetId);
            // Create the line
            if (connectionData.line) {
                const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                line.setAttribute('x1', connectionData.line.x1 || 0);
                line.setAttribute('y1', connectionData.line.y1 || 0);
                line.setAttribute('x2', connectionData.line.x2 || 0);
                line.setAttribute('y2', connectionData.line.y2 || 0);
                line.setAttribute('stroke', connectionData.line.stroke || '#6c757d');
                line.setAttribute('stroke-width', connectionData.line.strokeWidth || '3');
                line.classList.add('connection-line');
                // Use inline styles to override CSS
                line.style.stroke = connectionData.line.stroke || '#6c757d';
                line.style.strokeWidth = (connectionData.line.strokeWidth || '3') + 'px';
                connectionGroup.appendChild(line);
            }
            // Add connection to the connections layer
            const connectionsLayer = document.getElementById('connectionsLayer');
            if (connectionsLayer) connectionsLayer.appendChild(connectionGroup);
            else {
                // Fallback: Insert connection before shapes
                const firstShape = (0, $162Oa.elements).topologyCanvas.querySelector('.canvas-shape');
                if (firstShape) (0, $162Oa.elements).topologyCanvas.insertBefore(connectionGroup, firstShape);
                else (0, $162Oa.elements).topologyCanvas.appendChild(connectionGroup);
            }
            // Create and append labels to the labels layer
            const labelsLayer = document.getElementById('labelsLayer');
            const labelTarget = labelsLayer || (0, $162Oa.elements).topologyCanvas;
            if (connectionData.sourceLabel) {
                const sourceLabel = $1c2baf1cfca3dbed$var$createLabelElement(connectionData.id, connectionData.sourceLabel, 'source');
                connectionGroup.setAttribute('data-source-label-id', sourceLabel.id);
                labelTarget.appendChild(sourceLabel);
            }
            if (connectionData.targetLabel) {
                const targetLabel = $1c2baf1cfca3dbed$var$createLabelElement(connectionData.id, connectionData.targetLabel, 'target');
                connectionGroup.setAttribute('data-target-label-id', targetLabel.id);
                labelTarget.appendChild(targetLabel);
            }
            if (connectionData.centerLabel) {
                const centerLabel = $1c2baf1cfca3dbed$var$createLabelElement(connectionData.id, connectionData.centerLabel, 'center');
                connectionGroup.setAttribute('data-center-label-id', centerLabel.id);
                labelTarget.appendChild(centerLabel);
            }
            // Update shape connections data
            const sourceShape = document.getElementById(connectionData.sourceId);
            const targetShape = document.getElementById(connectionData.targetId);
            if (sourceShape) {
                if (!sourceShape.dataset.connections) sourceShape.dataset.connections = '';
                sourceShape.dataset.connections += connectionData.id + ',';
            }
            if (targetShape) {
                if (!targetShape.dataset.connections) targetShape.dataset.connections = '';
                targetShape.dataset.connections += connectionData.id + ',';
            }
        } catch (error) {
            console.error('Error restoring connection:', error, connectionData);
        }
    });
    // Update the shape counter if needed
    const maxShapeId = topology.shapes.reduce((max, shape)=>{
        const match = shape.id.match(/shape-(\d+)/);
        return match ? Math.max(max, parseInt(match[1])) : max;
    }, 0);
    if (maxShapeId > 0 && maxShapeId >= (0, $lwME4.appState).shapeIdCounter) (0, $lwME4.appState).shapeIdCounter = maxShapeId + 1;
    // Update connection counter if needed
    if (topology.connections) {
        const maxConnectionId = topology.connections.reduce((max, conn)=>{
            const match = conn.id.match(/connection-(\d+)/);
            return match ? Math.max(max, parseInt(match[1])) : max;
        }, 0);
        if (maxConnectionId > 0 && maxConnectionId >= (0, $lwME4.appState).connectionIdCounter) (0, $lwME4.appState).connectionIdCounter = maxConnectionId + 1;
    }
    (0, $4DKvQ.saveAppState)();
}
/**
 * Create a label element for imported topology
 * @param {string} connectionId - The connection ID
 * @param {Object} labelData - Label data object
 * @param {string} type - 'source' or 'target'
 * @returns {SVGTextElement} The label element
 */ function $1c2baf1cfca3dbed$var$createLabelElement(connectionId, labelData, type) {
    const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    label.id = `label-${connectionId}-${type}`;
    label.setAttribute('x', labelData.x || 0);
    label.setAttribute('y', labelData.y || 0);
    label.setAttribute('dx', labelData.dx || '5');
    label.setAttribute('dy', labelData.dy || '-5');
    label.setAttribute('text-anchor', labelData.textAnchor || 'start');
    label.setAttribute('fill', labelData.fill || '#495057');
    label.setAttribute('font-size', labelData.fontSize || '12');
    label.classList.add('connection-label');
    label.classList.add(`connection-label-${type}`);
    label.setAttribute('data-connection-id', connectionId);
    label.setAttribute('data-label-type', type);
    label.textContent = labelData.text || '';
    label.style.cursor = 'move';
    label.style.userSelect = 'none';
    return label;
}
function $1c2baf1cfca3dbed$export$a1c066623ac679d3() {
    // Remove all shapes
    const shapes = (0, $162Oa.elements).topologyCanvas.querySelectorAll('.canvas-shape');
    shapes.forEach((shape)=>shape.remove());
    // Remove all connections
    const connections = (0, $162Oa.elements).topologyCanvas.querySelectorAll('.connection');
    connections.forEach((connection)=>connection.remove());
    // Remove all connection labels
    const labels = (0, $162Oa.elements).topologyCanvas.querySelectorAll('.connection-label');
    labels.forEach((label)=>label.remove());
    // Deselect any selected elements
    (0, $lwME4.appState).deselectShape();
    (0, $f2jpm.removeResizeHandles)();
    // Reset connection counter
    (0, $lwME4.appState).connectionIdCounter = 1;
    (0, $4DKvQ.saveAppState)();
}


/**
 * PNG Export functionality
 * Exports the canvas as a PNG image with automatic cropping to content
 */ 
var $162Oa = parcelRequire("162Oa");
/**
 * Calculate the bounding box that contains all shapes
 * @returns {Object} Bounding box with x, y, width, height
 */ function $3b2a74e3c78acc77$var$calculateContentBounds() {
    const shapesLayer = document.getElementById('shapesLayer');
    const connectionsLayer = document.getElementById('connectionsLayer');
    if (!shapesLayer) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    // Get bounds from all shapes
    const shapes = shapesLayer.querySelectorAll('.canvas-shape');
    shapes.forEach((shape)=>{
        const bbox = shape.getBBox();
        const transform = shape.getAttribute('transform');
        let x = bbox.x;
        let y = bbox.y;
        // Handle transform for groups (Cisco shapes)
        if (transform) {
            const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
            if (match) {
                x += parseFloat(match[1]);
                y += parseFloat(match[2]);
            }
        }
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x + bbox.width);
        maxY = Math.max(maxY, y + bbox.height);
    });
    // Include text labels (sibling labels for basic shapes)
    const labels = shapesLayer.querySelectorAll('text[data-shape-id]');
    labels.forEach((label)=>{
        const x = parseFloat(label.getAttribute('x')) || 0;
        const y = parseFloat(label.getAttribute('y')) || 0;
        const bbox = label.getBBox();
        minX = Math.min(minX, x);
        minY = Math.min(minY, y - bbox.height);
        maxX = Math.max(maxX, x + bbox.width);
        maxY = Math.max(maxY, y);
    });
    // Include connections
    if (connectionsLayer) {
        const connections = connectionsLayer.querySelectorAll('line, path, text, circle');
        connections.forEach((element)=>{
            const bbox = element.getBBox();
            minX = Math.min(minX, bbox.x);
            minY = Math.min(minY, bbox.y);
            maxX = Math.max(maxX, bbox.x + bbox.width);
            maxY = Math.max(maxY, bbox.y + bbox.height);
        });
    }
    // If no content found, return null
    if (!isFinite(minX)) return null;
    // Add padding
    const padding = 40;
    return {
        x: minX - padding,
        y: minY - padding,
        width: maxX - minX + padding * 2,
        height: maxY - minY + padding * 2
    };
}
function $3b2a74e3c78acc77$export$dacfb2bdc7f402e9() {
    const canvas = (0, $162Oa.elements).topologyCanvas;
    if (!canvas) {
        console.error('Canvas element not found');
        return;
    }
    // Calculate content bounds
    const bounds = $3b2a74e3c78acc77$var$calculateContentBounds();
    if (!bounds) {
        alert('No content to export. Please add some shapes first.');
        return;
    }
    // Create a new SVG with the cropped viewBox
    const svgClone = canvas.cloneNode(true);
    svgClone.setAttribute('viewBox', `${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`);
    svgClone.setAttribute('width', bounds.width);
    svgClone.setAttribute('height', bounds.height);
    // Remove unwanted elements from the clone
    const resizeHandles = svgClone.querySelectorAll('.resize-handle');
    resizeHandles.forEach((handle)=>handle.remove());
    const interactionCircles = svgClone.querySelectorAll('[id*="interaction-circle"]');
    interactionCircles.forEach((circle)=>circle.remove());
    const endpointHandles = svgClone.querySelectorAll('[class*="endpoint-handle"]');
    endpointHandles.forEach((handle)=>handle.remove());
    // Remove selection styles
    const selectedElements = svgClone.querySelectorAll('.selected');
    selectedElements.forEach((el)=>el.classList.remove('selected'));
    // Serialize the SVG
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgClone);
    const svgBlob = new Blob([
        svgString
    ], {
        type: 'image/svg+xml;charset=utf-8'
    });
    const svgUrl = URL.createObjectURL(svgBlob);
    // Create an image from the SVG
    const img = new Image();
    img.onload = function() {
        // Create a canvas to render the image at high resolution
        const scaleFactor = 4; // 4x resolution for high quality
        const canvas = document.createElement('canvas');
        canvas.width = bounds.width * scaleFactor;
        canvas.height = bounds.height * scaleFactor;
        const ctx = canvas.getContext('2d');
        // Enable high-quality image rendering
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        // Fill with white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // Draw the image at scaled resolution
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // Convert to PNG and download with high quality
        canvas.toBlob((blob)=>{
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `topology-${new Date().toISOString().slice(0, 10)}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Cleanup
            URL.revokeObjectURL(url);
            URL.revokeObjectURL(svgUrl);
        }, 'image/png', 1.0); // 1.0 = maximum quality
    };
    img.onerror = function() {
        console.error('Failed to load SVG image');
        alert('Failed to export PNG. Please try again.');
        URL.revokeObjectURL(svgUrl);
    };
    img.src = svgUrl;
}


/**
 * Canvas zoom functionality
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $b8j1A = parcelRequire("b8j1A");

var $4DKvQ = parcelRequire("4DKvQ");
function $7bd485089488656c$export$3b71758b3ed5255f() {
    (0, $lwME4.appState).currentZoom = Math.min((0, $lwME4.appState).currentZoom * (0, $b8j1A.ZOOM_CONFIG).STEP, (0, $b8j1A.ZOOM_CONFIG).MAX);
    $7bd485089488656c$var$updateZoom();
}
function $7bd485089488656c$export$9fdb0a49c6b4b521() {
    (0, $lwME4.appState).currentZoom = Math.max((0, $lwME4.appState).currentZoom / (0, $b8j1A.ZOOM_CONFIG).STEP, (0, $b8j1A.ZOOM_CONFIG).MIN);
    $7bd485089488656c$var$updateZoom();
}
function $7bd485089488656c$export$ac12f90bdc1d9b7() {
    (0, $lwME4.appState).currentZoom = (0, $b8j1A.ZOOM_CONFIG).DEFAULT;
    $7bd485089488656c$var$updateZoom();
    // Center the canvas
    (0, $162Oa.elements).canvasWrapper.scrollLeft = ((0, $162Oa.elements).topologyCanvas.clientWidth - (0, $162Oa.elements).canvasWrapper.clientWidth) / 2;
    (0, $162Oa.elements).canvasWrapper.scrollTop = ((0, $162Oa.elements).topologyCanvas.clientHeight - (0, $162Oa.elements).canvasWrapper.clientHeight) / 2;
}
/**
 * Update the canvas zoom level and display
 */ function $7bd485089488656c$var$updateZoom() {
    (0, $162Oa.elements).canvas.style.transform = `scale(${(0, $lwME4.appState).currentZoom})`;
    if ((0, $162Oa.elements).zoomLevel) (0, $162Oa.elements).zoomLevel.textContent = `${Math.round((0, $lwME4.appState).currentZoom * 100)}%`;
    // Persist zoom level
    (0, $4DKvQ.saveZoom)();
}


function $c1c0c7dc7f537ac0$export$2e773a31cc80e22d() {
    $c1c0c7dc7f537ac0$var$setupApiListeners();
    $c1c0c7dc7f537ac0$var$setupMenuListeners();
    $c1c0c7dc7f537ac0$var$setupCanvasControlListeners();
}
/**
 * Setup API-related event listeners
 */ function $c1c0c7dc7f537ac0$var$setupApiListeners() {
    (0, $162Oa.elements).testApiBtn.addEventListener('click', (0, $7ed3f2ca01046419$export$e6e3d7943645aa22));
}
/**
 * Setup menu event listeners
 */ function $c1c0c7dc7f537ac0$var$setupMenuListeners() {
    (0, $162Oa.elements).newTopologyBtn.addEventListener('click', (0, $1c2baf1cfca3dbed$export$f5ba530d10156f5d));
    (0, $162Oa.elements).exportBtn.addEventListener('click', (0, $1c2baf1cfca3dbed$export$d5e3c7064fd1767d));
    (0, $162Oa.elements).exportPngBtn.addEventListener('click', (0, $3b2a74e3c78acc77$export$dacfb2bdc7f402e9));
    (0, $162Oa.elements).importBtn.addEventListener('click', (0, $1c2baf1cfca3dbed$export$fb6d00c0fc525e11));
}
/**
 * Setup canvas control event listeners
 */ function $c1c0c7dc7f537ac0$var$setupCanvasControlListeners() {
    // Sidebar controls (only if they exist)
    if ((0, $162Oa.elements).zoomInBtn) (0, $162Oa.elements).zoomInBtn.addEventListener('click', (0, $7bd485089488656c$export$3b71758b3ed5255f));
    if ((0, $162Oa.elements).zoomOutBtn) (0, $162Oa.elements).zoomOutBtn.addEventListener('click', (0, $7bd485089488656c$export$9fdb0a49c6b4b521));
    if ((0, $162Oa.elements).resetZoomBtn) (0, $162Oa.elements).resetZoomBtn.addEventListener('click', (0, $7bd485089488656c$export$ac12f90bdc1d9b7));
    if ((0, $162Oa.elements).clearCanvasBtn) (0, $162Oa.elements).clearCanvasBtn.addEventListener('click', (0, $1c2baf1cfca3dbed$export$a1c066623ac679d3));
    // Floating controls - hide tooltips on click
    (0, $162Oa.elements).zoomInBtnFloating.addEventListener('click', ()=>{
        $c1c0c7dc7f537ac0$var$hideTooltip((0, $162Oa.elements).zoomInBtnFloating);
        (0, $7bd485089488656c$export$3b71758b3ed5255f)();
    });
    (0, $162Oa.elements).zoomOutBtnFloating.addEventListener('click', ()=>{
        $c1c0c7dc7f537ac0$var$hideTooltip((0, $162Oa.elements).zoomOutBtnFloating);
        (0, $7bd485089488656c$export$9fdb0a49c6b4b521)();
    });
    (0, $162Oa.elements).resetZoomBtnFloating.addEventListener('click', ()=>{
        $c1c0c7dc7f537ac0$var$hideTooltip((0, $162Oa.elements).resetZoomBtnFloating);
        (0, $7bd485089488656c$export$ac12f90bdc1d9b7)();
    });
}
/**
 * Hide Bootstrap tooltip for an element
 */ function $c1c0c7dc7f537ac0$var$hideTooltip(element) {
    if (element) {
        const tooltipInstance = window.bootstrap.Tooltip.getInstance(element);
        if (tooltipInstance) tooltipInstance.hide();
    }
}


/**
 * Keyboard shortcuts handler
 */ 
var $lwME4 = parcelRequire("lwME4");

var $f2jpm = parcelRequire("f2jpm");


var $4DKvQ = parcelRequire("4DKvQ");

var $hkA3I = parcelRequire("hkA3I");
function $564da1315aa2876b$export$33b7ddbdf2c41949() {
    document.addEventListener('keydown', $564da1315aa2876b$var$handleKeyDown);
}
/**
 * Handle keydown events
 * @param {KeyboardEvent} e - The keyboard event
 */ function $564da1315aa2876b$var$handleKeyDown(e) {
    // Ignore keyboard shortcuts if user is typing in an input, textarea, or contenteditable element
    const isTyping = e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable;
    if (isTyping) return; // Let the input handle the key event
    // Delete/Backspace key - delete selected shape
    // On macOS, the delete key sends 'Backspace', on Windows/Linux it sends 'Delete'
    if ((e.key === 'Delete' || e.key === 'Backspace') && (0, $lwME4.appState).selectedShape) {
        // Delete all connections for this shape first
        (0, $hkA3I.deleteShapeConnections)((0, $lwME4.appState).selectedShape);
        // Delete associated label if it's a basic shape with sibling label
        const shapeId = (0, $lwME4.appState).selectedShape.getAttribute('id');
        const siblingLabel = (0, $lwME4.appState).selectedShape.parentNode?.querySelector(`text[data-shape-id="${shapeId}"]`);
        if (siblingLabel) siblingLabel.remove();
        (0, $lwME4.appState).selectedShape.remove();
        (0, $lwME4.appState).deselectShape();
        (0, $f2jpm.removeResizeHandles)();
        // Persist state after deleting shape
        (0, $4DKvQ.saveAppState)();
        return;
    }
    // Escape key - deselect shape
    if (e.key === 'Escape') {
        (0, $f2jpm.deselectShape)();
        return;
    }
    // Zoom shortcuts (Ctrl/Cmd + =/-/0)
    if (e.ctrlKey || e.metaKey) switch(e.key){
        case '=':
        case '+':
            e.preventDefault();
            (0, $7bd485089488656c$export$3b71758b3ed5255f)();
            break;
        case '-':
            e.preventDefault();
            (0, $7bd485089488656c$export$9fdb0a49c6b4b521)();
            break;
        case '0':
            e.preventDefault();
            (0, $7bd485089488656c$export$ac12f90bdc1d9b7)();
            break;
    }
}


/**
 * Toolbar drag and drop functionality
 */ parcelRequire("162Oa");
function $1bdc8349b5a8317a$export$8ac0af29ee290079() {
    const shapeTools = document.querySelectorAll('.shape-tool');
    shapeTools.forEach((tool)=>{
        tool.addEventListener('dragstart', (e)=>{
            const shapeType = tool.getAttribute('data-shape');
            const isCisco = tool.getAttribute('data-cisco') === 'true';
            e.dataTransfer.setData('text/plain', shapeType);
            e.dataTransfer.setData('cisco', isCisco ? 'true' : 'false');
            e.dataTransfer.effectAllowed = 'copy';
        });
    });
}


/**
 * Canvas event handlers
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $f2jpm = parcelRequire("f2jpm");

var $cqSAC = parcelRequire("cqSAC");
/**
 * Canvas panning functionality
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $4DKvQ = parcelRequire("4DKvQ");
function $a2153c9f9bc61548$export$e8049d694ec3c6db(e) {
    (0, $lwME4.appState).isPanningCanvas = true;
    (0, $lwME4.appState).panStartX = e.clientX + (0, $162Oa.elements).canvasWrapper.scrollLeft;
    (0, $lwME4.appState).panStartY = e.clientY + (0, $162Oa.elements).canvasWrapper.scrollTop;
    (0, $162Oa.elements).topologyCanvas.style.cursor = 'grabbing';
    e.preventDefault();
}
function $a2153c9f9bc61548$export$be1ea4b2e7533abf(e) {
    if (!(0, $lwME4.appState).isPanningCanvas) return false;
    // Pan the canvas by adjusting scroll position
    (0, $162Oa.elements).canvasWrapper.scrollLeft = (0, $lwME4.appState).panStartX - e.clientX;
    (0, $162Oa.elements).canvasWrapper.scrollTop = (0, $lwME4.appState).panStartY - e.clientY;
    return true;
}
function $a2153c9f9bc61548$export$9aa1e16b497891aa() {
    if ((0, $lwME4.appState).isPanningCanvas) {
        (0, $lwME4.appState).isPanningCanvas = false;
        // Don't change cursor if in selection mode
        if (!(0, $lwME4.appState).isSelectionMode) (0, $162Oa.elements).topologyCanvas.style.cursor = 'grab';
        // Persist scroll position after panning
        (0, $4DKvQ.saveScrollPosition)();
    }
}



var $gLqu3 = parcelRequire("gLqu3");

var $4DKvQ = parcelRequire("4DKvQ");

var $hkA3I = parcelRequire("hkA3I");

var $cgpVJ = parcelRequire("cgpVJ");

var $k5XSw = parcelRequire("k5XSw");
function $87579d676bc22961$export$b35ac6730b96dd26() {
    $87579d676bc22961$var$setupCanvasMouseEvents();
    $87579d676bc22961$var$setupCanvasDropZone();
}
/**
 * Setup mouse events for canvas (panning and deselection)
 */ function $87579d676bc22961$var$setupCanvasMouseEvents() {
    // Canvas mousedown for panning
    (0, $162Oa.elements).topologyCanvas.addEventListener('mousedown', (e)=>{
        // Don't start panning in selection mode
        if ((0, $lwME4.appState).isSelectionMode) return;
        // Only start panning if clicking on canvas background (not on shapes or handles)
        if (e.target === (0, $162Oa.elements).topologyCanvas || e.target.tagName === 'rect' && e.target.getAttribute('fill') === 'url(#grid)') (0, $a2153c9f9bc61548$export$e8049d694ec3c6db)(e);
    });
    // Canvas click (deselect shapes)
    (0, $162Oa.elements).topologyCanvas.addEventListener('click', (e)=>{
        // Deselect if clicking on canvas background or grid (not on shapes or resize handles)
        if ((0, $lwME4.appState).selectedShape || document.querySelector('.connection.selected, .connection-label.selected')) {
            const isCanvas = e.target === (0, $162Oa.elements).topologyCanvas;
            const isGrid = e.target.tagName === 'rect' && e.target.getAttribute('fill') === 'url(#grid)';
            const isResizeHandle = e.target.classList && e.target.classList.contains('resize-handle');
            const isShape = e.target.tagName === 'circle' || e.target.tagName === 'ellipse' || e.target.tagName === 'rect' && !isGrid && !isResizeHandle;
            const isConnection = e.target.classList && e.target.classList.contains('connection-line');
            const isLabel = e.target.classList && e.target.classList.contains('connection-label');
            if (!isShape && !isResizeHandle && !isConnection && !isLabel) {
                (0, $f2jpm.deselectShape)();
                (0, $cgpVJ.deselectAll)();
            }
        }
    });
    // Global mouse move handler
    document.addEventListener('mousemove', $87579d676bc22961$var$handleGlobalMouseMove);
    // Global mouse up handler
    document.addEventListener('mouseup', $87579d676bc22961$var$handleGlobalMouseUp);
}
/**
 * Handle global mouse move for dragging, resizing, and panning
 * @param {MouseEvent} e - The mouse event
 */ function $87579d676bc22961$var$handleGlobalMouseMove(e) {
    // Handle panning first
    if ((0, $a2153c9f9bc61548$export$be1ea4b2e7533abf)(e)) return;
    const canvasRect = (0, $162Oa.elements).topologyCanvas.getBoundingClientRect();
    const mouseX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
    const mouseY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
    // Handle endpoint dragging
    if ((0, $lwME4.appState).isDraggingEndpoint && (0, $lwME4.appState).selectedShape && (0, $lwME4.appState).draggingEndpointType) {
        (0, $k5XSw.handleEndpointDrag)((0, $lwME4.appState).selectedShape, (0, $lwME4.appState).draggingEndpointType, mouseX, mouseY);
        return;
    }
    // Handle resizing
    if ((0, $lwME4.appState).isResizing && (0, $lwME4.appState).selectedShape && (0, $lwME4.appState).resizeHandle) {
        (0, $cqSAC.handleResize)((0, $lwME4.appState).selectedShape, (0, $lwME4.appState).resizeHandle, mouseX, mouseY);
        return;
    }
    // Check for drag threshold - only start dragging if mouse moved enough
    if ((0, $lwME4.appState).isMouseDown && !(0, $lwME4.appState).isDraggingShape && (0, $lwME4.appState).selectedShape) {
        const deltaX = Math.abs(e.clientX - (0, $lwME4.appState).dragStartX);
        const deltaY = Math.abs(e.clientY - (0, $lwME4.appState).dragStartY);
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        if (distance > (0, $lwME4.appState).dragThreshold) {
            // User has moved the mouse enough, start dragging
            (0, $lwME4.appState).isDraggingShape = true;
            // Prevent text selection during drag
            document.body.classList.add('no-select');
            // Recalculate drag offsets based on CURRENT mouse position and shape position
            // This prevents the shape from jumping when dragging starts
            const shape = (0, $lwME4.appState).selectedShape;
            if (shape.tagName === 'g') {
                const transform = shape.getAttribute('transform');
                let tx = 0, ty = 0;
                if (transform) {
                    const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
                    if (match) {
                        tx = parseFloat(match[1]);
                        ty = parseFloat(match[2]);
                    }
                }
                (0, $lwME4.appState).dragOffsetX = mouseX - tx;
                (0, $lwME4.appState).dragOffsetY = mouseY - ty;
            } else if (shape.tagName === 'circle' || shape.tagName === 'ellipse') {
                (0, $lwME4.appState).dragOffsetX = mouseX - parseFloat(shape.getAttribute('cx'));
                (0, $lwME4.appState).dragOffsetY = mouseY - parseFloat(shape.getAttribute('cy'));
            } else if (shape.tagName === 'rect') {
                const x = parseFloat(shape.getAttribute('x'));
                const y = parseFloat(shape.getAttribute('y'));
                (0, $lwME4.appState).dragOffsetX = mouseX - x;
                (0, $lwME4.appState).dragOffsetY = mouseY - y;
            }
        }
    }
    // Handle shape dragging (only if we've passed the threshold)
    if ((0, $lwME4.appState).isDraggingShape && (0, $lwME4.appState).selectedShape) $87579d676bc22961$var$handleShapeDragging(mouseX, mouseY);
}
/**
 * Update sibling label position for basic shapes
 * @param {SVGElement} shape - The shape element
 */ function $87579d676bc22961$var$updateSiblingLabelPosition(shape) {
    // Only for basic shapes (circle, rect, ellipse)
    if (shape.tagName !== 'circle' && shape.tagName !== 'rect' && shape.tagName !== 'ellipse') return;
    // Find sibling label
    const shapeId = shape.getAttribute('id');
    const labelEl = shape.parentNode?.querySelector(`text[data-shape-id="${shapeId}"]`);
    if (!labelEl) return;
    // Get label position preference
    const position = labelEl.getAttribute('data-position') || 'below';
    const offset = 20;
    // Get shape dimensions and position
    let width, height, x, y;
    if (shape.tagName === 'circle') {
        const r = parseFloat(shape.getAttribute('r')) || 30;
        const cx = parseFloat(shape.getAttribute('cx')) || 0;
        const cy = parseFloat(shape.getAttribute('cy')) || 0;
        width = r * 2;
        height = r * 2;
        x = cx;
        y = cy;
    } else if (shape.tagName === 'ellipse') {
        const rx = parseFloat(shape.getAttribute('rx')) || 40;
        const ry = parseFloat(shape.getAttribute('ry')) || 30;
        const cx = parseFloat(shape.getAttribute('cx')) || 0;
        const cy = parseFloat(shape.getAttribute('cy')) || 0;
        width = rx * 2;
        height = ry * 2;
        x = cx;
        y = cy;
    } else if (shape.tagName === 'rect') {
        width = parseFloat(shape.getAttribute('width')) || 60;
        height = parseFloat(shape.getAttribute('height')) || 40;
        x = parseFloat(shape.getAttribute('x')) || 0;
        y = parseFloat(shape.getAttribute('y')) || 0;
    }
    // Calculate label position (circles/ellipses use center coords, rects use corner)
    const isCircular = shape.tagName === 'circle' || shape.tagName === 'ellipse';
    let labelX, labelY;
    switch(position){
        case 'above':
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y - height / 2 - offset : y - offset;
            break;
        case 'below':
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y + height / 2 + offset : y + height + offset;
            break;
        case 'left':
            labelX = isCircular ? x - width / 2 - offset : x - offset;
            labelY = isCircular ? y : y + height / 2;
            break;
        case 'right':
            labelX = isCircular ? x + width / 2 + offset : x + width + offset;
            labelY = isCircular ? y : y + height / 2;
            break;
        case 'center':
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y + 5 : y + height / 2 + 5;
            break;
        default:
            labelX = isCircular ? x : x + width / 2;
            labelY = isCircular ? y + height / 2 + offset : y + height + offset;
    }
    labelEl.setAttribute('x', labelX);
    labelEl.setAttribute('y', labelY);
}
/**
 * Handle shape dragging
 */ function $87579d676bc22961$var$handleShapeDragging(mouseX, mouseY) {
    const shape = (0, $lwME4.appState).selectedShape;
    const newX = mouseX - (0, $lwME4.appState).dragOffsetX;
    const newY = mouseY - (0, $lwME4.appState).dragOffsetY;
    const dataType = shape.getAttribute('data-shape-type');
    // Update shape position based on type
    if (shape.tagName === 'g') {
        // Handle group elements (Cisco shapes and arrows)
        if (dataType === 'arrow') {
            // For arrows, move all components together
            const line = shape.querySelector('.arrow-line');
            const arrowhead = shape.querySelector('.arrow-head');
            const startCircle = shape.querySelector('.arrow-start');
            if (line) {
                const oldX1 = parseFloat(line.getAttribute('x1'));
                const oldY1 = parseFloat(line.getAttribute('y1'));
                const oldX2 = parseFloat(line.getAttribute('x2'));
                const oldY2 = parseFloat(line.getAttribute('y2'));
                const oldCenterX = (oldX1 + oldX2) / 2;
                const oldCenterY = (oldY1 + oldY2) / 2;
                const deltaX = newX - oldCenterX;
                const deltaY = newY - oldCenterY;
                // Update line
                line.setAttribute('x1', oldX1 + deltaX);
                line.setAttribute('y1', oldY1 + deltaY);
                line.setAttribute('x2', oldX2 + deltaX);
                line.setAttribute('y2', oldY2 + deltaY);
                // Update arrowhead
                if (arrowhead) {
                    const points = arrowhead.getAttribute('points').split(' ');
                    const newPoints = points.map((point)=>{
                        const [x, y] = point.split(',').map(Number);
                        return `${x + deltaX},${y + deltaY}`;
                    }).join(' ');
                    arrowhead.setAttribute('points', newPoints);
                }
                // Update start circle
                if (startCircle) {
                    const cx = parseFloat(startCircle.getAttribute('cx'));
                    const cy = parseFloat(startCircle.getAttribute('cy'));
                    startCircle.setAttribute('cx', cx + deltaX);
                    startCircle.setAttribute('cy', cy + deltaY);
                }
            }
        } else // Cisco shapes with transform
        shape.setAttribute('transform', `translate(${newX}, ${newY})`);
    } else if (shape.tagName === 'line') {
        // For lines, move both endpoints
        const oldX1 = parseFloat(shape.getAttribute('x1'));
        const oldY1 = parseFloat(shape.getAttribute('y1'));
        const oldX2 = parseFloat(shape.getAttribute('x2'));
        const oldY2 = parseFloat(shape.getAttribute('y2'));
        const oldCenterX = (oldX1 + oldX2) / 2;
        const oldCenterY = (oldY1 + oldY2) / 2;
        const deltaX = newX - oldCenterX;
        const deltaY = newY - oldCenterY;
        shape.setAttribute('x1', oldX1 + deltaX);
        shape.setAttribute('y1', oldY1 + deltaY);
        shape.setAttribute('x2', oldX2 + deltaX);
        shape.setAttribute('y2', oldY2 + deltaY);
    } else if (shape.tagName === 'circle') {
        shape.setAttribute('cx', newX);
        shape.setAttribute('cy', newY);
    } else if (shape.tagName === 'ellipse') {
        shape.setAttribute('cx', newX);
        shape.setAttribute('cy', newY);
    } else if (shape.tagName === 'rect') {
        shape.setAttribute('x', newX);
        shape.setAttribute('y', newY);
    }
    // Update sibling label position if shape has one
    $87579d676bc22961$var$updateSiblingLabelPosition(shape);
    // Update resize handles
    (0, $f2jpm.updateResizeHandles)(shape);
    // Update any connections to this shape
    (0, $hkA3I.updateShapeConnections)(shape);
}

/**
 * Handle global mouse up event
 */ function $87579d676bc22961$var$handleGlobalMouseUp() {
    const wasInteracting = (0, $lwME4.appState).isDraggingShape || (0, $lwME4.appState).isResizing || (0, $lwME4.appState).isDraggingEndpoint;
    const wasResizing = (0, $lwME4.appState).isResizing;
    const wasDragging = (0, $lwME4.appState).isDraggingShape;
    const wasDraggingEndpoint = (0, $lwME4.appState).isDraggingEndpoint;
    const interactedShape = (0, $lwME4.appState).selectedShape;
    // Re-enable text selection
    document.body.classList.remove('no-select');
    // Stop endpoint dragging if active
    if (wasDraggingEndpoint) (0, $k5XSw.stopEndpointDrag)();
    (0, $lwME4.appState).reset();
    (0, $a2153c9f9bc61548$export$9aa1e16b497891aa)();
    // Reset cursor
    document.body.style.cursor = 'default';
    (0, $162Oa.elements).topologyCanvas.style.cursor = 'grab';
    // Update interaction circle after resize or drag is complete
    if ((wasResizing || wasDragging || wasDraggingEndpoint) && interactedShape) {
        const { updateInteractionCirclePosition: updateInteractionCirclePosition } = (parcelRequire("hqYiK"));
        updateInteractionCirclePosition(interactedShape);
    }
    // Save state if user was interacting with shapes
    if (wasInteracting) (0, $4DKvQ.saveAppState)();
}
/**
 * Setup drop zone for shapes from toolbar
 */ function $87579d676bc22961$var$setupCanvasDropZone() {
    (0, $162Oa.elements).topologyCanvas.addEventListener('dragover', (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
        (0, $162Oa.elements).topologyCanvas.classList.add('dragging-over');
    });
    (0, $162Oa.elements).topologyCanvas.addEventListener('dragleave', (e)=>{
        e.preventDefault();
        (0, $162Oa.elements).topologyCanvas.classList.remove('dragging-over');
    });
    (0, $162Oa.elements).topologyCanvas.addEventListener('drop', (e)=>{
        e.preventDefault();
        (0, $162Oa.elements).topologyCanvas.classList.remove('dragging-over');
        const shapeType = e.dataTransfer.getData('text/plain');
        const isCisco = e.dataTransfer.getData('cisco') === 'true';
        const canvasRect = (0, $162Oa.elements).topologyCanvas.getBoundingClientRect();
        const x = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
        const y = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
        const shape = (0, $gLqu3.createShape)(shapeType, x, y, isCisco);
        if (shape) {
            const shapesLayer = document.getElementById('shapesLayer') || (0, $162Oa.elements).topologyCanvas;
            shapesLayer.appendChild(shape);
            (0, $4DKvQ.saveAppState)();
        }
    });
}



/**
 * State restoration functionality
 * Restores saved topology, zoom level, and scroll position from localStorage
 */ 
var $lwME4 = parcelRequire("lwME4");

var $162Oa = parcelRequire("162Oa");

var $gLqu3 = parcelRequire("gLqu3");

var $89InF = parcelRequire("89InF");

var $4DKvQ = parcelRequire("4DKvQ");

var $cgpVJ = parcelRequire("cgpVJ");

var $b8j1A = parcelRequire("b8j1A");
function $b18534792cfb37d0$export$32e2ba60a07f30a6() {
    // Check if there's saved data to restore
    if (!(0, $4DKvQ.hasSavedData)()) {
        console.log('No saved data to restore');
        return;
    }
    console.log('Restoring saved application state...');
    // Restore shape counter first (so new shapes get correct IDs)
    const savedCounter = (0, $4DKvQ.loadShapeCounter)();
    if (savedCounter !== null) {
        (0, $lwME4.appState).shapeIdCounter = savedCounter;
        console.log(`Restored shape counter: ${savedCounter}`);
    }
    // Restore connection counter
    const savedConnectionCounter = (0, $4DKvQ.loadConnectionCounter)();
    if (savedConnectionCounter !== null) {
        (0, $lwME4.appState).connectionIdCounter = savedConnectionCounter;
        console.log(`Restored connection counter: ${savedConnectionCounter}`);
    }
    // Restore topology (shapes and connections)
    const topology = (0, $4DKvQ.loadTopology)();
    if (topology && topology.shapes) {
        $b18534792cfb37d0$var$restoreShapes(topology.shapes);
        console.log(`Restored ${topology.shapes.length} shapes`);
        // Restore connections after shapes (so shapes exist)
        if (topology.connections && topology.connections.length > 0) {
            $b18534792cfb37d0$var$restoreConnections(topology.connections);
            console.log(`Restored ${topology.connections.length} connections`);
        }
    }
    // Restore zoom level
    const zoom = (0, $4DKvQ.loadZoom)();
    if (zoom !== null) {
        (0, $lwME4.appState).currentZoom = zoom;
        (0, $162Oa.elements).canvas.style.transform = `scale(${zoom})`;
        if ((0, $162Oa.elements).zoomLevel) (0, $162Oa.elements).zoomLevel.textContent = `${Math.round(zoom * 100)}%`;
        console.log(`Restored zoom level: ${Math.round(zoom * 100)}%`);
    }
    // Restore scroll position (must be done after a small delay to ensure DOM is ready)
    setTimeout(()=>{
        const scrollPos = (0, $4DKvQ.loadScrollPosition)();
        if (scrollPos) {
            (0, $162Oa.elements).canvasWrapper.scrollLeft = scrollPos.left;
            (0, $162Oa.elements).canvasWrapper.scrollTop = scrollPos.top;
            console.log(`Restored scroll position: (${scrollPos.left}, ${scrollPos.top})`);
        }
    }, 100);
}
/**
 * Restore shapes to the canvas from saved data
 * @param {Array} shapesData - Array of shape data objects
 */ function $b18534792cfb37d0$var$restoreShapes(shapesData) {
    shapesData.forEach((shapeData, index)=>{
        try {
            console.log(`Restoring shape ${index + 1}:`, shapeData);
            // Create the SVG element based on the saved data
            const shape = $b18534792cfb37d0$var$createShapeElement(shapeData);
            // Determine which layer to add the shape to
            const targetLayerId = shapeData.layer || 'shapesLayer';
            const targetLayer = document.getElementById(targetLayerId) || document.getElementById('shapesLayer') || (0, $162Oa.elements).canvas;
            console.log(`Adding shape to layer: ${targetLayer.id}`);
            targetLayer.appendChild(shape);
            // Add event listeners to make it interactive
            (0, $89InF.addShapeEventListeners)(shape);
            console.log(`Shape ${index + 1} restored successfully:`, shape);
        } catch (error) {
            console.error('Error restoring shape:', error, shapeData);
        }
    });
}
/**
 * Create an SVG shape element from saved data
 * @param {Object} shapeData - Shape data object
 * @returns {SVGElement} The created shape element
 */ function $b18534792cfb37d0$var$createShapeElement(shapeData) {
    const { tagName: tagName, id: id, attributes: attributes, style: style, innerHTML: innerHTML } = shapeData;
    // Create the SVG element using the correct tag name
    const shape = document.createElementNS('http://www.w3.org/2000/svg', tagName);
    // Set the ID
    if (id) shape.id = id;
    // Add the canvas-shape class
    shape.classList.add('canvas-shape');
    // Add cisco-shape class if it's a group element
    if (tagName === 'g' && attributes && attributes['data-cisco'] === 'true') shape.classList.add('cisco-shape');
    // Set attributes
    if (attributes) Object.entries(attributes).forEach(([key, value])=>{
        shape.setAttribute(key, value);
    });
    // Set inline styles
    if (style) Object.entries(style).forEach(([key, value])=>{
        if (value) shape.style[key] = value;
    });
    // For group elements (Cisco shapes), restore or recreate the innerHTML
    if (tagName === 'g') {
        if (innerHTML && innerHTML.trim() !== '') // Restore from saved innerHTML
        shape.innerHTML = innerHTML;
        else {
            // innerHTML is empty or missing - need to recreate the Cisco shape
            const shapeType = attributes['data-shape-type'];
            if (shapeType && (0, $b8j1A.CISCO_SHAPES)[shapeType]) $b18534792cfb37d0$var$recreateCiscoShapeContent(shape, (0, $b8j1A.CISCO_SHAPES)[shapeType]);
        }
    }
    return shape;
}
/**
 * Recreate the innerHTML content for a Cisco shape
 * @param {SVGElement} group - The group element
 * @param {Object} ciscoTemplate - The Cisco shape template
 */ function $b18534792cfb37d0$var$recreateCiscoShapeContent(group, ciscoTemplate) {
    // Parse viewBox to get original dimensions
    const viewBoxParts = ciscoTemplate.viewBox.split(' ').map(Number);
    const [vbX, vbY, vbWidth, vbHeight] = viewBoxParts;
    // Scale to fit within 60x60 while maintaining aspect ratio
    const targetSize = 60;
    const scale = Math.min(targetSize / vbWidth, targetSize / vbHeight);
    const scaledWidth = vbWidth * scale;
    const scaledHeight = vbHeight * scale;
    // Create an SVG element to properly handle viewBox
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', scaledWidth);
    svg.setAttribute('height', scaledHeight);
    svg.setAttribute('viewBox', ciscoTemplate.viewBox);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    // Add a white background rectangle for visibility
    const bgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    bgRect.setAttribute('x', vbX);
    bgRect.setAttribute('y', vbY);
    bgRect.setAttribute('width', vbWidth);
    bgRect.setAttribute('height', vbHeight);
    bgRect.setAttribute('fill', '#ffffff');
    bgRect.setAttribute('rx', '3');
    svg.appendChild(bgRect);
    // Create the shape path with proper fill
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', ciscoTemplate.svgPath);
    path.setAttribute('fill', ciscoTemplate.attributes.fill);
    path.setAttribute('stroke', ciscoTemplate.attributes.stroke || 'none');
    svg.appendChild(path);
    group.appendChild(svg);
    // Add label text below the shape
    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.setAttribute('x', scaledWidth / 2);
    text.setAttribute('y', scaledHeight + 12);
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('fill', '#333');
    text.setAttribute('font-size', '10');
    text.setAttribute('font-weight', 'bold');
    text.textContent = ciscoTemplate.label;
    group.appendChild(text);
}
/**
 * Restore connections to the canvas from saved data
 * @param {Array} connectionsData - Array of connection data objects
 */ function $b18534792cfb37d0$var$restoreConnections(connectionsData) {
    connectionsData.forEach((connectionData, index)=>{
        try {
            console.log(`Restoring connection ${index + 1}:`, connectionData);
            // Create connection group
            const connectionGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
            connectionGroup.id = connectionData.id;
            connectionGroup.classList.add('connection');
            connectionGroup.setAttribute('data-source', connectionData.sourceId);
            connectionGroup.setAttribute('data-target', connectionData.targetId);
            // Create the line
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', connectionData.line.x1);
            line.setAttribute('y1', connectionData.line.y1);
            line.setAttribute('x2', connectionData.line.x2);
            line.setAttribute('y2', connectionData.line.y2);
            line.setAttribute('stroke', connectionData.line.stroke || '#6c757d');
            line.setAttribute('stroke-width', connectionData.line.strokeWidth || '3');
            line.classList.add('connection-line');
            // Use inline styles to override CSS
            line.style.stroke = connectionData.line.stroke || '#6c757d';
            line.style.strokeWidth = (connectionData.line.strokeWidth || '3') + 'px';
            // Apply stroke-dasharray if present
            if (connectionData.line.strokeDasharray) {
                line.setAttribute('stroke-dasharray', connectionData.line.strokeDasharray);
                line.style.strokeDasharray = connectionData.line.strokeDasharray;
            }
            // Create invisible wider line for easier clicking (hit target)
            const hitTarget = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            hitTarget.setAttribute('x1', connectionData.line.x1);
            hitTarget.setAttribute('y1', connectionData.line.y1);
            hitTarget.setAttribute('x2', connectionData.line.x2);
            hitTarget.setAttribute('y2', connectionData.line.y2);
            hitTarget.setAttribute('stroke', 'transparent');
            hitTarget.setAttribute('stroke-width', '12'); // Wider hit area
            hitTarget.classList.add('connection-hit-target');
            hitTarget.style.cursor = 'pointer';
            hitTarget.style.strokeWidth = '12px';
            // Create source label
            const sourceLabel = $b18534792cfb37d0$var$createConnectionLabelElement(connectionData.id, connectionData.sourceLabel, 'source');
            // Create target label
            const targetLabel = $b18534792cfb37d0$var$createConnectionLabelElement(connectionData.id, connectionData.targetLabel, 'target');
            // Create center label
            const centerLabel = $b18534792cfb37d0$var$createConnectionLabelElement(connectionData.id, connectionData.centerLabel, 'center');
            // Add line to connection group (only the line!)
            connectionGroup.appendChild(line); // Add visible line first
            connectionGroup.appendChild(hitTarget); // Add hit target last (on top for mouse events)
            // Store label IDs as data attributes
            connectionGroup.setAttribute('data-source-label-id', sourceLabel.id);
            connectionGroup.setAttribute('data-target-label-id', targetLabel.id);
            connectionGroup.setAttribute('data-center-label-id', centerLabel.id);
            // Add connection to the connections layer
            const connectionsLayer = document.getElementById('connectionsLayer');
            if (connectionsLayer) connectionsLayer.appendChild(connectionGroup);
            else {
                // Fallback: Insert connection group before shapes so lines appear behind them
                const gridRect = (0, $162Oa.elements).canvas.querySelector('rect[fill="url(#grid)"]');
                if (gridRect && gridRect.nextSibling) (0, $162Oa.elements).canvas.insertBefore(connectionGroup, gridRect.nextSibling);
                else if (gridRect) (0, $162Oa.elements).canvas.appendChild(connectionGroup);
                else (0, $162Oa.elements).canvas.appendChild(connectionGroup);
            }
            // Add labels to the labels layer
            const labelsLayer = document.getElementById('labelsLayer');
            const labelTarget = labelsLayer || (0, $162Oa.elements).canvas;
            labelTarget.appendChild(sourceLabel);
            labelTarget.appendChild(targetLabel);
            labelTarget.appendChild(centerLabel);
            // Add event listeners to labels for selection, editing, and dragging
            (0, $cgpVJ.addLabelListeners)(sourceLabel);
            (0, $cgpVJ.addLabelListeners)(targetLabel);
            (0, $cgpVJ.addLabelListeners)(centerLabel);
            // Update shape connections data
            const sourceShape = document.getElementById(connectionData.sourceId);
            const targetShape = document.getElementById(connectionData.targetId);
            if (sourceShape) {
                if (!sourceShape.dataset.connections) sourceShape.dataset.connections = '';
                sourceShape.dataset.connections += connectionData.id + ',';
                // Restore constraint center from saved data if available, otherwise calculate from shape
                if (connectionData.sourceLabel.constraintCenterX && connectionData.sourceLabel.constraintCenterY) {
                    sourceLabel.setAttribute('data-constraint-center-x', connectionData.sourceLabel.constraintCenterX);
                    sourceLabel.setAttribute('data-constraint-center-y', connectionData.sourceLabel.constraintCenterY);
                } else {
                    // Fallback: Calculate from current shape position
                    const sourceBounds = (0, $gLqu3.getShapeBounds)(sourceShape);
                    const sourceCenterX = sourceBounds.x + sourceBounds.width / 2;
                    const sourceCenterY = sourceBounds.y + sourceBounds.height / 2;
                    sourceLabel.setAttribute('data-constraint-center-x', sourceCenterX);
                    sourceLabel.setAttribute('data-constraint-center-y', sourceCenterY);
                }
                // Restore constraint radius
                if (connectionData.sourceLabel.constraintRadius) sourceLabel.setAttribute('data-constraint-radius', connectionData.sourceLabel.constraintRadius);
            }
            if (targetShape) {
                if (!targetShape.dataset.connections) targetShape.dataset.connections = '';
                targetShape.dataset.connections += connectionData.id + ',';
                // Restore constraint center from saved data if available, otherwise calculate from shape
                if (connectionData.targetLabel.constraintCenterX && connectionData.targetLabel.constraintCenterY) {
                    targetLabel.setAttribute('data-constraint-center-x', connectionData.targetLabel.constraintCenterX);
                    targetLabel.setAttribute('data-constraint-center-y', connectionData.targetLabel.constraintCenterY);
                } else {
                    // Fallback: Calculate from current shape position
                    const targetBounds = (0, $gLqu3.getShapeBounds)(targetShape);
                    const targetCenterX = targetBounds.x + targetBounds.width / 2;
                    const targetCenterY = targetBounds.y + targetBounds.height / 2;
                    targetLabel.setAttribute('data-constraint-center-x', targetCenterX);
                    targetLabel.setAttribute('data-constraint-center-y', targetCenterY);
                }
                // Restore constraint radius
                if (connectionData.targetLabel.constraintRadius) targetLabel.setAttribute('data-constraint-radius', connectionData.targetLabel.constraintRadius);
            }
            console.log(`Connection ${index + 1} restored successfully`);
        } catch (error) {
            console.error('Error restoring connection:', error, connectionData);
        }
    });
}
/**
 * Create a connection label element from saved data
 * @param {string} connectionId - The connection ID
 * @param {Object} labelData - Label data object
 * @param {string} type - 'source' or 'target'
 * @returns {SVGTextElement} The label element
 */ function $b18534792cfb37d0$var$createConnectionLabelElement(connectionId, labelData, type) {
    const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    // Set label ID
    label.id = `label-${connectionId}-${type}`;
    // Handle null or missing labelData
    if (!labelData || !labelData.x) labelData = {
        x: 0,
        y: 0,
        dx: type === 'source' ? '-5' : '5',
        dy: '-10',
        textAnchor: type === 'source' ? 'end' : 'start',
        text: ''
    };
    label.setAttribute('x', labelData.x || 0);
    label.setAttribute('y', labelData.y || 0);
    label.setAttribute('dx', labelData.dx || '0');
    label.setAttribute('dy', labelData.dy || '0');
    label.setAttribute('text-anchor', labelData.textAnchor || 'start');
    label.setAttribute('fill', labelData.fill || '#495057');
    label.setAttribute('font-size', labelData.fontSize || '12');
    label.setAttribute('font-family', 'Arial, sans-serif');
    label.setAttribute('font-weight', 'bold');
    label.classList.add('connection-label', `connection-label-${type}`);
    label.setAttribute('data-connection-id', connectionId);
    label.setAttribute('data-label-type', type);
    label.style.cursor = 'pointer';
    label.textContent = labelData.text || '';
    // Calculate and store constraint circle data for dragging
    // This will be set properly after the connection is restored and we know the shapes
    // For now, set a default radius
    label.setAttribute('data-constraint-radius', '60');
    // Make label draggable (need to import and call makeLabelDraggable from connectionManager)
    // For now, we'll add basic dragging inline
    $b18534792cfb37d0$var$makeLabelDraggableInline(label);
    return label;
}

/**
 * Make a label draggable with circular constraint (inline version for restore)
 * @param {SVGTextElement} label - The label element
 */ function $b18534792cfb37d0$var$makeLabelDraggableInline(label) {
    let isDragging = false;
    let shapeCenter = null;
    let constraintRadius = 0;
    label.addEventListener('mousedown', (e)=>{
        if ((0, $lwME4.appState).isAddingConnection) return;
        e.stopPropagation();
        e.preventDefault(); // Prevent text selection during drag
        isDragging = true;
        // Get the connection and determine which shape this label is attached to
        const connectionId = label.getAttribute('data-connection-id');
        const labelType = label.getAttribute('data-label-type');
        const connection = document.getElementById(connectionId);
        if (connection) {
            const sourceId = connection.getAttribute('data-source');
            const targetId = connection.getAttribute('data-target');
            const shapeId = labelType === 'source' ? sourceId : targetId;
            const shape = document.getElementById(shapeId);
            if (shape) {
                // Get shape center
                const shapeRect = shape.getBoundingClientRect();
                const canvasRect = (0, $162Oa.elements).canvas.getBoundingClientRect();
                shapeCenter = {
                    x: (shapeRect.left + shapeRect.width / 2 - canvasRect.left) / (0, $lwME4.appState).currentZoom,
                    y: (shapeRect.top + shapeRect.height / 2 - canvasRect.top) / (0, $lwME4.appState).currentZoom
                };
                // Calculate constraint radius
                const currentX = parseFloat(label.getAttribute('x'));
                const currentY = parseFloat(label.getAttribute('y'));
                const dx = currentX - shapeCenter.x;
                const dy = currentY - shapeCenter.y;
                constraintRadius = Math.sqrt(dx * dx + dy * dy);
                // Ensure minimum radius
                if (constraintRadius < 50) constraintRadius = 50;
            }
        }
        label.style.cursor = 'grabbing';
    });
    const handleMouseMove = (e)=>{
        if (!isDragging || !shapeCenter) return;
        const canvasRect = (0, $162Oa.elements).canvas.getBoundingClientRect();
        const mouseX = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
        const mouseY = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
        // Calculate angle from shape center to mouse position
        const dx = mouseX - shapeCenter.x;
        const dy = mouseY - shapeCenter.y;
        const angle = Math.atan2(dy, dx);
        // Position label on the circle at this angle
        const newX = shapeCenter.x + Math.cos(angle) * constraintRadius;
        const newY = shapeCenter.y + Math.sin(angle) * constraintRadius;
        label.setAttribute('x', newX);
        label.setAttribute('y', newY);
    };
    const handleMouseUp = ()=>{
        if (isDragging) {
            isDragging = false;
            shapeCenter = null;
            label.style.cursor = 'move';
            // Save the updated label position to localStorage
            const { saveAppState: saveAppState } = (parcelRequire("4DKvQ"));
            saveAppState();
        }
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}



var $hkA3I = parcelRequire("hkA3I");

var $cgpVJ = parcelRequire("cgpVJ");
/**
 * Status bar functionality
 * Updates canvas info and pointer position in the footer
 */ 
var $162Oa = parcelRequire("162Oa");

var $lwME4 = parcelRequire("lwME4");

var $b8j1A = parcelRequire("b8j1A");
function $198847b3bb70cf12$export$8ea63a1eb032cf80() {
    // Set canvas size from constants
    $198847b3bb70cf12$var$updateCanvasInfo();
    // Setup pointer position tracking
    $198847b3bb70cf12$var$setupPointerTracking();
}
/**
 * Update canvas info display with values from constants
 */ function $198847b3bb70cf12$var$updateCanvasInfo() {
    if ((0, $162Oa.elements).canvasInfo) (0, $162Oa.elements).canvasInfo.textContent = `${(0, $b8j1A.CANVAS_CONFIG).WIDTH}x${(0, $b8j1A.CANVAS_CONFIG).HEIGHT}`;
}
/**
 * Setup pointer position tracking on canvas
 */ function $198847b3bb70cf12$var$setupPointerTracking() {
    if (!(0, $162Oa.elements).topologyCanvas || !(0, $162Oa.elements).pointerPosition) return;
    (0, $162Oa.elements).topologyCanvas.addEventListener('mousemove', (e)=>{
        const canvasRect = (0, $162Oa.elements).topologyCanvas.getBoundingClientRect();
        // Calculate position accounting for zoom
        const x = (e.clientX - canvasRect.left) / (0, $lwME4.appState).currentZoom;
        const y = (e.clientY - canvasRect.top) / (0, $lwME4.appState).currentZoom;
        // Round to whole numbers for cleaner display
        const roundedX = Math.round(x);
        const roundedY = Math.round(y);
        // Update display
        (0, $162Oa.elements).pointerPosition.textContent = `(${roundedX}, ${roundedY})`;
    });
    // Clear position when mouse leaves canvas
    (0, $162Oa.elements).topologyCanvas.addEventListener('mouseleave', ()=>{
        (0, $162Oa.elements).pointerPosition.textContent = '(--, --)';
    });
}



var $1cdEC = parcelRequire("1cdEC");
/**
 * Sidebar panel state management with localStorage persistence
 */ const $2cf8010633541100$var$STORAGE_KEY = 'topologyBuilder_sidebarState';
function $2cf8010633541100$export$709790fc8a5e8200() {
    const savedState = $2cf8010633541100$var$getSavedState();
    // Apply saved state or defaults
    const basicCollapse = document.getElementById('basicShapesCollapse');
    const ciscoCollapse = document.getElementById('ciscoShapesCollapse');
    const basicToggle = document.getElementById('basicShapesToggle');
    const ciscoToggle = document.getElementById('ciscoShapesToggle');
    if (!basicCollapse || !ciscoCollapse || !basicToggle || !ciscoToggle) return;
    // Import Bootstrap's Collapse class
    const Collapse = window.bootstrap?.Collapse;
    if (!Collapse) {
        console.warn('Bootstrap Collapse not available');
        return;
    }
    // Apply saved state
    if (savedState.basicExpanded) {
        basicCollapse.classList.add('show');
        basicToggle.setAttribute('aria-expanded', 'true');
        $2cf8010633541100$var$updateChevron(basicToggle, true);
    } else {
        basicCollapse.classList.remove('show');
        basicToggle.setAttribute('aria-expanded', 'false');
        $2cf8010633541100$var$updateChevron(basicToggle, false);
    }
    if (savedState.ciscoExpanded) {
        ciscoCollapse.classList.add('show');
        ciscoToggle.setAttribute('aria-expanded', 'true');
        $2cf8010633541100$var$updateChevron(ciscoToggle, true);
    } else {
        ciscoCollapse.classList.remove('show');
        ciscoToggle.setAttribute('aria-expanded', 'false');
        $2cf8010633541100$var$updateChevron(ciscoToggle, false);
    }
    // Set up event listeners to save state on changes
    basicCollapse.addEventListener('shown.bs.collapse', ()=>{
        $2cf8010633541100$var$saveState('basic', true);
        $2cf8010633541100$var$updateChevron(basicToggle, true);
    });
    basicCollapse.addEventListener('hidden.bs.collapse', ()=>{
        $2cf8010633541100$var$saveState('basic', false);
        $2cf8010633541100$var$updateChevron(basicToggle, false);
    });
    ciscoCollapse.addEventListener('shown.bs.collapse', ()=>{
        $2cf8010633541100$var$saveState('cisco', true);
        $2cf8010633541100$var$updateChevron(ciscoToggle, true);
    });
    ciscoCollapse.addEventListener('hidden.bs.collapse', ()=>{
        $2cf8010633541100$var$saveState('cisco', false);
        $2cf8010633541100$var$updateChevron(ciscoToggle, false);
    });
}
/**
 * Get saved sidebar state from localStorage
 * @returns {Object} Saved state or defaults
 */ function $2cf8010633541100$var$getSavedState() {
    try {
        const saved = localStorage.getItem($2cf8010633541100$var$STORAGE_KEY);
        if (saved) return JSON.parse(saved);
    } catch (e) {
        console.warn('Failed to load sidebar state:', e);
    }
    // Default state: Basic collapsed, Cisco expanded
    return {
        basicExpanded: false,
        ciscoExpanded: true
    };
}
/**
 * Save panel state to localStorage
 * @param {string} panel - 'basic' or 'cisco'
 * @param {boolean} expanded - Whether the panel is expanded
 */ function $2cf8010633541100$var$saveState(panel, expanded) {
    try {
        const state = $2cf8010633541100$var$getSavedState();
        if (panel === 'basic') state.basicExpanded = expanded;
        else if (panel === 'cisco') state.ciscoExpanded = expanded;
        localStorage.setItem($2cf8010633541100$var$STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
        console.warn('Failed to save sidebar state:', e);
    }
}
/**
 * Update chevron icon based on expanded state
 * @param {HTMLElement} button - Toggle button element
 * @param {boolean} expanded - Whether the panel is expanded
 */ function $2cf8010633541100$var$updateChevron(button, expanded) {
    const icon = button.querySelector('i');
    if (!icon) return;
    if (expanded) {
        icon.classList.remove('bi-chevron-right');
        icon.classList.add('bi-chevron-down');
    } else {
        icon.classList.remove('bi-chevron-down');
        icon.classList.add('bi-chevron-right');
    }
}


/**
 * Selection Mode - Multi-select shapes with rectangle drag
 */ 
var $lwME4 = parcelRequire("lwME4");
/**
 * Alignment toolbar for multi-shape operations
 */ /**
 * Multi-shape alignment and distribution tools
 */ 
var $4DKvQ = parcelRequire("4DKvQ");

var $hkA3I = parcelRequire("hkA3I");
/**
 * Get the bounding box for a shape
 * @param {SVGElement} shape - The shape element
 * @returns {Object} Bounding box with x, y, width, height, centerX, centerY
 */ function $abfe2741cb397477$var$getShapeBounds(shape) {
    const bbox = shape.getBBox();
    let x = bbox.x;
    let y = bbox.y;
    // Handle transform for groups (Cisco shapes)
    const transform = shape.getAttribute('transform');
    if (transform) {
        const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
        if (match) {
            x += parseFloat(match[1]);
            y += parseFloat(match[2]);
        }
    }
    // For basic shapes, get position from attributes
    if (shape.tagName === 'circle' || shape.tagName === 'ellipse') {
        x = parseFloat(shape.getAttribute('cx')) - bbox.width / 2;
        y = parseFloat(shape.getAttribute('cy')) - bbox.height / 2;
    } else if (shape.tagName === 'rect') {
        x = parseFloat(shape.getAttribute('x'));
        y = parseFloat(shape.getAttribute('y'));
    }
    return {
        x: x,
        y: y,
        width: bbox.width,
        height: bbox.height,
        centerX: x + bbox.width / 2,
        centerY: y + bbox.height / 2,
        right: x + bbox.width,
        bottom: y + bbox.height
    };
}
/**
 * Move a shape to a specific position
 * @param {SVGElement} shape - The shape to move
 * @param {number} x - New x position
 * @param {number} y - New y position
 */ function $abfe2741cb397477$var$moveShapeToPosition(shape, x, y) {
    const bounds = $abfe2741cb397477$var$getShapeBounds(shape);
    const currentCenterX = bounds.centerX;
    const currentCenterY = bounds.centerY;
    if (shape.tagName === 'g') // For groups, update transform
    shape.setAttribute('transform', `translate(${x}, ${y})`);
    else if (shape.tagName === 'circle' || shape.tagName === 'ellipse') {
        // For circles/ellipses, update cx/cy
        const newCx = x + bounds.width / 2;
        const newCy = y + bounds.height / 2;
        shape.setAttribute('cx', newCx);
        shape.setAttribute('cy', newCy);
    } else if (shape.tagName === 'rect') {
        // For rectangles, update x/y
        shape.setAttribute('x', x);
        shape.setAttribute('y', y);
    }
    // Update sibling label position if exists
    $abfe2741cb397477$var$updateSiblingLabel(shape);
    // Update connections
    (0, $hkA3I.updateShapeConnections)(shape);
}
/**
 * Update sibling label position for basic shapes
 * @param {SVGElement} shape - The shape element
 */ function $abfe2741cb397477$var$updateSiblingLabel(shape) {
    if (shape.tagName !== 'circle' && shape.tagName !== 'rect' && shape.tagName !== 'ellipse') return;
    const shapeId = shape.getAttribute('id');
    const labelEl = shape.parentNode?.querySelector(`text[data-shape-id="${shapeId}"]`);
    if (!labelEl) return;
    const position = labelEl.getAttribute('data-position') || 'below';
    const offset = 20;
    const bounds = $abfe2741cb397477$var$getShapeBounds(shape);
    const isCircular = shape.tagName === 'circle' || shape.tagName === 'ellipse';
    let labelX, labelY;
    switch(position){
        case 'above':
            labelX = isCircular ? bounds.centerX : bounds.x + bounds.width / 2;
            labelY = isCircular ? bounds.y - offset : bounds.y - offset;
            break;
        case 'below':
            labelX = isCircular ? bounds.centerX : bounds.x + bounds.width / 2;
            labelY = isCircular ? bounds.bottom + offset : bounds.bottom + offset;
            break;
        case 'left':
            labelX = isCircular ? bounds.x - offset : bounds.x - offset;
            labelY = isCircular ? bounds.centerY : bounds.y + bounds.height / 2;
            break;
        case 'right':
            labelX = isCircular ? bounds.right + offset : bounds.right + offset;
            labelY = isCircular ? bounds.centerY : bounds.y + bounds.height / 2;
            break;
        case 'center':
            labelX = isCircular ? bounds.centerX : bounds.x + bounds.width / 2;
            labelY = isCircular ? bounds.centerY + 5 : bounds.y + bounds.height / 2 + 5;
            break;
        default:
            labelX = isCircular ? bounds.centerX : bounds.x + bounds.width / 2;
            labelY = isCircular ? bounds.bottom + offset : bounds.bottom + offset;
    }
    labelEl.setAttribute('x', labelX);
    labelEl.setAttribute('y', labelY);
}
function $abfe2741cb397477$export$f25172b8ab8e6f89(shapeIds, alignment) {
    if (shapeIds.length < 2) return;
    const shapes = shapeIds.map((id)=>document.getElementById(id)).filter(Boolean);
    if (shapes.length < 2) return;
    const bounds = shapes.map($abfe2741cb397477$var$getShapeBounds);
    // Calculate reference position
    let referenceX;
    if (alignment === 'left') referenceX = Math.min(...bounds.map((b)=>b.x));
    else if (alignment === 'right') referenceX = Math.max(...bounds.map((b)=>b.right));
    else {
        // center
        const minX = Math.min(...bounds.map((b)=>b.x));
        const maxRight = Math.max(...bounds.map((b)=>b.right));
        referenceX = (minX + maxRight) / 2;
    }
    // Align each shape
    shapes.forEach((shape, index)=>{
        const bound = bounds[index];
        let newX;
        if (alignment === 'left') newX = referenceX;
        else if (alignment === 'right') newX = referenceX - bound.width;
        else // center
        newX = referenceX - bound.width / 2;
        $abfe2741cb397477$var$moveShapeToPosition(shape, newX, bound.y);
    });
    (0, $4DKvQ.saveAppState)();
}
function $abfe2741cb397477$export$c71550881637c12a(shapeIds, alignment) {
    if (shapeIds.length < 2) return;
    const shapes = shapeIds.map((id)=>document.getElementById(id)).filter(Boolean);
    if (shapes.length < 2) return;
    const bounds = shapes.map($abfe2741cb397477$var$getShapeBounds);
    // Calculate reference position
    let referenceY;
    if (alignment === 'top') referenceY = Math.min(...bounds.map((b)=>b.y));
    else if (alignment === 'bottom') referenceY = Math.max(...bounds.map((b)=>b.bottom));
    else {
        // middle
        const minY = Math.min(...bounds.map((b)=>b.y));
        const maxBottom = Math.max(...bounds.map((b)=>b.bottom));
        referenceY = (minY + maxBottom) / 2;
    }
    // Align each shape
    shapes.forEach((shape, index)=>{
        const bound = bounds[index];
        let newY;
        if (alignment === 'top') newY = referenceY;
        else if (alignment === 'bottom') newY = referenceY - bound.height;
        else // middle
        newY = referenceY - bound.height / 2;
        $abfe2741cb397477$var$moveShapeToPosition(shape, bound.x, newY);
    });
    (0, $4DKvQ.saveAppState)();
}
function $abfe2741cb397477$export$1c410dbd190efd23(shapeIds) {
    if (shapeIds.length < 3) return;
    const shapes = shapeIds.map((id)=>document.getElementById(id)).filter(Boolean);
    if (shapes.length < 3) return;
    const bounds = shapes.map((shape, index)=>({
            shape: shape,
            ...$abfe2741cb397477$var$getShapeBounds(shape)
        }));
    // Sort by current X position
    bounds.sort((a, b)=>a.x - b.x);
    // Calculate total span and spacing
    const leftmostX = bounds[0].x;
    const rightmostX = bounds[bounds.length - 1].right;
    const totalWidth = bounds.reduce((sum, b)=>sum + b.width, 0);
    const totalGap = rightmostX - leftmostX - totalWidth;
    const spacing = totalGap / (bounds.length - 1);
    // Distribute shapes
    let currentX = leftmostX;
    bounds.forEach((bound)=>{
        $abfe2741cb397477$var$moveShapeToPosition(bound.shape, currentX, bound.y);
        currentX += bound.width + spacing;
    });
    (0, $4DKvQ.saveAppState)();
}
function $abfe2741cb397477$export$f55c563e22b97517(shapeIds) {
    if (shapeIds.length < 3) return;
    const shapes = shapeIds.map((id)=>document.getElementById(id)).filter(Boolean);
    if (shapes.length < 3) return;
    const bounds = shapes.map((shape, index)=>({
            shape: shape,
            ...$abfe2741cb397477$var$getShapeBounds(shape)
        }));
    // Sort by current Y position
    bounds.sort((a, b)=>a.y - b.y);
    // Calculate total span and spacing
    const topmostY = bounds[0].y;
    const bottommostY = bounds[bounds.length - 1].bottom;
    const totalHeight = bounds.reduce((sum, b)=>sum + b.height, 0);
    const totalGap = bottommostY - topmostY - totalHeight;
    const spacing = totalGap / (bounds.length - 1);
    // Distribute shapes
    let currentY = topmostY;
    bounds.forEach((bound)=>{
        $abfe2741cb397477$var$moveShapeToPosition(bound.shape, bound.x, currentY);
        currentY += bound.height + spacing;
    });
    (0, $4DKvQ.saveAppState)();
}



var $lwME4 = parcelRequire("lwME4");
function $84ef0419adada554$export$4924b4313410a96f() {
    $84ef0419adada554$var$createToolbarHTML();
    $84ef0419adada554$var$attachEventListeners();
}
/**
 * Create the HTML for the alignment toolbar
 */ function $84ef0419adada554$var$createToolbarHTML() {
    const existing = document.getElementById('alignmentToolbar');
    if (existing) return;
    const toolbar = document.createElement('div');
    toolbar.id = 'alignmentToolbar';
    toolbar.className = 'alignment-toolbar';
    toolbar.style.display = 'none';
    toolbar.innerHTML = `
        <div class="btn-group" role="group" aria-label="Horizontal alignment">
            <button type="button" class="btn btn-sm btn-outline-secondary" id="alignLeft"
                    title="Align Left" data-bs-toggle="tooltip">
                <i class="bi bi-align-start"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" id="alignCenterH"
                    title="Align Center (Horizontal)" data-bs-toggle="tooltip">
                <i class="bi bi-align-center"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" id="alignRight"
                    title="Align Right" data-bs-toggle="tooltip">
                <i class="bi bi-align-end"></i>
            </button>
        </div>
        <div class="btn-group ms-2" role="group" aria-label="Vertical alignment">
            <button type="button" class="btn btn-sm btn-outline-secondary" id="alignTop"
                    title="Align Top" data-bs-toggle="tooltip">
                <i class="bi bi-align-top"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" id="alignMiddle"
                    title="Align Middle (Vertical)" data-bs-toggle="tooltip">
                <i class="bi bi-align-middle"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" id="alignBottom"
                    title="Align Bottom" data-bs-toggle="tooltip">
                <i class="bi bi-align-bottom"></i>
            </button>
        </div>
        <div class="btn-group ms-2" role="group" aria-label="Distribution">
            <button type="button" class="btn btn-sm btn-outline-secondary" id="distributeH"
                    title="Distribute Horizontally" data-bs-toggle="tooltip">
                <i class="bi bi-distribute-horizontal"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" id="distributeV"
                    title="Distribute Vertically" data-bs-toggle="tooltip">
                <i class="bi bi-distribute-vertical"></i>
            </button>
        </div>
    `;
    document.body.appendChild(toolbar);
    // Initialize tooltips
    const tooltipTriggerList = toolbar.querySelectorAll('[data-bs-toggle="tooltip"]');
    [
        ...tooltipTriggerList
    ].map((tooltipTriggerEl)=>new bootstrap.Tooltip(tooltipTriggerEl));
}
/**
 * Attach event listeners to toolbar buttons
 */ function $84ef0419adada554$var$attachEventListeners() {
    const toolbar = document.getElementById('alignmentToolbar');
    if (!toolbar) return;
    const buttonHandlers = {
        alignLeft: ()=>$84ef0419adada554$var$handleAlignment('horizontal', 'left'),
        alignCenterH: ()=>$84ef0419adada554$var$handleAlignment('horizontal', 'center'),
        alignRight: ()=>$84ef0419adada554$var$handleAlignment('horizontal', 'right'),
        alignTop: ()=>$84ef0419adada554$var$handleAlignment('vertical', 'top'),
        alignMiddle: ()=>$84ef0419adada554$var$handleAlignment('vertical', 'middle'),
        alignBottom: ()=>$84ef0419adada554$var$handleAlignment('vertical', 'bottom'),
        distributeH: ()=>$84ef0419adada554$var$handleDistribution('horizontal'),
        distributeV: ()=>$84ef0419adada554$var$handleDistribution('vertical')
    };
    Object.entries(buttonHandlers).forEach(([id, handler])=>{
        const button = document.getElementById(id);
        if (button) button.addEventListener('click', handler);
    });
}
/**
 * Handle alignment button clicks
 * @param {string} direction - 'horizontal' or 'vertical'
 * @param {string} alignment - 'left', 'center', 'right', 'top', 'middle', 'bottom'
 */ function $84ef0419adada554$var$handleAlignment(direction, alignment) {
    const selectionManager = (0, $lwME4.appState)?.selectionManager;
    if (!selectionManager) return;
    const selectedShapes = selectionManager.getSelectedShapes();
    if (selectedShapes.length < 2) return;
    if (direction === 'horizontal') (0, $abfe2741cb397477$export$f25172b8ab8e6f89)(selectedShapes, alignment);
    else (0, $abfe2741cb397477$export$c71550881637c12a)(selectedShapes, alignment);
}
/**
 * Handle distribution button clicks
 * @param {string} direction - 'horizontal' or 'vertical'
 */ function $84ef0419adada554$var$handleDistribution(direction) {
    const selectionManager = (0, $lwME4.appState)?.selectionManager;
    if (!selectionManager) return;
    const selectedShapes = selectionManager.getSelectedShapes();
    if (selectedShapes.length < 3) {
        // Show feedback that at least 3 shapes are needed
        console.log('At least 3 shapes must be selected for distribution');
        return;
    }
    if (direction === 'horizontal') (0, $abfe2741cb397477$export$1c410dbd190efd23)(selectedShapes);
    else (0, $abfe2741cb397477$export$f55c563e22b97517)(selectedShapes);
}
function $84ef0419adada554$export$e726fcdbcd24dc5f() {
    const toolbar = document.getElementById('alignmentToolbar');
    if (toolbar) toolbar.style.display = 'flex';
}
function $84ef0419adada554$export$da56684ff4b0165f() {
    const toolbar = document.getElementById('alignmentToolbar');
    if (toolbar) toolbar.style.display = 'none';
}
function $84ef0419adada554$export$e3ef497c9f03959a(selectedCount) {
    if (selectedCount >= 2) $84ef0419adada554$export$e726fcdbcd24dc5f();
    else $84ef0419adada554$export$da56684ff4b0165f();
}






class $b2b3075c112d628f$export$91484609d16ec765 {
    constructor(canvas){
        this.canvas = canvas;
        this.isActive = false;
        this.isSelecting = false;
        this.isDraggingGroup = false;
        this.startPoint = null;
        this.dragStartPoint = null;
        this.initialShapePositions = new Map();
        this.selectionRect = document.getElementById('selectionRect');
        this.selectedShapes = new Set();
        this.initEventListeners();
    }
    toggle() {
        this.isActive = !this.isActive;
        (0, $lwME4.appState).isSelectionMode = this.isActive;
        if (this.isActive) {
            this.canvas.classList.add('selection-mode');
            this.canvas.style.cursor = 'crosshair';
            document.getElementById('toggleSelectionMode')?.classList.add('active');
        } else {
            this.canvas.classList.remove('selection-mode');
            this.canvas.style.cursor = 'grab';
            document.getElementById('toggleSelectionMode')?.classList.remove('active');
            this.clearSelection();
        }
        return this.isActive;
    }
    initEventListeners() {
        // Mouse down on canvas
        this.canvas.addEventListener('mousedown', (e)=>{
            if (!this.isActive) return;
            const clickedShape = e.target.closest('.canvas-shape');
            // Check if clicked on a selected shape
            if (clickedShape && this.selectedShapes.has(clickedShape.id)) {
                // Start dragging the group
                this.startGroupDrag(e);
                e.stopPropagation();
                return;
            }
            // Check if clicked on an unselected shape
            if (clickedShape) {
                // Replace selection with just this shape
                this.clearSelection();
                this.selectedShapes.add(clickedShape.id);
                clickedShape.classList.add('shape-selected');
                (0, $84ef0419adada554$export$e3ef497c9f03959a)(1);
                this.startGroupDrag(e);
                e.stopPropagation();
                return;
            }
            // Clicked on background - start new selection rectangle
            const isBackgroundClick = e.target === this.canvas || e.target.id === 'grid' || e.target.tagName === 'rect' && e.target.getAttribute('fill')?.includes('url(#grid)') || e.target.closest('g')?.id === 'backgroundShapesLayer';
            if (isBackgroundClick) this.startSelection(e);
        });
        // Mouse move updates selection rectangle or drags group
        this.canvas.addEventListener('mousemove', (e)=>{
            if (!this.isActive) return;
            if (this.isDraggingGroup) this.updateGroupDrag(e);
            else if (this.isSelecting) this.updateSelection(e);
        });
        // Mouse up completes selection or group drag
        this.canvas.addEventListener('mouseup', (e)=>{
            if (!this.isActive) return;
            if (this.isDraggingGroup) this.endGroupDrag(e);
            else if (this.isSelecting) this.endSelection(e);
        });
        // Global mouse up to handle dragging outside canvas
        document.addEventListener('mouseup', (e)=>{
            if (this.isDraggingGroup) this.endGroupDrag(e);
        });
        // Keyboard: Delete selected shapes
        document.addEventListener('keydown', (e)=>{
            if (!this.isActive || this.selectedShapes.size === 0) return;
            if (e.key === 'Delete' || e.key === 'Backspace') {
                // Don't delete if typing in input
                if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
                e.preventDefault();
                this.deleteSelectedShapes();
            }
        });
        // Keyboard: V key toggles selection mode
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'v' || e.key === 'V') {
                // Don't toggle if typing in input
                if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
                e.preventDefault();
                this.toggle();
            }
        });
    }
    startSelection(e) {
        const canvasWrapper = document.getElementById('canvasWrapper');
        const wrapperRect = canvasWrapper.getBoundingClientRect();
        // Convert viewport coordinates to SVG coordinates
        // Account for wrapper position and scroll
        const x = e.clientX - wrapperRect.left + canvasWrapper.scrollLeft;
        const y = e.clientY - wrapperRect.top + canvasWrapper.scrollTop;
        this.startPoint = {
            x: x,
            y: y
        };
        this.isSelecting = true;
        this.selectionRect.style.display = 'block';
        this.selectionRect.setAttribute('x', x);
        this.selectionRect.setAttribute('y', y);
        this.selectionRect.setAttribute('width', 0);
        this.selectionRect.setAttribute('height', 0);
        // Clear previous selection
        this.clearSelection();
    }
    updateSelection(e) {
        const canvasWrapper = document.getElementById('canvasWrapper');
        const wrapperRect = canvasWrapper.getBoundingClientRect();
        // Convert viewport coordinates to SVG coordinates
        const currentPoint = {
            x: e.clientX - wrapperRect.left + canvasWrapper.scrollLeft,
            y: e.clientY - wrapperRect.top + canvasWrapper.scrollTop
        };
        const x = Math.min(this.startPoint.x, currentPoint.x);
        const y = Math.min(this.startPoint.y, currentPoint.y);
        const width = Math.abs(currentPoint.x - this.startPoint.x);
        const height = Math.abs(currentPoint.y - this.startPoint.y);
        this.selectionRect.setAttribute('x', x);
        this.selectionRect.setAttribute('y', y);
        this.selectionRect.setAttribute('width', width);
        this.selectionRect.setAttribute('height', height);
        // Highlight shapes that intersect with selection rectangle
        this.highlightIntersectingShapes(x, y, width, height);
    }
    endSelection(e) {
        this.isSelecting = false;
        this.selectionRect.style.display = 'none';
        (0, $84ef0419adada554$export$e3ef497c9f03959a)(this.selectedShapes.size);
    }
    highlightIntersectingShapes(selX, selY, selWidth, selHeight) {
        // Clear previous highlights
        this.clearSelection();
        // Get all shape groups from the canvas
        const shapes = this.canvas.querySelectorAll('.canvas-shape');
        shapes.forEach((shapeGroup)=>{
            try {
                // Get the bounding box of the shape in SVG coordinates
                const bbox = shapeGroup.getBBox();
                // Get transform if any
                const transform = shapeGroup.getAttribute('transform');
                let x = bbox.x;
                let y = bbox.y;
                // Parse translate transform if present
                if (transform) {
                    const translateMatch = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
                    if (translateMatch) {
                        x = parseFloat(translateMatch[1]);
                        y = parseFloat(translateMatch[2]);
                    }
                }
                const width = bbox.width;
                const height = bbox.height;
                // Check if selection rectangle intersects with shape
                if (this.rectanglesIntersect(selX, selY, selWidth, selHeight, x, y, width, height)) {
                    this.selectedShapes.add(shapeGroup.id);
                    shapeGroup.classList.add('shape-selected');
                }
            } catch (e) {
            // getBBox might fail for some elements, skip them silently
            }
        });
    }
    rectanglesIntersect(x1, y1, w1, h1, x2, y2, w2, h2) {
        return !(x1 + w1 < x2 || x2 + w2 < x1 || y1 + h1 < y2 || y2 + h2 < y1);
    }
    clearSelection() {
        this.selectedShapes.forEach((shapeId)=>{
            const shapeGroup = document.getElementById(shapeId);
            if (shapeGroup) shapeGroup.classList.remove('shape-selected');
        });
        this.selectedShapes.clear();
        (0, $84ef0419adada554$export$e3ef497c9f03959a)(0);
    }
    startGroupDrag(e) {
        const canvasWrapper = document.getElementById('canvasWrapper');
        const wrapperRect = canvasWrapper.getBoundingClientRect();
        this.isDraggingGroup = true;
        this.dragStartPoint = {
            x: e.clientX - wrapperRect.left + canvasWrapper.scrollLeft,
            y: e.clientY - wrapperRect.top + canvasWrapper.scrollTop
        };
        // Prevent text selection during drag
        document.body.classList.add('no-select');
        // Store initial positions of all selected shapes
        this.initialShapePositions.clear();
        this.selectedShapes.forEach((shapeId)=>{
            const shape = document.getElementById(shapeId);
            if (shape) {
                const pos = this.getShapePosition(shape);
                this.initialShapePositions.set(shapeId, pos);
            }
        });
        this.canvas.style.cursor = 'move';
    }
    updateGroupDrag(e) {
        if (!this.isDraggingGroup) return;
        const canvasWrapper = document.getElementById('canvasWrapper');
        const wrapperRect = canvasWrapper.getBoundingClientRect();
        const currentPoint = {
            x: e.clientX - wrapperRect.left + canvasWrapper.scrollLeft,
            y: e.clientY - wrapperRect.top + canvasWrapper.scrollTop
        };
        const dx = currentPoint.x - this.dragStartPoint.x;
        const dy = currentPoint.y - this.dragStartPoint.y;
        // Move all selected shapes
        this.selectedShapes.forEach((shapeId)=>{
            const shape = document.getElementById(shapeId);
            const initialPos = this.initialShapePositions.get(shapeId);
            if (shape && initialPos) {
                this.setShapePosition(shape, initialPos.x + dx, initialPos.y + dy);
                // Update connections for this shape
                Promise.resolve((parcelRequire("hkA3I"))).then(({ updateShapeConnections: updateShapeConnections })=>{
                    updateShapeConnections(shape);
                });
            }
        });
    }
    endGroupDrag(e) {
        if (!this.isDraggingGroup) return;
        this.isDraggingGroup = false;
        this.dragStartPoint = null;
        this.initialShapePositions.clear();
        this.canvas.style.cursor = 'crosshair';
        // Re-enable text selection
        document.body.classList.remove('no-select');
        // Save state after moving
        Promise.resolve((parcelRequire("4DKvQ"))).then(({ saveAppState: saveAppState })=>{
            saveAppState();
        });
    }
    getShapePosition(shape) {
        // Check if shape has transform attribute (for groups)
        const transform = shape.getAttribute('transform');
        if (transform) {
            const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
            if (match) return {
                x: parseFloat(match[1]),
                y: parseFloat(match[2])
            };
        }
        // For basic shapes (circle, ellipse, rect)
        const tagName = shape.tagName.toLowerCase();
        if (tagName === 'circle' || tagName === 'ellipse') return {
            x: parseFloat(shape.getAttribute('cx') || 0),
            y: parseFloat(shape.getAttribute('cy') || 0)
        };
        else if (tagName === 'rect') return {
            x: parseFloat(shape.getAttribute('x') || 0),
            y: parseFloat(shape.getAttribute('y') || 0)
        };
        else if (tagName === 'g') // Group without transform
        return {
            x: 0,
            y: 0
        };
        return {
            x: 0,
            y: 0
        };
    }
    setShapePosition(shape, x, y) {
        // Check if shape has transform attribute (for groups)
        const transform = shape.getAttribute('transform');
        if (transform || shape.tagName.toLowerCase() === 'g') {
            shape.setAttribute('transform', `translate(${x}, ${y})`);
            return;
        }
        // For basic shapes
        const tagName = shape.tagName.toLowerCase();
        if (tagName === 'circle' || tagName === 'ellipse') {
            shape.setAttribute('cx', x);
            shape.setAttribute('cy', y);
        } else if (tagName === 'rect') {
            shape.setAttribute('x', x);
            shape.setAttribute('y', y);
        }
    }
    deleteSelectedShapes() {
        if (this.selectedShapes.size === 0) return;
        // Get references to modal elements
        const deleteModal = document.getElementById('deleteShapesModal');
        const deleteMessage = document.getElementById('deleteShapesMessage');
        const confirmButton = document.getElementById('confirmDeleteShapes');
        if (!deleteModal || !deleteMessage || !confirmButton) {
            console.error('Delete modal elements not found');
            return;
        }
        // Update modal message with count
        const count = this.selectedShapes.size;
        deleteMessage.textContent = `Are you sure you want to delete ${count} selected shape${count > 1 ? 's' : ''}?`;
        // Create Bootstrap modal instance
        const modalInstance = new bootstrap.Modal(deleteModal);
        // Handle confirm button - use a named function so we can remove the listener
        const handleConfirm = ()=>{
            // Import dependencies
            Promise.resolve((parcelRequire("hkA3I"))).then(({ deleteShapeConnections: deleteShapeConnections })=>{
                Promise.resolve((parcelRequire("4DKvQ"))).then(({ saveAppState: saveAppState })=>{
                    // Convert Set to array to avoid issues with modifying during iteration
                    const shapesToDelete = Array.from(this.selectedShapes);
                    shapesToDelete.forEach((shapeId)=>{
                        const shapeGroup = document.getElementById(shapeId);
                        if (shapeGroup) {
                            // Delete connections first
                            deleteShapeConnections(shapeGroup);
                            // Remove from DOM
                            shapeGroup.remove();
                        }
                    });
                    // Clear selection and save state
                    this.clearSelection();
                    saveAppState();
                    // Hide modal and remove listener
                    modalInstance.hide();
                    confirmButton.removeEventListener('click', handleConfirm);
                });
            });
        };
        // Attach event listener
        confirmButton.addEventListener('click', handleConfirm);
        // Clean up listener when modal is hidden via cancel or close button
        deleteModal.addEventListener('hidden.bs.modal', ()=>{
            confirmButton.removeEventListener('click', handleConfirm);
        }, {
            once: true
        });
        // Show the modal
        modalInstance.show();
    }
    moveSelectedShapes(dx, dy) {
        this.selectedShapes.forEach((shapeId)=>{
            const shape = (0, $lwME4.appState).shapes.get(shapeId);
            if (shape) {
                shape.x = parseFloat(shape.x) + dx;
                shape.y = parseFloat(shape.y) + dy;
                const shapeGroup = document.getElementById(shapeId);
                if (shapeGroup) shapeGroup.setAttribute('transform', `translate(${shape.x}, ${shape.y})`);
            }
        });
    }
    getSelectedShapes() {
        return Array.from(this.selectedShapes);
    }
}




var $lwME4 = parcelRequire("lwME4");
/**
 * Migrate existing canvas elements to layer groups
 */ function $f7fca9471e720bd1$var$migrateToLayerGroups() {
    const canvas = document.getElementById('topologyCanvas');
    const backgroundShapesLayer = document.getElementById('backgroundShapesLayer');
    const shapesLayer = document.getElementById('shapesLayer');
    const connectionsLayer = document.getElementById('connectionsLayer');
    const labelsLayer = document.getElementById('labelsLayer');
    const interactionLayer = document.getElementById('interactionLayer');
    if (!backgroundShapesLayer || !shapesLayer || !connectionsLayer || !labelsLayer || !interactionLayer) {
        console.warn('Layer groups not found, skipping migration');
        return;
    }
    // Get all direct children of canvas that should be in layers
    const canvasChildren = Array.from(canvas.children);
    canvasChildren.forEach((child)=>{
        const id = child.id || '';
        // Skip the layer groups themselves and base elements
        if (id === 'backgroundShapesLayer' || id === 'shapesLayer' || id === 'connectionsLayer' || id === 'labelsLayer' || id === 'interactionLayer' || id === 'selectionRect' || !id || child.tagName === 'defs' || child.tagName === 'rect') return;
        // Migrate based on element type
        if (id.startsWith('shape-')) shapesLayer.appendChild(child);
        else if (id.startsWith('connection-')) connectionsLayer.appendChild(child);
        else if (id.startsWith('label-')) labelsLayer.appendChild(child);
        else if (id === 'interaction-circle') interactionLayer.appendChild(child);
    });
    console.log('Migrated existing elements to layer groups');
}
/**
 * Initialize Bootstrap tooltips for floating buttons
 */ function $f7fca9471e720bd1$var$initializeTooltips() {
    // Check if Bootstrap is available
    if (typeof window.bootstrap === 'undefined') {
        console.error('Bootstrap is not loaded yet');
        return;
    }
    // Initialize tooltips for all elements with data-bs-toggle="tooltip"
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    console.log('Found tooltip elements:', tooltipTriggerList.length);
    tooltipTriggerList.forEach((tooltipTriggerEl)=>{
        console.log('Initializing tooltip for:', tooltipTriggerEl.id);
        try {
            new window.bootstrap.Tooltip(tooltipTriggerEl, {
                trigger: 'hover',
                container: 'body',
                html: false
            });
        } catch (error) {
            console.error('Error initializing tooltip for', tooltipTriggerEl.id, error);
        }
    });
}
/**
 * Initialize the Topology Builder application
 */ function $f7fca9471e720bd1$var$init() {
    // Initialize DOM references
    (0, $162Oa.initializeElements)();
    // Setup all event listeners
    (0, $c1c0c7dc7f537ac0$export$2e773a31cc80e22d)();
    (0, $564da1315aa2876b$export$33b7ddbdf2c41949)();
    (0, $1bdc8349b5a8317a$export$8ac0af29ee290079)();
    (0, $87579d676bc22961$export$b35ac6730b96dd26)();
    (0, $hkA3I.setupConnectionMode)();
    (0, $1cdEC.initializeShapeOverlay)();
    (0, $cgpVJ.initializeConnectionInteractions)();
    (0, $2cf8010633541100$export$709790fc8a5e8200)(); // Initialize sidebar panel state persistence
    (0, $84ef0419adada554$export$4924b4313410a96f)(); // Initialize alignment toolbar for multi-shape operations
    // Initialize selection mode
    const canvas = document.getElementById('topologyCanvas');
    const selectionMode = new (0, $b2b3075c112d628f$export$91484609d16ec765)(canvas);
    (0, $lwME4.appState).selectionManager = selectionMode; // Store reference in appState
    // Setup selection mode toggle button
    const toggleBtn = document.getElementById('toggleSelectionMode');
    if (toggleBtn) toggleBtn.addEventListener('click', ()=>{
        // Hide tooltip on click
        const tooltipInstance = window.bootstrap.Tooltip.getInstance(toggleBtn);
        if (tooltipInstance) tooltipInstance.hide();
        selectionMode.toggle();
    });
    // Initialize canvas
    (0, $7bd485089488656c$export$ac12f90bdc1d9b7)();
    // Initialize status bar
    (0, $198847b3bb70cf12$export$8ea63a1eb032cf80)();
    // Restore saved state (topology, zoom, scroll position)
    (0, $b18534792cfb37d0$export$32e2ba60a07f30a6)();
    // Migrate existing elements to layer groups (for backwards compatibility)
    $f7fca9471e720bd1$var$migrateToLayerGroups();
    // Migrate existing connections to have label IDs (for backwards compatibility)
    (0, $hkA3I.migrateExistingConnections)();
    // Initialize Bootstrap tooltips after everything is loaded
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(()=>{
        $f7fca9471e720bd1$var$initializeTooltips();
    }, 100);
    console.log('Topology Builder initialized');
}
// Start the application when DOM is loaded
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $f7fca9471e720bd1$var$init);
else $f7fca9471e720bd1$var$init();


//# sourceMappingURL=frontend.47aa7ee6.js.map
